import translationAutofill from "./translationAutofill.generated.mjs";

export const rawTranslations = {
  en: {
    // Navigation
    home: 'Home',
    tools: 'Tools',
    aiChat: 'Free AI Chat',
    aiToolsDirectory: 'AI Tools Directory',
    footballNews: 'Football News',
    programming: 'Programming',
    gaming: 'Gaming',
    gamesHub: 'IQ Games',
    menuToolsCategories: 'Tool Categories',
    menuSearchTools: 'Search inside menu...',
    menuImageTools: 'Image Tools',
    menuPdfTools: 'PDF Tools',
    menuCalculatorTools: 'Calculator Tools',
    menuTextTools: 'Text Tools',
    menuUtilityTools: 'Utility Tools',
    menuAiTools: 'AI Tools',
    menuAiGames: 'AI Games',
    menuExploreImageTools: 'Explore image tools',
    menuExplorePdfTools: 'Explore PDF tools',
    gamesHubTitle: 'IQ & Brain Training Games',
    gamesHubSubtitle: 'Play free memory, logic, reaction, and coding games to improve focus and keep your brain active.',
    seoGamesTitle: 'IQ Games Online | 3ToolsPro',
    seoGamesDesc: 'Play free IQ and brain training games online including memory, puzzle, reaction, and coding challenges. Mobile-friendly and fully browser-based.',
    gameWhatIsTitle: 'What is',
    gameHowToPlayTitle: 'How to play',
    gameSkillsTitle: 'Skills improved',
    gameBenefitsTitle: 'Benefits',
    gameFaqTitle: 'FAQ',
    gameRelatedTitle: 'Related tools & games',
    gameScore: 'Score',
    gameBest: 'Best',
    gameQuestion: 'Question',
    gameNextQuestion: 'Next question',
    difficultyEasy: 'Easy',
    difficultyMedium: 'Medium',
    difficultyHard: 'Hard',
    codeOutputTitle: 'Code Output Guess',
    codeOutputSubtitle: 'A developer brain game to sharpen JavaScript reasoning.',
    seoCodeOutputTitle: 'Code Output Guess Game | 3ToolsPro',
    seoCodeOutputDesc: 'Play a free coding IQ game and guess JavaScript output. Practice logic, debugging mindset, and time-saving developer intuition in your browser.',
    codeOutputWhatIs: 'Code Output Guess is a lightweight coding challenge for developers and learners. It trains fast analysis of syntax, scope, and runtime behavior.',
    codeOutputHow1: 'Choose a difficulty level.',
    codeOutputHow2: 'Read the JavaScript snippet carefully.',
    codeOutputHow3: 'Select the output you think is correct.',
    codeOutputHow4: 'Move to the next question and improve your score.',
    codeOutputSkill1: 'Debugging mindset',
    codeOutputSkill2: 'JavaScript fundamentals',
    codeOutputSkill3: 'Time complexity intuition',
    codeOutputBenefit1: 'Higher developer engagement',
    codeOutputBenefit2: 'Useful interview practice',
    codeOutputBenefit3: 'Quick daily learning habit',
    codeOutputFaq1Q: 'Are questions beginner-friendly?',
    codeOutputFaq1A: 'Yes. Easy mode is designed for foundational practice.',
    codeOutputFaq2Q: 'Is score saved?',
    codeOutputFaq2A: 'Best score is saved locally in your browser.',

    aiGameTopicLabel: 'Game topic (optional)',
    aiGameGenerate: 'Generate round',
    aiGameGenerating: 'Generating...',
    aiGameShare: 'Share result',
    aiGameCopied: 'Copied!',
    aiGameApiFallback: 'Live AI is temporarily unavailable, showing offline game content.',
    aiGameFeature1: 'Mobile-first gameplay with tap-friendly controls',
    aiGameFeature2: 'API-backed AI generation with offline fallback',
    aiGameFeature3: 'Shareable outputs for social traffic boosts',
    aiStoryAdventureTitle: 'AI Story Adventure',
    aiStoryAdventureSubtitle: 'Create magical branching story moments instantly with AI.',
    aiStoryAdventurePlaceholder: 'Example: lost city, space pirates, dragon school...',
    seoAiStoryAdventureTitle: 'AI Story Adventure Game | 3ToolsPro',
    seoAiStoryAdventureDesc: 'Play AI Story Adventure online with instant branching scenes, mobile-first UX, and shareable story rounds.',
    aiDungeonTitle: 'AI Dungeon',
    aiDungeonSubtitle: 'Generate dungeon turns and pick your action in every round.',
    aiDungeonPlaceholder: 'Example: cursed temple, lava cave, frozen castle...',
    seoAiDungeonTitle: 'AI Dungeon Game Online | 3ToolsPro',
    seoAiDungeonDesc: 'Enter an AI Dungeon challenge with dynamic turns, quick prompts, and social-ready gameplay snippets.',
    aiRiddleGeneratorTitle: 'AI Riddle Generator',
    aiRiddleGeneratorSubtitle: 'Produce clever riddles in seconds for fun challenges.',
    aiRiddleGeneratorPlaceholder: 'Example: animals, school, travel, food...',
    seoAiRiddleGeneratorTitle: 'AI Riddle Generator | 3ToolsPro',
    seoAiRiddleGeneratorDesc: 'Generate fun AI riddles instantly with answers, built for mobile players and shareable engagement.',
    aiGuessTheCharacterTitle: 'AI Guess The Character',
    aiGuessTheCharacterSubtitle: 'Get clue-based character challenges and test your friends.',
    aiGuessTheCharacterPlaceholder: 'Example: superhero, anime legend, movie icon...',
    seoAiGuessTheCharacterTitle: 'AI Guess The Character Game | 3ToolsPro',
    seoAiGuessTheCharacterDesc: 'Play AI Guess The Character with instant clues and shareable results for social engagement.',
    aiRoastMeTitle: 'AI Roast Me',
    aiRoastMeSubtitle: 'Generate playful roasts that stay light-hearted and funny.',
    aiRoastMePlaceholder: 'Example: my gamer friend, my coding team, me...',
    seoAiRoastMeTitle: 'AI Roast Me Game | 3ToolsPro',
    seoAiRoastMeDesc: 'Try AI Roast Me for hilarious, family-friendly jokes with one tap and easy sharing.',
    aiQuizGameTitle: 'AI Quiz Game',
    aiQuizGameSubtitle: 'Build quick quizzes on any topic and challenge your audience.',
    aiQuizGamePlaceholder: 'Example: football trivia, JavaScript basics, movies...',
    seoAiQuizGameTitle: 'AI Quiz Game Online | 3ToolsPro',
    seoAiQuizGameDesc: 'Create AI-powered quiz questions instantly with answer keys, mobile UX, and shareable output.',
    memoryGameTitle: 'Memory Cards Game',
    memoryGameSubtitle: 'Match all pairs in the fewest moves and beat your personal best score.',
    seoMemoryGameTitle: 'Memory Cards Game | 3ToolsPro',
    seoMemoryGameDesc: 'Play a free online memory cards game to train focus and short-term memory. Track your best score and improve concentration with this brain game.',
    memoryWhatIs: 'This lightweight brain game helps children and adults strengthen visual memory and concentration by matching symbol pairs.',
    memoryHow1: 'Tap one card to reveal it.',
    memoryHow2: 'Tap a second card to find a match.',
    memoryHow3: 'Keep matching pairs until the board is solved.',
    memoryHow4: 'Try to finish with fewer moves each round.',
    memorySkill1: 'Working memory',
    memorySkill2: 'Visual attention',
    memorySkill3: 'Pattern recognition',
    memoryBenefit1: 'Fast daily brain exercise',
    memoryBenefit2: 'Family-friendly gameplay',
    memoryBenefit3: 'No account or download required',
    memoryFaq1Q: 'Does this game save my best score?',
    memoryFaq1A: 'Yes, your best move count is stored in localStorage on this device.',
    memoryFaq2Q: 'Can kids play this game?',
    memoryFaq2A: 'Yes, it uses simple visuals and tap-friendly controls.',
    numberPuzzleTitle: 'Number Puzzle',
    numberPuzzleSubtitle: 'Slide tiles into the correct order from 1 to 8.',
    seoNumberPuzzleTitle: 'Number Puzzle Game | 3ToolsPro',
    seoNumberPuzzleDesc: 'Play a free 3x3 number puzzle game online. Improve problem-solving and logic skills, track best moves, and enjoy a fast browser challenge.',
    numberPuzzleSolved: 'Great job! Puzzle solved in {moves} moves.',
    numberPuzzleWhatIs: 'Number Puzzle is a classic logic game where you slide numbered tiles to restore the correct order.',
    numberPuzzleHow1: 'Tap a tile next to the empty space.',
    numberPuzzleHow2: 'Continue moving tiles one step at a time.',
    numberPuzzleHow3: 'Arrange numbers from 1 to 8 in order.',
    numberPuzzleHow4: 'Replay and improve your best score.',
    numberPuzzleSkill1: 'Problem solving',
    numberPuzzleSkill2: 'Planning ahead',
    numberPuzzleSkill3: 'Spatial reasoning',
    numberPuzzleBenefit1: 'Quick brain workout',
    numberPuzzleBenefit2: 'Improves patience and focus',
    numberPuzzleBenefit3: 'Works smoothly on mobile and desktop',
    numberPuzzleFaq1Q: 'Does this game require internet?',
    numberPuzzleFaq1A: 'No. Once loaded, gameplay is fully client-side.',
    numberPuzzleFaq2Q: 'Is best score saved?',
    numberPuzzleFaq2A: 'Yes, your best move count is saved in localStorage.',
    reactionTestTitle: 'Quick Reaction Test',
    reactionTestSubtitle: 'Measure your reflex speed and keep your best score.',
    seoReactionTestTitle: 'Quick Reaction Test | 3ToolsPro',
    seoReactionTestDesc: 'Test your reaction speed online for free. Track your best reflex score and improve focus with a lightweight browser game.',
    reactionWhatIs: 'Quick Reaction Test is a simple reflex game that measures how quickly you react to a visual signal.',
    reactionHow1: 'Press Start to arm the test.',
    reactionHow2: 'Wait until the panel turns green.',
    reactionHow3: 'Tap immediately when ready appears.',
    reactionHow4: 'Repeat and improve your best time.',
    reactionSkill1: 'Reflex speed',
    reactionSkill2: 'Visual focus',
    reactionSkill3: 'Response control',
    reactionBenefit1: 'Fast daily challenge',
    reactionBenefit2: 'Great for all ages',
    reactionBenefit3: 'No signup or install',
    reactionFaq1Q: 'What is a good reaction time?',
    reactionFaq1A: 'For many people, 200–300 ms is a strong result.',
    reactionFaq2Q: 'Can I use this on mobile?',
    reactionFaq2A: 'Yes, the game is optimized for mobile taps.',
    reactionInitialMessage: 'Tap start and wait for green',
    reactionWaitMessage: 'Wait for green...',
    reactionClickNow: 'Tap now!',
    reactionTooEarly: 'Too early! Tap start to try again.',
    reactionYourTime: 'Your time',
    reactionLatest: 'Latest result',
    gameStart: 'Start',
    gameTime: 'Time',
    gameMoves: 'Moves',
    gameRestart: 'Restart',
    selectLanguage: 'Select Language',
    more: 'More',
    resources: 'Resources',

    routeLoadingPage: 'Loading page...',
    appLoadingExperience: 'Loading experience...',
    categoryNotFound: 'Category not found',
    backToTools: 'Back to tools',
    categoryArticleLinkProductivity: 'Best free productivity tools',
    categoryArticleLinkContentSeo: 'How to improve content SEO',
    privacyLastUpdatedDate: 'January 2025',
    privacyThirdPartyGoogleAnalytics: 'Google Analytics',
    privacyThirdPartyGoogleAdsense: 'Google AdSense',
    ownerName: 'Eslam Mamdouh',
    contactEmailAddress: 'EslamMamdouh619@gmail.com',
    howToUseFaqTitle: 'FAQ',
    howToUseFaqSwitchLanguageQuestion: 'How do I switch language?',
    howToUseFaqSwitchLanguageAnswer: 'Use the globe icon in the navbar. The page direction and translated content update instantly.',
    howToUseFaqManageSettingsQuestion: 'How can I manage platform settings?',
    relatedToolsHeading: 'Related Tools',
    globalErrorTitle: 'Something went wrong',
    globalErrorDescription: 'We could not load this page safely. Please refresh and try again.',
    close: 'Close',
    ariaPagination: 'pagination',
    ariaGoToPreviousPage: 'Go to previous page',
    previous: 'Previous',
    ariaGoToNextPage: 'Go to next page',
    next: 'Next',
    paginationMorePages: 'More pages',
    ariaBreadcrumb: 'breadcrumb',
    ariaPreviousSlide: 'Previous slide',
    ariaNextSlide: 'Next slide',

    // Home Page
    heroTitle: 'Free Online Tools to Make Your Work Faster',
    heroSubtitle: 'Professional tools for everyday tasks. Fast, secure, and no registration required.',
    startUsing: 'Start Using Tools',
    ourTools: 'Our Tools',
    ourToolsSubtitle: 'All our tools are 100% free, work instantly in your browser, and require no registration.',
    allFree: '100% Free Forever',
    instantResults: 'Instant Results',
    noSignup: 'No signup required',
    freeAIChat: 'Free AI Chat',
    readSeoArticles: 'Read SEO Articles',
    scrollToTop: 'Scroll to top',
    scrollToBottom: 'Scroll to bottom',
    tableOfContents: 'Table of contents',
    topPicks: 'Top picks',
    popularPicks: 'Popular picks',
    topResources: 'Top resources',
    internalLinksBetterCrawlDepth: 'Internal links for better crawl depth',
    textContentTools: 'Text & Content tools',
    translationDashboardTitle: 'Translation Dashboard',
    translationDashboardSubtitle: 'Internal localization health and automation status.',
    noindex: 'Noindex',
    buildTimeAutomationOnly: 'Build-time automation only',
    aiRetryFallbackFlags: 'AI retry + fallback flags',
    loadingLocalizationStatus: 'Loading localization status...',
    language: 'Language',
    coverage: 'Coverage',
    missing: 'Missing',
    flagged: 'Flagged',
    indentLabel: 'Indent:',
    formattedJsonPlaceholder: 'Formatted JSON will appear here...',
    clickGeneratePassword: 'Click Generate to create password',
    passwordStrength: 'Password Strength',
    passwordLength: 'Password Length',
    allowDuplicateNumbers: 'Allow duplicate numbers',
    typeOrPasteTextHere: 'Type or paste your text here...',
    textOnePlaceholder: 'Text 1...',
    textTwoPlaceholder: 'Text 2...',
    fromLabel: 'From',
    enterValue: 'Enter value',
    toLabel: 'To',
    words: 'Words',
    characters: 'Characters',
    noSpaces: 'No Spaces',
    sentences: 'Sentences',
    paragraphs: 'Paragraphs',
    minRead: 'Min Read',
    startTypingOrPaste: 'Start typing or paste your text here...',
    width: 'Width',
    height: 'Height',
    rotateDegrees: 'Rotate degrees',
    processedOutput: 'Processed output',
    download: 'Download',
    runTool: 'Run Tool',
    output: 'Output',
    adminConfig: 'Admin Config',
    hiddenAdminConfig: 'Hidden Admin Config',
    password: 'Password',
    unlock: 'Unlock',
    editAndSaveConfig: 'Edit and save app-config compatible values. Sensitive keys are excluded.',
    saveJson: 'Save JSON',
    downloadJson: 'Download JSON',

    // Shared UI
    adLabel: 'Advertisement',
    adAreaAriaLabel: 'Sponsored content area',
    adPlaceholderLabel: 'Google AdSense Placement',
    adPlaceholderBetweenSections: 'In-content ad placement',
    visitSite: 'Visit Site',
    noSitesFound: 'No sites found',
    selectDifferentRegion: 'Try selecting a different region',
    aiServiceUnavailable: 'Service temporarily unavailable',
    aiUnexpectedError: 'Something went wrong. Please try again.',
    aiGenerate: 'Generate',
    aiGenerating: 'Generating...',
    aiCopyResult: 'Copy result',
    configAccessDesc: 'Edit /public/app-config.json to manage global settings, AI providers, language defaults, and tool visibility.',

    // Home Card Descriptions
    aiChatDesc: 'Chat with AI for free - Limited usage',
    aiToolsDesc: 'Discover the best AI tools for your needs',
    footballDesc: 'Latest football news from around the world',
    programmingDesc: 'Resources for developers and learners',
    gamingDesc: 'Best gaming platforms and resources',

    // Tools Page
    toolsPageTitle: 'Free Online Tools',
    toolsPageSubtitle: 'Professional tools for everyday tasks. Fast, secure, and no registration required.',

    // Tool Categories
    categoryAll: 'All',
    categoryTextContent: 'Text & Content',
    categoryDeveloper: 'Developer',
    categoryUtility: 'Utility',

    // Tool Names
    toolWordCounter: 'Word Counter',
    toolTextCaseConverter: 'Text Case Converter',
    toolTextCompare: 'Text Compare',
    toolLoremIpsum: 'Lorem Ipsum Generator',
    toolJSONFormatter: 'JSON Formatter',
    toolBase64Encoder: 'Base64 Encoder/Decoder',
    toolURLEncoder: 'URL Encoder/Decoder',
    toolPasswordGenerator: 'Password Generator',
    toolRandomNumber: 'Random Number Generator',
    toolAgeCalculator: 'Age Calculator',
    toolAgeCalculatorSubtitle: 'Find your exact age in years, months, and days.',
    toolAgeEnterDate: 'Enter your birth date',
    toolAgeCalculate: 'Calculate age',
    toolAgeYourAge: 'Your age',
    years: 'years',
    months: 'months',
    and: 'and',
    days: 'days',
    totalMonths: 'Total months',
    totalWeeks: 'Total weeks',
    totalDays: 'Total days',
    totalHours: 'Total hours',
    totalMinutes: 'Total minutes',
    daysToBirthday: 'Days to next birthday',
    nextBirthday: 'Next birthday',
    toolUnitConverter: 'Unit Converter',
    toolWheelOfFortune: 'Wheel of Fortune',
    toolWheelOfFortuneDesc: 'Spin a customizable wheel to pick a random food or item',
    toolTranslationTool: 'Real-time Translation Tool',
    toolTranslationToolDesc: 'Translate text with auto-detect, live results, and quick copy',

    // Search & Translation
    search: 'Search',
    homeSearchPlaceholder: 'Search tools, AI tools, blog, and categories...',
    searchResultsTitle: 'Search results',
    searchResultsDescription: 'Find tools, AI services, and content across 3ToolsPro.',
    searchShowingFor: 'Showing results for "{query}"',
    searchTypeToStart: 'Type a keyword in the homepage search bar to start.',
    searchNoResults: 'No matching results. Try different keywords.',
    searchInputPlaceholder: 'Search tools, AI tools, articles, and categories...',
    searchSeeAllResults: 'See all results',
    searchTypeTool: 'Tool',
    searchTypeAiTool: 'AI Tool',
    searchTypeArticle: 'Article',
    searchTypeCategory: 'Category',
    category: 'Category',
    level: 'Level',
    searchTypeAny: 'Result',
    searchTypeLabelTool: 'Tool',
    searchTypeLabelAi: 'AI Tool',
    searchTypeLabelBlog: 'Article',
    searchTypeLabelCategory: 'Category',
    copyResult: 'Copy result',
    translationTitle: 'Real-time Translation Tool',
    translationSubtitle: 'Translate content instantly with auto-detect, language swap, and mobile-first UX for writers, bloggers, and professionals.',
    translationFrom: 'From language',
    translationTo: 'To language',
    translationSwap: 'Swap languages',
    translationInputPlaceholder: 'Type or paste text to translate...',
    translationOutputPlaceholder: 'Translation appears here instantly...',
    translationError: 'Translation is temporarily unavailable. Please try again in a moment.',
    translationArticleTitle: 'Why use this translation tool?',
    translationArticleP1: 'This tool is built for creators, bloggers, marketers, and students who need fast multilingual writing support without complex setup.',
    translationArticleP2: 'It supports live translation with debounce, copy-ready output, local session persistence, and a responsive design that works smoothly on mobile.',
    translationFaqTitle: 'Translation FAQ',
    translationFaqQ1: 'Does it auto-detect language?',
    translationFaqA1: 'Yes. Keep source language on Auto Detect and the tool will detect the input language automatically.',
    translationHow1: 'Choose source and target languages.',
    translationHow2: 'Type your text and wait for live translation.',
    translationHow3: 'Copy translated output or swap directions instantly.',
    translationBenefitsTitle: 'Benefits',
    translationBenefit1: 'Fast live translation with debounced input.',
    translationBenefit2: 'Mobile-first interface designed for readability.',
    translationBenefit3: 'Session persistence keeps your last input locally.',
    translationFaqQ2: 'Is my text stored on this website?',
    translationFaqA2: 'Only your last session is saved in localStorage on your device for better UX.',
    seoTranslationToolTitle: 'Real-time Translation Tool Online | 3ToolsPro',
    seoTranslationToolDesc: 'Translate text online with auto-detect, instant updates, language swap, and copy output. Mobile-optimized translation for creators and writers.',

    // AI Chat Status
    connectionStatus: 'Status',
    aiStatusOnline: 'Online',
    aiStatusOffline: 'Offline mode',
    aiLocalModeNotice: 'The AI service is currently unavailable, so you are using offline responses.',
    openChatGPT: 'Open ChatGPT',
    aiLocalResponse1: 'I am offline right now, but I can still help. Try refining your question or ask for a quick outline.',
    aiLocalResponse2: 'Here is a quick suggestion: break the task into steps and start with the most important part.',
    aiLocalResponse3: 'If you need detailed results, try again later. For now, I can provide a brief summary or checklist.',

    // Wheel of Fortune UI
    wheelTitle: 'Wheel of Fortune (Food Picker)',
    wheelSubtitle: 'Add options, spin the wheel, and get a random pick instantly.',
    wheelSpin: 'Spin the Wheel',
    wheelSpinning: 'Spinning...',
    wheelResultLabel: 'Selected result',
    wheelResultPlaceholder: 'Add items and spin to choose',
    wheelManageTitle: 'Manage your items',
    wheelManageSubtitle: 'Add foods or options and keep them saved on this device.',
    wheelInputPlaceholder: 'Type a food or item',
    wheelAdd: 'Add',
    wheelEmpty: 'No items yet. Add at least two to spin.',
    wheelRemove: 'Remove',
    wheelReset: 'Reset list',

    // Tool Content - Age Calculator
    toolAgeWhatTitle: 'What is the Age Calculator?',
    toolAgeWhatDesc: 'The Age Calculator helps you find your exact age and key milestones from a birth date.',
    toolAgeHowTitle: 'How to use the Age Calculator',
    toolAgeHow1: 'Select your birth date.',
    toolAgeHow2: 'Click calculate to view your age details.',
    toolAgeHow3: 'Review totals like days, months, and next birthday.',
    toolAgeBenefitsTitle: 'Benefits',
    toolAgeBenefit1: 'Get accurate age details instantly.',
    toolAgeBenefit2: 'See useful totals like days and months.',
    toolAgeBenefit3: 'Everything runs locally for privacy.',
    toolAgeFaqTitle: 'FAQ',
    toolAgeFaq1Q: 'Is the calculation accurate?',
    toolAgeFaq1A: 'Yes, it uses your local device date and time for precise results.',
    toolAgeFaq2Q: 'Is my date stored anywhere?',
    toolAgeFaq2A: 'No. All calculations happen in your browser.',

    // Tool Content - Base64
    toolBase64WhatTitle: 'What is the Base64 Encoder/Decoder?',
    toolBase64WhatDesc: 'This tool converts text to and from Base64 for safe transfer and testing.',
    toolBase64HowTitle: 'How to use the Base64 tool',
    toolBase64How1: 'Choose encode or decode mode.',
    toolBase64How2: 'Paste your text or Base64 string.',
    toolBase64How3: 'Click process and copy the result.',
    toolBase64BenefitsTitle: 'Benefits',
    toolBase64Benefit1: 'Quickly convert data without uploads.',
    toolBase64Benefit2: 'Helpful for development and debugging.',
    toolBase64Benefit3: 'Runs entirely in your browser.',
    toolBase64FaqTitle: 'FAQ',
    toolBase64Faq1Q: 'Is Base64 encryption?',
    toolBase64Faq1A: 'No, Base64 is an encoding format and can be reversed easily.',
    toolBase64Faq2Q: 'Does the tool store my data?',
    toolBase64Faq2A: 'No. Your data stays on your device.',

    // Tool Content - JSON Formatter
    toolJsonWhatTitle: 'What is the JSON Formatter?',
    toolJsonWhatDesc: 'Format, validate, and minify JSON with clear output and instant errors.',
    toolJsonHowTitle: 'How to use the JSON Formatter',
    toolJsonHow1: 'Paste JSON into the input box.',
    toolJsonHow2: 'Choose format, minify, or validate.',
    toolJsonHow3: 'Copy the output when ready.',
    toolJsonBenefitsTitle: 'Benefits',
    toolJsonBenefit1: 'Improve readability for debugging.',
    toolJsonBenefit2: 'Catch errors fast with validation.',
    toolJsonBenefit3: 'Minify JSON for production use.',
    toolJsonFaqTitle: 'FAQ',
    toolJsonFaq1Q: 'Does it support arrays?',
    toolJsonFaq1A: 'Yes, arrays and objects are supported.',
    toolJsonFaq2Q: 'Is my data sent to a server?',
    toolJsonFaq2A: 'No, everything runs in your browser.',

    // Tool Content - Lorem Ipsum
    toolLoremWhatTitle: 'What is the Lorem Ipsum Generator?',
    toolLoremWhatDesc: 'Generate placeholder text to fill layouts, mockups, and design drafts.',
    toolLoremHowTitle: 'How to use the Lorem Ipsum Generator',
    toolLoremHow1: 'Select paragraphs and words per paragraph.',
    toolLoremHow2: 'Choose whether to start with “Lorem”.',
    toolLoremHow3: 'Click generate and copy the output.',
    toolLoremBenefitsTitle: 'Benefits',
    toolLoremBenefit1: 'Create realistic layout filler quickly.',
    toolLoremBenefit2: 'Customize length for any project.',
    toolLoremBenefit3: 'No downloads or sign-ups required.',
    toolLoremFaqTitle: 'FAQ',
    toolLoremFaq1Q: 'Can I change the length?',
    toolLoremFaq1A: 'Yes, you can control paragraphs and word count.',
    toolLoremFaq2Q: 'Is the text copyright-free?',
    toolLoremFaq2A: 'Yes, it is standard placeholder text.',

    // Tool Content - Password Generator
    toolPasswordWhatTitle: 'What is the Password Generator?',
    toolPasswordWhatDesc: 'Create strong passwords with custom length and character options.',
    toolPasswordHowTitle: 'How to use the Password Generator',
    toolPasswordHow1: 'Adjust length and character settings.',
    toolPasswordHow2: 'Click generate to create a password.',
    toolPasswordHow3: 'Copy the password for use.',
    toolPasswordBenefitsTitle: 'Benefits',
    toolPasswordBenefit1: 'Create secure passwords instantly.',
    toolPasswordBenefit2: 'Customize strength based on needs.',
    toolPasswordBenefit3: 'Generated locally for privacy.',
    toolPasswordFaqTitle: 'FAQ',
    toolPasswordFaq1Q: 'Are passwords stored?',
    toolPasswordFaq1A: 'No, passwords are generated locally and never saved.',
    toolPasswordFaq2Q: 'How long should passwords be?',
    toolPasswordFaq2A: 'We recommend 12+ characters for strong security.',

    // Tool Content - Random Number
    toolRandomWhatTitle: 'What is the Random Number Generator?',
    toolRandomWhatDesc: 'Generate random numbers within a custom range for games, testing, or selection.',
    toolRandomHowTitle: 'How to use the Random Number Generator',
    toolRandomHow1: 'Set your minimum and maximum range.',
    toolRandomHow2: 'Choose how many numbers to generate.',
    toolRandomHow3: 'Click generate and copy the results.',
    toolRandomBenefitsTitle: 'Benefits',
    toolRandomBenefit1: 'Quick random picks for any task.',
    toolRandomBenefit2: 'Support for unique or duplicate results.',
    toolRandomBenefit3: 'Works instantly in your browser.',
    toolRandomFaqTitle: 'FAQ',
    toolRandomFaq1Q: 'Can I avoid duplicates?',
    toolRandomFaq1A: 'Yes, disable duplicates to get unique numbers.',
    toolRandomFaq2Q: 'How many numbers can I generate?',
    toolRandomFaq2A: 'Up to 100 numbers per run.',

    // Tool Content - Text Case Converter
    toolCaseWhatTitle: 'What is the Text Case Converter?',
    toolCaseWhatDesc: 'Convert text into different cases for writing, formatting, and coding.',
    toolCaseHowTitle: 'How to use the Text Case Converter',
    toolCaseHow1: 'Paste or type your text.',
    toolCaseHow2: 'Select the case you want to apply.',
    toolCaseHow3: 'Copy the updated text.',
    toolCaseBenefitsTitle: 'Benefits',
    toolCaseBenefit1: 'Instantly standardize text formatting.',
    toolCaseBenefit2: 'Useful for titles, headings, and code.',
    toolCaseBenefit3: 'No data leaves your browser.',
    toolCaseFaqTitle: 'FAQ',
    toolCaseFaq1Q: 'Can I convert large text?',
    toolCaseFaq1A: 'Yes, large blocks of text are supported.',
    toolCaseFaq2Q: 'Does it keep punctuation?',
    toolCaseFaq2A: 'Yes, punctuation remains unchanged.',

    // Tool Content - Text Compare
    toolCompareWhatTitle: 'What is the Text Compare tool?',
    toolCompareWhatDesc: 'Compare two texts line by line to find changes, additions, and deletions.',
    toolCompareHowTitle: 'How to use the Text Compare tool',
    toolCompareHow1: 'Paste the original text in the first box.',
    toolCompareHow2: 'Paste the modified text in the second box.',
    toolCompareHow3: 'Click compare to view differences.',
    toolCompareBenefitsTitle: 'Benefits',
    toolCompareBenefit1: 'Spot changes quickly during reviews.',
    toolCompareBenefit2: 'Clear highlights for edits and updates.',
    toolCompareBenefit3: 'Ideal for writers and developers.',
    toolCompareFaqTitle: 'FAQ',
    toolCompareFaq1Q: 'Does it compare by line?',
    toolCompareFaq1A: 'Yes, it compares text line by line.',
    toolCompareFaq2Q: 'Is my text stored?',
    toolCompareFaq2A: 'No, comparisons run locally.',

    // Tool Content - URL Encoder
    toolUrlWhatTitle: 'What is the URL Encoder/Decoder?',
    toolUrlWhatDesc: 'Encode or decode URLs to safely handle special characters in web links.',
    toolUrlHowTitle: 'How to use the URL Encoder',
    toolUrlHow1: 'Select encode or decode mode.',
    toolUrlHow2: 'Paste your URL or text.',
    toolUrlHow3: 'Click process and copy the result.',
    toolUrlBenefitsTitle: 'Benefits',
    toolUrlBenefit1: 'Avoid broken links in web forms.',
    toolUrlBenefit2: 'Great for APIs and query strings.',
    toolUrlBenefit3: 'Fast, browser-based processing.',
    toolUrlFaqTitle: 'FAQ',
    toolUrlFaq1Q: 'What characters are encoded?',
    toolUrlFaq1A: 'Spaces and special characters are converted to safe codes.',
    toolUrlFaq2Q: 'Does it support full URLs?',
    toolUrlFaq2A: 'Yes, it works with full URLs and query strings.',

    // Tool Content - Unit Converter
    toolUnitWhatTitle: 'What is the Unit Converter?',
    toolUnitWhatDesc: 'Convert between common units for length, weight, temperature, volume, and time.',
    toolUnitHowTitle: 'How to use the Unit Converter',
    toolUnitHow1: 'Choose a category like length or temperature.',
    toolUnitHow2: 'Select the units to convert.',
    toolUnitHow3: 'Enter a value to see results instantly.',
    toolUnitBenefitsTitle: 'Benefits',
    toolUnitBenefit1: 'Accurate conversions in seconds.',
    toolUnitBenefit2: 'Supports multiple categories.',
    toolUnitBenefit3: 'Easy to use on any device.',
    toolUnitFaqTitle: 'FAQ',
    toolUnitFaq1Q: 'Which units are supported?',
    toolUnitFaq1A: 'Length, weight, temperature, volume, and time.',
    toolUnitFaq2Q: 'Is the conversion accurate?',
    toolUnitFaq2A: 'Yes, standard conversion factors are used.',

    // Tool Content - Wheel of Fortune
    wheelWhatTitle: 'What is the Wheel of Fortune tool?',
    wheelWhatDesc: 'A fun, interactive picker that helps you decide by spinning a customizable wheel.',
    wheelHowTitle: 'How to use the Wheel of Fortune',
    wheelHow1: 'Add foods or items to your list.',
    wheelHow2: 'Click spin to animate the wheel.',
    wheelHow3: 'View the selected result instantly.',
    wheelBenefitsTitle: 'Benefits',
    wheelBenefit1: 'Great for quick decisions and group picks.',
    wheelBenefit2: 'Items are saved locally on your device.',
    wheelBenefit3: 'Works smoothly on mobile and desktop.',
    wheelFaqTitle: 'FAQ',
    wheelFaq1Q: 'Are my items saved?',
    wheelFaq1A: 'Yes, items are stored in localStorage on your device.',
    wheelFaq2Q: 'Can I reset the list?',
    wheelFaq2A: 'Yes, use the reset button to clear all items.',

    // Tools Features
    featureFast: 'Lightning Fast',
    featureFastDesc: 'All tools run directly in your browser for instant results',
    featureSecure: '100% Secure',
    featureSecureDesc: 'Your data never leaves your device - complete privacy',
    featureFree: 'Completely Free',
    featureFreeDesc: 'No signups, no limits, no hidden costs - forever free',

    // AI Chat
    freeAIChatTitle: 'Free AI Chat',
    freeAIChatSubtitle: 'Chat with AI Assistant',
    fairUsagePolicy: 'Free AI Chat – Fair usage policy',
    disclaimer: 'Disclaimer',
    aiDisclaimer: 'This is a free AI chat for engagement purposes. Responses are generated by an AI model and may not always be accurate. This service has usage limits to ensure fair access for all users. For unlimited professional AI chat, consider premium services like ChatGPT, Claude, or Gemini.',
    startConversation: 'Start a conversation! Ask me anything.',
    exampleQuestions: 'Try: "Tell me a joke" or "What is artificial intelligence?"',
    aiThinking: 'AI is thinking...',
    typePlaceholder: 'Type your message...',
    sendMessage: 'Send message',
    pressEnter: 'Press Enter to send',
    freeServiceNotice: 'Free service with fair usage limits',
    aboutFreeAIChat: 'About Free AI Chat',
    poweredByHF: 'Powered by Hugging Face - Free and open-source AI',
    refreshToReset: 'Refresh page to start a new conversation',
    responsesDelay: 'Responses typically arrive within 3-5 seconds',
    engagementOnly: 'This chat is for engagement and learning purposes',
    unlimitedAI: 'For unlimited professional AI chat: ChatGPT, Claude, or Gemini',
    aiNoResponse: 'Sorry, I could not generate a response. Please try again.',
    aiFallbackMessage: 'I apologize, but I\'m having trouble connecting right now. The free AI service may be experiencing high demand. Please try again in a moment or refresh the page.',

    // AI Tools Page
    aiToolsTitle: 'AI Tools Directory',
    aiToolsSubtitle: 'Discover the best AI tools for your needs',
    searchPlaceholder: 'What do you want to do? (e.g., create a logo, write an article)',
    aiFinderNav: 'AI Finder',
    aiFinderTitle: 'AI Tool Finder',
    aiFinderSubtitle: 'Describe your task and get ranked AI tool recommendations instantly.',
    aiFinderSeoTitle: 'AI Finder: Smart AI Tool Recommendations | 3ToolsPro',
    aiFinderSeoDescription: 'Find the best AI tools for chat, coding, image generation, writing, video, and more with weighted relevance ranking.',
    aiFinderLiveRanking: 'Live relevance ranking',
    aiFinderSearchAriaLabel: 'Describe what you want to do',
    aiFinderCategoryAriaLabel: 'Filter tools by category',
    aiFinderSearchPlaceholder: 'Describe your goal (e.g., write a blog post, generate product video)',
    aiFinderKeywordsDetected: 'Detected keywords',
    aiFinderNone: 'none',
    aiFinderLoading: 'Loading AI tools...',
    aiFinderLoadError: 'Unable to load tool recommendations right now. Please try again.',
    aiFinderNoResults: 'No matching tools found. Try another keyword or category.',
    aiFinderLoadMore: 'Load more recommendations',
    aiFinderCategoryAll: 'All categories',
    aiFinderCategoryChat: 'Chat',
    aiFinderCategoryImage: 'Image',
    aiFinderCategoryCoding: 'Coding',
    aiFinderCategoryWriting: 'Writing',
    aiFinderCategoryVideo: 'Video',
    aiFinderCategoryAudio: 'Audio',
    aiFinderCategoryProductivity: 'Productivity',
    aiFinderCategoryResearch: 'Research',
    allCategories: 'All Categories',
    visitTool: 'Visit Tool',
    free: 'Free',
    foundToolsFor: 'Found {count} tools for "{query}"',
    noAIToolsFound: 'No AI tools found',
    adjustSearchFilter: 'Try adjusting your search or category filter',

    // Football
    footballTitle: 'Football News Websites',
    footballSubtitle: 'Stay updated with the latest football news from around the world',

    // Programming
    programmingTitle: 'Programming & Development Resources',
    programmingSubtitle: 'Learn, build, and grow as a developer',

    // Gaming
    gamingTitle: 'Gaming Websites',
    gamingSubtitle: 'Discover the best gaming platforms and resources',

    // SEO
    seoHomeTitle: '3ToolsPro | Free Online Tools for Everyday Tasks',
    seoHomeDesc: 'Discover fast, secure, and free online tools for text, developer, and utility tasks. No sign-up required, built for professional results.',
    seoToolsTitle: 'Online Tools Library | 3ToolsPro',
    seoToolsDesc: 'Browse a curated library of free online tools for productivity, text, developer, and utility needs. Fast, secure, and ready to use instantly.',
    seoAiChatTitle: 'Free AI Chat (Fair Use) | 3ToolsPro',
    seoAiChatDesc: 'Chat with a free AI assistant for quick answers, drafts, and ideas. Fair-use limits keep access available for everyone on 3ToolsPro.',
    seoAiToolsTitle: 'AI Tools Directory | 3ToolsPro',
    seoAiToolsDesc: 'Explore vetted AI tools for writing, images, video, and productivity with clear summaries, categories, and direct links.',
    seoFootballTitle: 'Football News Sources | 3ToolsPro',
    seoFootballDesc: 'Find trusted football news websites from around the world and stay updated on leagues, transfers, and match coverage.',
    seoProgrammingTitle: 'Programming Resources | 3ToolsPro',
    seoProgrammingDesc: 'Discover programming resources, documentation, tools, and learning links curated for beginners and experienced developers.',
    seoGamingTitle: 'Gaming Resources | 3ToolsPro',
    seoGamingDesc: 'Explore gaming platforms, downloads, news, and community resources in one professional directory.',
    seoAboutTitle: 'About 3ToolsPro | Free Online Tools',
    seoAboutDesc: 'Learn about 3ToolsPro, our mission to provide free online tools, and how we build fast, private, and reliable services.',
    seoContactTitle: 'Contact 3ToolsPro | Support & Feedback',
    seoContactDesc: 'Contact the 3ToolsPro team for support, feedback, or partnership inquiries. We respond quickly and value user input.',
    seoHowToUseTitle: 'How to Use 3ToolsPro | Quick Guide',
    seoHowToUseDesc: 'Follow a simple, step-by-step guide to use 3ToolsPro tools effectively and get professional results every time.',
    seoPrivacyTitle: 'Privacy Policy | 3ToolsPro',
    seoPrivacyDesc: 'Read how 3ToolsPro handles data, privacy, and security, including analytics, cookies, and user rights.',
    seoTermsTitle: 'Terms of Service | 3ToolsPro',
    seoTermsDesc: 'Review the terms of service for using 3ToolsPro, including acceptable use, limitations, and updates.',
    seoWordCounterTitle: 'Word Counter | 3ToolsPro',
    seoWordCounterDesc: 'Count words, characters, sentences, and paragraphs instantly. Perfect for writers, students, and SEO checks with private, in-browser analysis.',
    seoTextCaseTitle: 'Text Case Converter | 3ToolsPro',
    seoTextCaseDesc: 'Convert text to uppercase, lowercase, title case, sentence case, and more. Fast, accurate formatting for writing and coding tasks.',
    seoTextCompareTitle: 'Text Compare Tool | 3ToolsPro',
    seoTextCompareDesc: 'Compare two texts line by line to find additions, deletions, and changes. Ideal for editing, reviews, and content checks.',
    seoLoremIpsumTitle: 'Lorem Ipsum Generator | 3ToolsPro',
    seoLoremIpsumDesc: 'Generate customizable Lorem Ipsum placeholder text by paragraphs or words. Useful for mockups, layouts, and design drafts.',
    seoJsonFormatterTitle: 'JSON Formatter | 3ToolsPro',
    seoJsonFormatterDesc: 'Format, validate, and minify JSON with readable output and instant errors. Perfect for developers and data cleanup.',
    seoBase64Title: 'Base64 Encoder/Decoder | 3ToolsPro',
    seoBase64Desc: 'Encode or decode Base64 strings safely in your browser. Great for data transfer, testing, and development workflows.',
    seoUrlEncoderTitle: 'URL Encoder/Decoder | 3ToolsPro',
    seoUrlEncoderDesc: 'Encode or decode URLs to handle spaces and special characters correctly. Helpful for web forms, APIs, and debugging.',
    seoPasswordGeneratorTitle: 'Password Generator | 3ToolsPro',
    seoPasswordGeneratorDesc: 'Create strong, secure passwords with customizable length and character options. Generated locally for privacy.',
    seoRandomNumberTitle: 'Random Number Generator | 3ToolsPro',
    seoRandomNumberDesc: 'Generate random numbers within a range, with optional unique results. Useful for games, testing, and quick picks.',
    seoAgeCalculatorTitle: 'Age Calculator | 3ToolsPro',
    seoAgeCalculatorDesc: 'Calculate your exact age with detailed statistics, including months, days, and next birthday. Fast and private.',
    seoUnitConverterTitle: 'Unit Converter | 3ToolsPro',
    seoUnitConverterDesc: 'Convert length, weight, temperature, volume, and time units instantly with accurate results and an easy interface.',
    seoWheelTitle: 'Wheel of Fortune Picker | 3ToolsPro',
    seoWheelDesc: 'Spin a customizable wheel to pick food or any item. Save your list locally and get instant results on any device.',

    // Footer
    footerTagline: 'Professional free online tools for everyone',
    footerCopyright: '© 2025 3ToolsPro. All rights reserved.',
    quickLinks: 'Quick Links',
    legalInfo: 'Legal & Info',

    // Common
    copy: 'Copy',
    copied: 'Copied!',
    clear: 'Clear',
    generate: 'Generate',
    encode: 'Encode',
    decode: 'Decode',
    format: 'Format',
    validate: 'Validate',
    compare: 'Compare',
    calculate: 'Calculate',
    owner: 'Owner',
    email: 'Email',
    supportEmail: 'Support Email',

    // About Page
    aboutUs: 'About Us',
    aboutSubtitle: 'Learn more about 3ToolsPro and our mission',
    ourMission: 'Our Mission',
    missionText: '3ToolsPro was created to provide free, high-quality online tools that make everyday tasks easier. We believe that powerful productivity tools should be accessible to everyone, without paywalls or complicated sign-ups.',
    missionText2: 'Our platform offers a growing collection of free tools for text processing, data conversion, security, calculations, and AI-powered assistance. All tools run directly in your browser, ensuring your data stays private and secure.',
    whatWeOffer: 'What We Offer',
    offer1: 'Free text tools: Word counter, case converter, text comparison, and more',
    offer2: 'Data conversion tools: JSON formatter, Base64 encoder, URL encoder',
    offer3: 'Security tools: Password generator with customizable options',
    offer4: 'AI-powered chat for quick answers and learning',
    offer5: 'Curated directory of the best AI tools, programming resources, and more',
    contactInfo: 'Contact Information',

    // Contact Page
    contactUs: 'Contact Us',
    contactSubtitle: 'Get in touch with us - we\'d love to hear from you',
    socialMedia: 'Connect on Social Media',
    needHelp: 'Need Help?',
    contactText: 'If you have any questions, suggestions, or feedback about our tools, please don\'t hesitate to reach out. We typically respond within 24-48 hours.',

    // Privacy Policy
    privacyPolicy: 'Privacy Policy',
    lastUpdated: 'Last Updated',
    introduction: 'Introduction',
    privacyIntro: 'At 3ToolsPro, we take your privacy seriously. This Privacy Policy explains how we collect, use, and protect your information when you use our website and tools. By using our services, you agree to the collection and use of information in accordance with this policy.',
    dataCollection: 'Information We Collect',
    dataCollectionText: 'We collect minimal information to provide and improve our services:',
    dataItem1: 'Usage data: Pages visited, tools used, and interaction patterns (via Google Analytics)',
    dataItem2: 'Device information: Browser type, operating system, and screen resolution',
    dataItem3: 'IP address: For security and analytics purposes (anonymized)',
    howWeUseData: 'How We Use Your Information',
    useItem1: 'To provide and maintain our free tools and services',
    useItem2: 'To analyze usage patterns and improve user experience',
    useItem3: 'To display relevant advertisements through Google AdSense',
    cookies: 'Cookies',
    cookiesText: 'We use cookies to enhance your experience on our site. Cookies help us remember your preferences (like language settings) and provide analytics data. You can disable cookies in your browser settings, but some features may not work properly.',
    thirdParty: 'Third-Party Services',
    thirdPartyText: 'We use the following third-party services that may collect information:',
    dataSecurity: 'Data Security',
    dataSecurityText: 'All tools on 3ToolsPro run directly in your browser. Your data is processed locally and is not sent to our servers. We do not store any content you enter into our tools. We implement appropriate security measures to protect against unauthorized access.',
    yourRights: 'Your Rights',
    right1: 'Access: You can request information about the data we collect',
    right2: 'Deletion: You can request deletion of any personal data',
    right3: 'Opt-out: You can opt-out of analytics tracking using browser extensions',
    privacyContactText: 'If you have any questions about this Privacy Policy, please contact us:',

    // Terms of Service
    termsOfService: 'Terms of Service',
    acceptanceOfTerms: 'Acceptance of Terms',
    acceptanceText: 'By accessing and using 3ToolsPro, you accept and agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.',
    useOfService: 'Use of Service',
    useOfServiceText: 'Our tools are provided free of charge for personal and commercial use, subject to the following conditions:',
    serviceRule1: 'You may use our tools for any lawful purpose',
    serviceRule2: 'You must not attempt to reverse engineer or copy our tools',
    serviceRule3: 'You must not use our services to engage in any illegal activities',
    serviceRule4: 'You must not attempt to overload or disrupt our services',
    intellectualProperty: 'Intellectual Property',
    intellectualPropertyText: 'All content, design, and code on 3ToolsPro is protected by intellectual property laws. You may not reproduce, distribute, or create derivative works without our express permission.',
    userContent: 'User Content',
    userContentText: 'Any data you input into our tools is processed locally in your browser and is not stored on our servers. You retain all rights to your content. We do not claim ownership of any content you process using our tools.',
    disclaimerText: 'Our tools are provided "as is" without any warranties, express or implied. We do not guarantee that our tools will be error-free, uninterrupted, or fit for any particular purpose.',
    disclaimerWarning: 'USE AT YOUR OWN RISK. We are not responsible for any data loss, damages, or issues arising from the use of our tools.',
    limitationOfLiability: 'Limitation of Liability',
    limitationText: 'To the maximum extent permitted by law, 3ToolsPro and its owner shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our services.',
    modifications: 'Modifications to Terms',
    modificationsText: 'We reserve the right to modify these Terms of Service at any time. Changes will be effective immediately upon posting. Your continued use of our services after any changes constitutes acceptance of the new terms.',
    governingLaw: 'Governing Law',
    governingLawText: 'These Terms shall be governed by and construed in accordance with the laws of Egypt. Any disputes shall be resolved in the courts of Egypt.',
    termsContactText: 'If you have any questions about these Terms of Service, please contact us:',

    // How To Use Page
    howToUse: 'How to Use',
    howToUseSubtitle: 'Get started with 3ToolsPro - it\'s easy and free!',
    step1Title: 'Step 1: Choose Your Tool',
    step1Text: 'Browse our collection of free tools from the Tools page or home page. We offer:',
    step1Item1: 'Text tools: Word counter, case converter, text comparison',
    step1Item2: 'Data tools: JSON formatter, Base64 encoder, URL encoder',
    step1Item3: 'Utility tools: Password generator, age calculator, unit converter',
    step2Title: 'Step 2: Use the Tool',
    step2Text: 'Each tool is simple to use with a clean interface:',
    step2Item1: 'Enter or paste your data in the input area',
    step2Item2: 'Click the action button (Convert, Generate, Format, etc.)',
    step2Item3: 'View your results instantly - no waiting!',
    step3Title: 'Step 3: Copy or Use Your Results',
    step3Text: 'Once you have your results:',
    step3Item1: 'Click the "Copy" button to copy to clipboard',
    step3Item2: 'Download results when available',
    step3Item3: 'Clear and start again with new data',
    step4Title: 'Step 4: Explore More',
    step4Text: 'Check out our AI Tools Directory to discover powerful AI services, browse our curated resources for Football News, Programming, and Gaming. Try our Free AI Chat for quick questions and learning!',
    helpText: 'If you need any help or have suggestions for new tools, feel free to contact us:',

    aiToolsPhase3Subtitle: 'Generate captions, stories, chats, images, and quizzes with secure server-side API routing and mobile-first design.',
    aiToolsPhase4Subtitle: 'Production-ready AI text, image, chat, and game tools with retries, status messaging, and local history.',
    aiToolsCountLabel: 'tools',
    aiCommonError: 'Something went wrong while contacting AI service. Please try again.',
    aiCategoryTextTools: 'AI Text Tools',
    aiCategoryImageTools: 'AI Image Tools',
    aiCategoryChatTools: 'AI Chat Tools',
    aiCategoryGames: 'AI Games',
    aiCaptionGeneratorTitle: 'AI Instagram Caption Generator',
    aiCaptionGeneratorDesc: 'Create social-ready captions with emojis and hashtags.',
    aiCaptionInput: 'Example: Summer coffee reel for my cafe',
    aiStoryGeneratorTitle: 'AI Story Generator',
    aiStoryGeneratorDesc: 'Generate a short creative story from one prompt.',
    aiStoryInput: 'Example: A robot that opens a bakery in Cairo',
    aiChatbotTitle: 'AI Chatbot',
    aiChatbotDesc: 'Ask quick questions and get concise answers.',
    aiChatInput: 'Type your question...',
    aiImageGeneratorTitle: 'AI Image Generator',
    aiImageGeneratorDesc: 'Create original concept art from your prompt.',
    aiImageInput: 'Example: Neon city skyline at sunrise, cinematic',
    aiQuizGeneratorTitle: 'AI Quiz Generator',
    aiQuizGeneratorDesc: 'Build practice quiz questions for study or games.',
    aiQuizInput: 'Example: JavaScript basics for beginners',
    aiTextGeneratorTitle: 'AI Text Generator',
    aiParagraphRewriterTitle: 'Paragraph Rewriter',
    aiGrammarCheckerTitle: 'Grammar Checker',
    aiTextSummarizerTitle: 'Text Summarizer',
    aiProductDescriptionTitle: 'Product Description Generator',
    aiYoutubeTitleGeneratorTitle: 'YouTube Title Generator',
    aiHashtagGeneratorTitle: 'Hashtag Generator',
    aiEmailWriterTitle: 'Email Writer',
    aiCartoonGeneratorTitle: 'Cartoon Generator',
    aiAvatarGeneratorTitle: 'Avatar Generator',
    aiLogoGeneratorTitle: 'Logo Generator',
    aiStyleTransferTitle: 'Style Transfer',
    aiPromptEnhancerTitle: 'Prompt Enhancer',
    aiCodingAssistantTitle: 'Coding Assistant',
    aiHomeworkHelperTitle: 'Homework Helper',
    aiEnglishPracticeTitle: 'English Practice',
    aiGenericPromptPlaceholder: 'Describe what you want to generate...',
    aiParagraphInput: 'Paste your paragraph here...',
    aiProductPromptPlaceholder: 'Example: Organic skincare serum for dry skin',
    aiYoutubePromptPlaceholder: 'Example: React performance optimization tutorial',
    aiEmailPromptPlaceholder: 'Example: Follow-up email after project proposal',
    aiChatInputPlaceholder: 'Ask a question or describe your task...',
    aiCodingPromptPlaceholder: 'Example: Fix this React hook dependency warning',
    aiHomeworkPromptPlaceholder: 'Example: Explain photosynthesis for class 7',
    aiEnglishPromptPlaceholder: 'Example: Check and improve this sentence',
    aiProviderLabel: 'Text provider',
    aiImageProviderLabel: 'Image provider',
    aiUsageLimitLabel: 'Usage limit',
    aiNoToolsAvailable: 'No tools are available right now.',
    aiHistoryTitle: 'Recent AI history',
    aiHistorySubtitle: 'Saved in localStorage on this device.',
    aiHistoryEmpty: 'No AI history yet. Run any tool to save a local history item.',
    aiInputRequired: 'Please enter a prompt before generating.',
    aiStatusGenerating: 'Generating response...',
    aiStatusRetrying: 'Retrying provider connection...',
    aiStatusDone: 'Done. You can copy the result now.',
    generate: 'Generate',
    askAI: 'Ask AI',
    generateImage: 'Generate Image',
    generateQuiz: 'Generate Quiz',
    aiGeneratedImageAlt: 'AI generated artwork',

    wordCounter: {
      title: 'Word Counter'
    },

    wordCounterPage: {
      title: 'Word Counter',
      subtitle: 'Count words, characters, sentences, paragraphs, and reading time instantly',
      whyTitle: 'Why use this Word Counter?',
      why1: 'Check article length for SEO optimization',
      why2: 'Count characters for social media limits',
      why3: 'Improve writing productivity and accuracy',
      why4: 'Estimate reading time automatically',
      why5: 'Analyze text instantly without uploading files',
      howTitle: 'How to use the Word Counter tool:',
      how1: 'Type or paste your text in the box above',
      how2: 'Statistics update automatically as you type',
      how3: 'Reading time is calculated based on 200 words per minute',
      how4: 'All processing happens in your browser — your text is never stored',
      faq: 'FAQ',
      faq1q: 'Is this word counter free?',
      faq1a: 'Yes, this tool is completely free with unlimited usage.',
      faq2q: 'Does my text get saved?',
      faq2a: 'No. All text processing happens locally in your browser.',
      faq3q: 'Who can use this tool?',
      faq3a: 'Writers, students, marketers, developers, and anyone working with text.',
      toolWordCounterDesc: "Count words and characters instantly.",
toolJSONFormatterDesc: "Format, validate, and beautify JSON data.",
toolPasswordGeneratorDesc: "Generate secure random passwords.",
toolBase64EncoderDesc: "Encode and decode Base64 strings easily.",
toolAgeCalculatorDesc: "Calculate age from birth date instantly.",
toolTextCaseConverterDesc: "Convert text to different letter cases."

    },
    seo: {
      wordCounterTitle: 'Free Word Counter Tool - Count Words, Characters & Sentences Online',
      wordCounterDesc: 'Free online word counter tool to count words, characters, sentences and reading time instantly.'
    }

    
  },
  ar: {
    // Navigation
    home: 'الرئيسية',
    tools: 'الأدوات',
    aiChat: 'دردشة AI مجانية',
    aiToolsDirectory: 'دليل أدوات AI',
    footballNews: 'أخبار كرة القدم',
    programming: 'البرمجة',
    gaming: 'الألعاب',
    gamesHub: 'ألعاب الذكاء',
    gamesHubTitle: 'ألعاب تدريب العقل والذكاء',
    gamesHubSubtitle: 'العب ألعاب الذاكرة والمنطق ورد الفعل والبرمجة مجانًا لتحسين التركيز وتنشيط عقلك.',
    seoGamesTitle: 'ألعاب الذكاء أونلاين | 3ToolsPro',
    seoGamesDesc: 'العب ألعاب الذكاء وتدريب العقل مجانًا عبر الإنترنت، بما في ذلك تحديات الذاكرة والألغاز ورد الفعل والبرمجة. متوافقة مع الجوال وتعمل بالكامل في المتصفح.',
    gameWhatIsTitle: 'ما هي',
    gameHowToPlayTitle: 'كيفية اللعب',
    gameSkillsTitle: 'المهارات المحسنة',
    gameBenefitsTitle: 'الفوائد',
    gameFaqTitle: 'الأسئلة الشائعة',
    gameRelatedTitle: 'أدوات وألعاب ذات صلة',
    gameScore: 'النتيجة',
    gameBest: 'الأفضل',
    gameQuestion: 'سؤال',
    gameNextQuestion: 'السؤال التالي',
    difficultyEasy: 'سهل',
    difficultyMedium: 'متوسط',
    difficultyHard: 'صعب',
    codeOutputTitle: 'تخمين مخرجات الكود',
    codeOutputSubtitle: 'لعبة ذهنية للمطورين لشحذ التفكير في جافا سكريبت.',
    seoCodeOutputTitle: 'لعبة تخمين مخرجات الكود | 3ToolsPro',
    seoCodeOutputDesc: 'العب لعبة ذكاء برمجي مجانية وخمن مخرجات جافا سكريبت. درب المنطق وعقلية التصحيح وبديهة المطور الموفرة للوقت في متصفحك.',
    codeOutputWhatIs: 'تخمين مخرجات الكود هو تحدي برمجي خفيف للمطورين والمتعلمين. يدرب على التحليل السريع لبناء الجملة والنطاق وسلوك وقت التشغيل.',
    codeOutputHow1: 'اختر مستوى الصعوبة.',
    codeOutputHow2: 'اقرأ مقتطف جافا سكريبت بعناية.',
    codeOutputHow3: 'حدد المخرجات التي تعتقد أنها صحيحة.',
    codeOutputHow4: 'انتقل إلى السؤال التالي وحسن نتيجتك.',
    codeOutputSkill1: 'عقلية التصحيح',
    codeOutputSkill2: 'أساسيات جافا سكريبت',
    codeOutputSkill3: 'حدس تعقيد الوقت',
    codeOutputBenefit1: 'مشاركة أعلى للمطورين',
    codeOutputBenefit2: 'تمرين مفيد للمقابلات',
    codeOutputBenefit3: 'عادة تعلم يومية سريعة',
    codeOutputFaq1Q: 'هل الأسئلة مناسبة للمبتدئين؟',
    codeOutputFaq1A: 'نعم. الوضع السهل مصمم للممارسة الأساسية.',
    codeOutputFaq2Q: 'هل يتم حفظ النتيجة؟',
    codeOutputFaq2A: 'يتم حفظ أفضل نتيجة محليًا في متصفحك.',
    memoryGameTitle: 'لعبة بطاقات الذاكرة',
    memoryGameSubtitle: 'طابق جميع الأزواج بأقل عدد من الحركات وحقق أفضل نتيجة شخصية لك.',
    seoMemoryGameTitle: 'لعبة بطاقات الذاكرة | 3ToolsPro',
    seoMemoryGameDesc: 'العب لعبة بطاقات الذاكرة المجانية عبر الإنترنت لتدريب التركيز والذاكرة قصيرة المدى. تابع أفضل نتيجة لك وحسن التركيز مع لعبة العقل هذه.',
    memoryWhatIs: 'تساعد لعبة العقل خفيفة الوزن هذه الأطفال والبالغين على تقوية الذاكرة البصرية والتركيز من خلال مطابقة أزواج الرموز.',
    memoryHow1: 'اضغط على بطاقة لكشفها.',
    memoryHow2: 'اضغط على بطاقة ثانية للعثور على تطابق.',
    memoryHow3: 'استمر في مطابقة الأزواج حتى تكتمل اللوحة.',
    memoryHow4: 'حاول إنهاء الجولة بحركات أقل.',
    memorySkill1: 'الذاكرة العاملة',
    memorySkill2: 'الانتباه البصري',
    memorySkill3: 'التعرف على الأنماط',
    memoryBenefit1: 'تمرين عقلي يومي سريع',
    memoryBenefit2: 'لعب مناسب للعائلة',
    memoryBenefit3: 'لا يتطلب حسابًا أو تنزيلًا',
    memoryFaq1Q: 'هل تحفظ اللعبة أفضل نتيجة لي؟',
    memoryFaq1A: 'نعم، يتم تخزين أفضل عدد حركات لك في التخزين المحلي على هذا الجهاز.',
    memoryFaq2Q: 'هل يمكن للأطفال لعب هذه اللعبة؟',
    memoryFaq2A: 'نعم، تستخدم رسومات بسيطة وأدوات تحكم سهلة اللمس.',
    numberPuzzleTitle: 'لغز الأرقام',
    numberPuzzleSubtitle: 'حرك البلاط إلى الترتيب الصحيح من 1 إلى 8.',
    seoNumberPuzzleTitle: 'لعبة لغز الأرقام | 3ToolsPro',
    seoNumberPuzzleDesc: 'العب لعبة ألغاز الأرقام 3×3 مجانًا عبر الإنترنت. حسن مهارات حل المشكلات والمنطق، وتابع أفضل الحركات، واستمتع بتحدي متصفح سريع.',
    numberPuzzleSolved: 'عمل رائع! تم حل اللغز في {moves} حركة.',
    numberPuzzleWhatIs: 'لغز الأرقام هي لعبة منطق كلاسيكية حيث تحرك البلاط المرقم لاستعادة الترتيب الصحيح.',
    numberPuzzleHow1: 'اضغط على بلاطة بجوار المساحة الفارغة.',
    numberPuzzleHow2: 'استمر في تحريك البلاط خطوة بخطوة.',
    numberPuzzleHow3: 'رتب الأرقام من 1 إلى 8 بالترتيب.',
    numberPuzzleHow4: 'أعد اللعب وحسن أفضل نتيجة لك.',
    numberPuzzleSkill1: 'حل المشكلات',
    numberPuzzleSkill2: 'التخطيط المسبق',
    numberPuzzleSkill3: 'التفكير المكاني',
    numberPuzzleBenefit1: 'تمرين عقلي سريع',
    numberPuzzleBenefit2: 'يحسن الصبر والتركيز',
    numberPuzzleBenefit3: 'يعمل بسلاسة على الجوال وسطح المكتب',
    numberPuzzleFaq1Q: 'هل تتطلب هذه اللعبة اتصالاً بالإنترنت؟',
    numberPuzzleFaq1A: 'لا. بمجرد التحميل، اللعب بالكامل من جانب العميل.',
    numberPuzzleFaq2Q: 'هل يتم حفظ أفضل نتيجة؟',
    numberPuzzleFaq2A: 'نعم، يتم حفظ أفضل عدد حركات لك في التخزين المحلي.',
    reactionTestTitle: 'اختبار رد الفعل السريع',
    reactionTestSubtitle: 'قس سرعة رد فعلك واحتفظ بأفضل نتيجة لك.',
    seoReactionTestTitle: 'اختبار رد الفعل السريع | 3ToolsPro',
    seoReactionTestDesc: 'اختبر سرعة رد فعلك عبر الإنترنت مجانًا. تابع أفضل نتيجة لرد فعلك وحسن التركيز مع لعبة متصفح خفيفة الوزن.',
    reactionWhatIs: 'اختبار رد الفعل السريع هو لعبة رد فعل بسيطة تقيس مدى سرعة استجابتك لإشارة بصرية.',
    reactionHow1: 'اضغط على بدء لتجهيز الاختبار.',
    reactionHow2: 'انتظر حتى تتحول اللوحة إلى اللون الأخضر.',
    reactionHow3: 'اضغط فورًا عندما تظهر كلمة "جاهز".',
    reactionHow4: 'كرر وحسن أفضل وقت لك.',
    reactionSkill1: 'سرعة رد الفعل',
    reactionSkill2: 'التركيز البصري',
    reactionSkill3: 'التحكم في الاستجابة',
    reactionBenefit1: 'تحدي يومي سريع',
    reactionBenefit2: 'رائع لجميع الأعمار',
    reactionBenefit3: 'لا يتطلب تسجيلًا أو تثبيتًا',
    reactionFaq1Q: 'ما هو وقت رد الفعل الجيد؟',
    reactionFaq1A: 'بالنسبة للعديد من الأشخاص، 200-300 مللي ثانية هي نتيجة قوية.',
    reactionFaq2Q: 'هل يمكنني استخدام هذا على الجوال؟',
    reactionFaq2A: 'نعم، اللعبة محسنة للنقر على شاشات اللمس.',
    gameMoves: 'الحركات',
    gameRestart: 'إعادة تشغيل',
    selectLanguage: 'اختر اللغة',
    more: 'المزيد',
    resources: 'الموارد',

    // Home Page
    heroTitle: 'أدوات مجانية عبر الإنترنت لتسريع عملك',
    heroSubtitle: 'أدوات احترافية للمهام اليومية. سريعة وآمنة وبدون تسجيل.',
    startUsing: 'ابدأ استخدام الأدوات',
    ourTools: 'أدواتنا',
    ourToolsSubtitle: 'جميع أدواتنا مجانية 100%، تعمل فوراً في متصفحك، ولا تحتاج لتسجيل.',
    allFree: 'مجاني 100% للأبد',
    instantResults: 'نتائج فورية',
    noSignup: 'لا يتطلب تسجيل',
    freeAIChat: 'دردشة AI مجانية',

    // Shared UI
    adLabel: 'إعلان',
    adAreaAriaLabel: 'منطقة محتوى مدعوم',
    adPlaceholderLabel: 'موضع إعلانات Google AdSense',
    adPlaceholderBetweenSections: 'موضع إعلان داخل المحتوى',
    visitSite: 'زيارة الموقع',
    noSitesFound: 'لم يتم العثور على مواقع',
    selectDifferentRegion: 'حاول اختيار منطقة مختلفة',
    aiServiceUnavailable: 'الخدمة غير متوفرة مؤقتًا',
    aiUnexpectedError: 'حدث خطأ ما. حاول مرة أخرى.',

    // Home Card Descriptions
    aiChatDesc: 'دردش مع AI مجاناً - استخدام محدود',
    aiToolsDesc: 'اكتشف أفضل أدوات AI لاحتياجاتك',
    footballDesc: 'آخر أخبار كرة القدم من جميع أنحاء العالم',
    programmingDesc: 'موارد للمطورين والمتعلمين',
    gamingDesc: 'أفضل منصات وموارد الألعاب',

    // Tools Page
    toolsPageTitle: 'أدوات مجانية عبر الإنترنت',
    toolsPageSubtitle: 'أدوات احترافية للمهام اليومية. سريعة وآمنة وبدون تسجيل.',

    // Tool Categories
    categoryAll: 'الكل',
    categoryTextContent: 'النص والمحتوى',
    categoryDeveloper: 'المطورين',
    categoryUtility: 'أدوات مساعدة',

    // Tool Names
    toolWordCounter: 'عداد الكلمات',
    toolTextCaseConverter: 'محول حالة النص',
    toolTextCompare: 'مقارنة النصوص',
    toolLoremIpsum: 'مولد نص وهمي',
    toolJSONFormatter: 'منسق JSON',
    toolBase64Encoder: 'مشفر/فاك Base64',
    toolURLEncoder: 'مشفر/فاك URL',
    toolPasswordGenerator: 'مولد كلمات المرور',
    toolRandomNumber: 'مولد الأرقام العشوائية',
    toolAgeCalculator: 'حاسبة العمر',
    toolUnitConverter: 'محول الوحدات',
    toolWheelOfFortune: 'عجلة الحظ',
    toolWheelOfFortuneDesc: 'دور عجلة قابلة للتخصيص لاختيار طعام أو عنصر عشوائي',

    // AI Chat Status
    connectionStatus: 'الحالة',
    aiStatusOnline: 'متصل',
    aiStatusOffline: 'وضع عدم الاتصال',
    aiLocalModeNotice: 'خدمة AI غير متوفرة حاليًا، لذلك تستخدم ردودًا دون اتصال.',
    openChatGPT: 'فتح ChatGPT',
    aiLocalResponse1: 'أنا غير متصل الآن، لكن لا يزال بإمكاني المساعدة. حاول تحسين سؤالك أو اطلب مخططًا سريعًا.',
    aiLocalResponse2: 'إليك اقتراح سريع: قسم المهمة إلى خطوات وابدأ بالجزء الأكثر أهمية.',
    aiLocalResponse3: 'إذا كنت بحاجة إلى نتائج مفصلة، حاول مرة أخرى لاحقًا. في الوقت الحالي، يمكنني تقديم ملخص أو قائمة مراجعة.',

    // Wheel of Fortune UI
    wheelTitle: 'عجلة الحظ (اختيار الطعام)',
    wheelSubtitle: 'أضف خيارات، ودور العجلة، واحصل على اختيار عشوائي فوري.',
    wheelSpin: 'دور العجلة',
    wheelSpinning: 'جاري الدوران...',
    wheelResultLabel: 'النتيجة المختارة',
    wheelResultPlaceholder: 'أضف عناصر ودور العجلة للاختيار',
    wheelManageTitle: 'إدارة عناصرك',
    wheelManageSubtitle: 'أضف أطعمة أو خيارات واحفظها على هذا الجهاز.',
    wheelInputPlaceholder: 'اكتب طعامًا أو عنصرًا',
    wheelAdd: 'إضافة',
    wheelEmpty: 'لا توجد عناصر بعد. أضف عنصرين على الأقل للدوران.',
    wheelRemove: 'إزالة',
    wheelReset: 'إعادة تعيين القائمة',

    // Tool Content - Age Calculator
    toolAgeWhatTitle: 'ما هي حاسبة العمر؟',
    toolAgeWhatDesc: 'تساعدك حاسبة العمر في معرفة عمرك الدقيق والمعالم الرئيسية من تاريخ الميلاد.',
    toolAgeHowTitle: 'كيفية استخدام حاسبة العمر',
    toolAgeHow1: 'اختر تاريخ ميلادك.',
    toolAgeHow2: 'انقر على حساب لعرض تفاصيل عمرك.',
    toolAgeHow3: 'راجع الإجماليات مثل الأيام والأشهر وعيد الميلاد القادم.',
    toolAgeBenefitsTitle: 'الفوائد',
    toolAgeBenefit1: 'احصل على تفاصيل العمر الدقيقة فورًا.',
    toolAgeBenefit2: 'شاهد إجماليات مفيدة مثل الأيام والأشهر.',
    toolAgeBenefit3: 'كل شيء يعمل محليًا للخصوصية.',
    toolAgeFaqTitle: 'الأسئلة الشائعة',
    toolAgeFaq1Q: 'هل الحساب دقيق؟',
    toolAgeFaq1A: 'نعم، يستخدم تاريخ ووقت جهازك المحلي للحصول على نتائج دقيقة.',
    toolAgeFaq2Q: 'هل يتم تخزين تاريخي في أي مكان؟',
    toolAgeFaq2A: 'لا. جميع الحسابات تتم في متصفحك.',

    // Tool Content - Base64
    toolBase64WhatTitle: 'ما هو مشفر/فاك Base64؟',
    toolBase64WhatDesc: 'تحول هذه الأداة النص من وإلى Base64 للنقل الآمن والاختبار.',
    toolBase64HowTitle: 'كيفية استخدام أداة Base64',
    toolBase64How1: 'اختر وضع التشفير أو فك التشفير.',
    toolBase64How2: 'الصق نصك أو سلسلة Base64.',
    toolBase64How3: 'انقر على معالجة وانسخ النتيجة.',
    toolBase64BenefitsTitle: 'الفوائد',
    toolBase64Benefit1: 'حوّل البيانات بسرعة بدون رفع ملفات.',
    toolBase64Benefit2: 'مفيد للتطوير وتصحيح الأخطاء.',
    toolBase64Benefit3: 'يعمل بالكامل في متصفحك.',
    toolBase64FaqTitle: 'الأسئلة الشائعة',
    toolBase64Faq1Q: 'هل Base64 تشفير؟',
    toolBase64Faq1A: 'لا، Base64 هو تنسيق ترميز ويمكن عكسه بسهولة.',
    toolBase64Faq2Q: 'هل تخزن الأداة بياناتي؟',
    toolBase64Faq2A: 'لا. تبقى بياناتك على جهازك.',

    // Tool Content - JSON Formatter
    toolJsonWhatTitle: 'ما هو منسق JSON؟',
    toolJsonWhatDesc: 'نسق وتحقق من صحة وصغر حجم JSON مع إخراج واضح وأخطاء فورية.',
    toolJsonHowTitle: 'كيفية استخدام منسق JSON',
    toolJsonHow1: 'الصق JSON في مربع الإدخال.',
    toolJsonHow2: 'اختر تنسيق أو تصغير أو تحقق.',
    toolJsonHow3: 'انسخ المخرجات عندما تكون جاهزة.',
    toolJsonBenefitsTitle: 'الفوائد',
    toolJsonBenefit1: 'حسن القراءة لتصحيح الأخطاء.',
    toolJsonBenefit2: 'اكتشف الأخطاء بسرعة مع التحقق.',
    toolJsonBenefit3: 'صغر حجم JSON للاستخدام في الإنتاج.',
    toolJsonFaqTitle: 'الأسئلة الشائعة',
    toolJsonFaq1Q: 'هل يدعم المصفوفات؟',
    toolJsonFaq1A: 'نعم، المصفوفات والكائنات مدعومة.',
    toolJsonFaq2Q: 'هل يتم إرسال بياناتي إلى خادم؟',
    toolJsonFaq2A: 'لا، كل شيء يعمل في متصفحك.',

    // Tool Content - Lorem Ipsum
    toolLoremWhatTitle: 'ما هو مولد النص الوهمي؟',
    toolLoremWhatDesc: 'أنشئ نصًا وهميًا لملء التخطيطات والنماذج الأولية ومسودات التصميم.',
    toolLoremHowTitle: 'كيفية استخدام مولد النص الوهمي',
    toolLoremHow1: 'اختر عدد الفقرات والكلمات لكل فقرة.',
    toolLoremHow2: 'اختر ما إذا كنت تريد البدء بـ "Lorem".',
    toolLoremHow3: 'انقر على إنشاء وانسخ المخرجات.',
    toolLoremBenefitsTitle: 'الفوائد',
    toolLoremBenefit1: 'أنشئ حشو تخطيط واقعي بسرعة.',
    toolLoremBenefit2: 'خصص الطول لأي مشروع.',
    toolLoremBenefit3: 'لا يتطلب تنزيلات أو تسجيل.',
    toolLoremFaqTitle: 'الأسئلة الشائعة',
    toolLoremFaq1Q: 'هل يمكنني تغيير الطول؟',
    toolLoremFaq1A: 'نعم، يمكنك التحكم في عدد الفقرات وعدد الكلمات.',
    toolLoremFaq2Q: 'هل النص خالٍ من حقوق النشر؟',
    toolLoremFaq2A: 'نعم، هو نص وهمي قياسي.',

    // Tool Content - Password Generator
    toolPasswordWhatTitle: 'ما هو مولد كلمات المرور؟',
    toolPasswordWhatDesc: 'أنشئ كلمات مرور قوية مع خيارات طول وأحرف مخصصة.',
    toolPasswordHowTitle: 'كيفية استخدام مولد كلمات المرور',
    toolPasswordHow1: 'اضبط إعدادات الطول والأحرف.',
    toolPasswordHow2: 'انقر على إنشاء لإنشاء كلمة مرور.',
    toolPasswordHow3: 'انسخ كلمة المرور للاستخدام.',
    toolPasswordBenefitsTitle: 'الفوائد',
    toolPasswordBenefit1: 'أنشئ كلمات مرور آمنة فورًا.',
    toolPasswordBenefit2: 'خصص القوة بناءً على الاحتياجات.',
    toolPasswordBenefit3: 'يُنشأ محليًا للخصوصية.',
    toolPasswordFaqTitle: 'الأسئلة الشائعة',
    toolPasswordFaq1Q: 'هل يتم تخزين كلمات المرور؟',
    toolPasswordFaq1A: 'لا، يتم إنشاء كلمات المرور محليًا ولا يتم حفظها أبدًا.',
    toolPasswordFaq2Q: 'كم يجب أن يكون طول كلمات المرور؟',
    toolPasswordFaq2A: 'نوصي بـ 12 حرفًا أو أكثر لأمان قوي.',

    // Tool Content - Random Number
    toolRandomWhatTitle: 'ما هو مولد الأرقام العشوائية؟',
    toolRandomWhatDesc: 'أنشئ أرقامًا عشوائية ضمن نطاق مخصص للألعاب أو الاختبار أو الاختيار.',
    toolRandomHowTitle: 'كيفية استخدام مولد الأرقام العشوائية',
    toolRandomHow1: 'حدد النطاق الأدنى والأقصى.',
    toolRandomHow2: 'اختر عدد الأرقام المراد إنشاؤها.',
    toolRandomHow3: 'انقر على إنشاء وانسخ النتائج.',
    toolRandomBenefitsTitle: 'الفوائد',
    toolRandomBenefit1: 'اختيارات عشوائية سريعة لأي مهمة.',
    toolRandomBenefit2: 'دعم للنتائج الفريدة أو المكررة.',
    toolRandomBenefit3: 'يعمل فورًا في متصفحك.',
    toolRandomFaqTitle: 'الأسئلة الشائعة',
    toolRandomFaq1Q: 'هل يمكنني تجنب التكرار؟',
    toolRandomFaq1A: 'نعم، قم بتعطيل التكرار للحصول على أرقام فريدة.',
    toolRandomFaq2Q: 'كم عدد الأرقام التي يمكنني إنشاؤها؟',
    toolRandomFaq2A: 'حتى 100 رقم في كل مرة.',

    // Tool Content - Text Case Converter
    toolCaseWhatTitle: 'ما هو محول حالة النص؟',
    toolCaseWhatDesc: 'حوّل النص إلى حالات مختلفة للكتابة والتنسيق والبرمجة.',
    toolCaseHowTitle: 'كيفية استخدام محول حالة النص',
    toolCaseHow1: 'الصق أو اكتب نصك.',
    toolCaseHow2: 'اختر الحالة التي تريد تطبيقها.',
    toolCaseHow3: 'انسخ النص المحدث.',
    toolCaseBenefitsTitle: 'الفوائد',
    toolCaseBenefit1: 'وحّد تنسيق النص فورًا.',
    toolCaseBenefit2: 'مفيد للعناوين والترويسات والكود.',
    toolCaseBenefit3: 'لا تغادر أي بيانات متصفحك.',
    toolCaseFaqTitle: 'الأسئلة الشائعة',
    toolCaseFaq1Q: 'هل يمكنني تحويل نص كبير؟',
    toolCaseFaq1A: 'نعم، كتل النص الكبيرة مدعومة.',
    toolCaseFaq2Q: 'هل يحتفظ بعلامات الترقيم؟',
    toolCaseFaq2A: 'نعم، تبقى علامات الترقيم كما هي.',

    // Tool Content - Text Compare
    toolCompareWhatTitle: 'ما هي أداة مقارنة النصوص؟',
    toolCompareWhatDesc: 'قارن بين نصين سطرًا بسطر للعثور على التغييرات والإضافات والحذف.',
    toolCompareHowTitle: 'كيفية استخدام أداة مقارنة النصوص',
    toolCompareHow1: 'الصق النص الأصلي في المربع الأول.',
    toolCompareHow2: 'الصق النص المعدل في المربع الثاني.',
    toolCompareHow3: 'انقر على مقارنة لعرض الاختلافات.',
    toolCompareBenefitsTitle: 'الفوائد',
    toolCompareBenefit1: 'اكتشف التغييرات بسرعة أثناء المراجعات.',
    toolCompareBenefit2: 'تمييز واضح للتعديلات والتحديثات.',
    toolCompareBenefit3: 'مثالي للكتاب والمطورين.',
    toolCompareFaqTitle: 'الأسئلة الشائعة',
    toolCompareFaq1Q: 'هل يقارن سطرًا بسطر؟',
    toolCompareFaq1A: 'نعم، يقارن النص سطرًا بسطر.',
    toolCompareFaq2Q: 'هل يتم تخزين نصي؟',
    toolCompareFaq2A: 'لا، تتم المقارنات محليًا.',

    // Tool Content - URL Encoder
    toolUrlWhatTitle: 'ما هو مشفر/فاك URL؟',
    toolUrlWhatDesc: 'شفر أو فك تشفير URLs للتعامل بأمان مع الأحرف الخاصة في روابط الويب.',
    toolUrlHowTitle: 'كيفية استخدام مشفر URL',
    toolUrlHow1: 'اختر وضع التشفير أو فك التشفير.',
    toolUrlHow2: 'الصق عنوان URL أو النص الخاص بك.',
    toolUrlHow3: 'انقر على معالجة وانسخ النتيجة.',
    toolUrlBenefitsTitle: 'الفوائد',
    toolUrlBenefit1: 'تجنب الروابط المعطلة في نماذج الويب.',
    toolUrlBenefit2: 'رائع لواجهات برمجة التطبيقات وسلاسل الاستعلام.',
    toolUrlBenefit3: 'معالجة سريعة قائمة على المتصفح.',
    toolUrlFaqTitle: 'الأسئلة الشائعة',
    toolUrlFaq1Q: 'ما الأحرف التي يتم تشفيرها؟',
    toolUrlFaq1A: 'يتم تحويل المسافات والأحرف الخاصة إلى رموز آمنة.',
    toolUrlFaq2Q: 'هل يدعم عناوين URL كاملة؟',
    toolUrlFaq2A: 'نعم، يعمل مع عناوين URL كاملة وسلاسل الاستعلام.',

    // Tool Content - Unit Converter
    toolUnitWhatTitle: 'ما هو محول الوحدات؟',
    toolUnitWhatDesc: 'حوّل بين الوحدات الشائعة للطول والوزن ودرجة الحرارة والحجم والوقت.',
    toolUnitHowTitle: 'كيفية استخدام محول الوحدات',
    toolUnitHow1: 'اختر فئة مثل الطول أو درجة الحرارة.',
    toolUnitHow2: 'اختر الوحدات المراد التحويل بينها.',
    toolUnitHow3: 'أدخل قيمة لرؤية النتائج فورًا.',
    toolUnitBenefitsTitle: 'الفوائد',
    toolUnitBenefit1: 'تحويلات دقيقة في ثوانٍ.',
    toolUnitBenefit2: 'يدعم فئات متعددة.',
    toolUnitBenefit3: 'سهل الاستخدام على أي جهاز.',
    toolUnitFaqTitle: 'الأسئلة الشائعة',
    toolUnitFaq1Q: 'ما الوحدات المدعومة؟',
    toolUnitFaq1A: 'الطول، الوزن، درجة الحرارة، الحجم، والوقت.',
    toolUnitFaq2Q: 'هل التحويل دقيق؟',
    toolUnitFaq2A: 'نعم، يتم استخدام عوامل التحويل القياسية.',

    // Tool Content - Wheel of Fortune
    wheelWhatTitle: 'ما هي أداة عجلة الحظ؟',
    wheelWhatDesc: 'أداة اختيار تفاعلية ممتعة تساعدك على اتخاذ القرار عن طريق تدوير عجلة قابلة للتخصيص.',
    wheelHowTitle: 'كيفية استخدام عجلة الحظ',
    wheelHow1: 'أضف أطعمة أو عناصر إلى قائمتك.',
    wheelHow2: 'انقر على تدوير لتحريك العجلة.',
    wheelHow3: 'شاهد النتيجة المختارة فورًا.',
    wheelBenefitsTitle: 'الفوائد',
    wheelBenefit1: 'رائع للقرارات السريعة واختيارات المجموعات.',
    wheelBenefit2: 'يتم حفظ العناصر محليًا على جهازك.',
    wheelBenefit3: 'يعمل بسلاسة على الجوال وسطح المكتب.',
    wheelFaqTitle: 'الأسئلة الشائعة',
    wheelFaq1Q: 'هل يتم حفظ عناصري؟',
    wheelFaq1A: 'نعم، يتم تخزين العناصر في التخزين المحلي على جهازك.',
    wheelFaq2Q: 'هل يمكنني إعادة تعيين القائمة؟',
    wheelFaq2A: 'نعم، استخدم زر إعادة التعيين لمسح جميع العناصر.',

    // Tools Features
    featureFast: 'سريع للغاية',
    featureFastDesc: 'جميع الأدوات تعمل مباشرة في متصفحك لنتائج فورية',
    featureSecure: 'آمن 100%',
    featureSecureDesc: 'بياناتك لا تغادر جهازك أبداً - خصوصية كاملة',
    featureFree: 'مجاني تماماً',
    featureFreeDesc: 'لا تسجيل، لا حدود، لا تكاليف خفية - مجاني للأبد',

    // AI Chat
    freeAIChatTitle: 'دردشة AI مجانية',
    freeAIChatSubtitle: 'تحدث مع مساعد AI',
    fairUsagePolicy: 'دردشة AI مجانية – سياسة الاستخدام العادل',
    disclaimer: 'إخلاء المسؤولية',
    aiDisclaimer: 'هذه دردشة AI مجانية لأغراض التفاعل. الردود تُنشأ بواسطة نموذج AI وقد لا تكون دقيقة دائماً. هذه الخدمة لها حدود استخدام لضمان الوصول العادل لجميع المستخدمين. للدردشة الاحترافية غير المحدودة، جرب ChatGPT أو Claude أو Gemini.',
    startConversation: 'ابدأ محادثة! اسألني أي شيء.',
    exampleQuestions: 'جرب: "احكِ لي نكتة" أو "ما هو الذكاء الاصطناعي؟"',
    aiThinking: 'AI يفكر...',
    typePlaceholder: 'اكتب رسالتك...',
    sendMessage: 'إرسال',
    pressEnter: 'اضغط Enter للإرسال',
    freeServiceNotice: 'خدمة مجانية مع حدود استخدام عادلة',
    aboutFreeAIChat: 'حول دردشة AI المجانية',
    poweredByHF: 'مدعوم من Hugging Face - AI مجاني ومفتوح المصدر',
    refreshToReset: 'حدّث الصفحة لبدء محادثة جديدة',
    responsesDelay: 'تصل الردود عادةً خلال 3-5 ثوانٍ',
    engagementOnly: 'هذه الدردشة للتفاعل والتعلم',
    unlimitedAI: 'للدردشة غير المحدودة: ChatGPT، Claude، أو Gemini',
    aiNoResponse: 'عذراً، لم أتمكن من إنشاء رد. حاول مرة أخرى.',
    aiFallbackMessage: 'أعتذر، أواجه مشكلة في الاتصال الآن. قد تكون الخدمة المجانية مشغولة. حاول مرة أخرى أو حدّث الصفحة.',

    // AI Tools Page
    aiToolsTitle: 'دليل أدوات AI',
    aiToolsSubtitle: 'اكتشف أفضل أدوات AI لاحتياجاتك',
    searchPlaceholder: 'ماذا تريد أن تفعل؟ (مثال: إنشاء شعار، كتابة مقال)',
    allCategories: 'جميع الفئات',
    visitTool: 'زيارة الأداة',
    free: 'مجاني',
    foundToolsFor: 'تم العثور على {count} أداة لـ "{query}"',
    noAIToolsFound: 'لم يتم العثور على أدوات AI',
    adjustSearchFilter: 'حاول تعديل البحث أو فلتر الفئة',

    // Football
    footballTitle: 'مواقع أخبار كرة القدم',
    footballSubtitle: 'ابقَ على اطلاع بآخر أخبار كرة القدم من العالم',

    // Programming
    programmingTitle: 'موارد البرمجة والتطوير',
    programmingSubtitle: 'تعلم وابنِ وتطور كمطور',

    // Gaming
    gamingTitle: 'مواقع الألعاب',
    gamingSubtitle: 'اكتشف أفضل منصات وموارد الألعاب',

    // SEO
    seoHomeTitle: '3ToolsPro - أدوات مجانية عبر الإنترنت للعمل اليومي',
    seoHomeDesc: 'الوصول إلى أدوات مجانية للنصوص والمطورين والمهام المساعدة. سريعة وآمنة ومصممة لنتائج احترافية.',
    seoToolsTitle: 'مكتبة أدوات مجانية عبر الإنترنت | 3ToolsPro',
    seoToolsDesc: 'تصفح مجموعة مختارة من الأدوات المجانية للإنتاجية والنصوص والمطورين والمهام المساعدة.',
    seoAiChatTitle: 'دردشة ذكاء اصطناعي مجانية مع سياسة استخدام عادلة | 3ToolsPro',
    seoAiChatDesc: 'تحدث مع مساعد ذكاء اصطناعي مجاني للإجابات والأفكار السريعة. تنطبق حدود استخدام عادلة لإتاحة الخدمة للجميع.',
    seoAiToolsTitle: 'دليل أدوات الذكاء الاصطناعي | 3ToolsPro',
    seoAiToolsDesc: 'استكشف أدوات ذكاء اصطناعي موثوقة عبر الكتابة والصور والفيديو والإنتاجية.',
    seoFootballTitle: 'مصادر أخبار كرة القدم | 3ToolsPro',
    seoFootballDesc: 'اعثر على مواقع أخبار كرة القدم الموثوقة حول العالم وابقَ على اطلاع بآخر التغطيات.',
    seoProgrammingTitle: 'موارد البرمجة | 3ToolsPro',
    seoProgrammingDesc: 'اكتشف موارد البرمجة والتوثيق والأدوات وروابط التعلم للمطورين بمختلف المستويات.',
    seoGamingTitle: 'موارد الألعاب | 3ToolsPro',
    seoGamingDesc: 'استكشف منصات الألعاب والتنزيلات والأخبار ومجتمعات اللاعبين في مكان واحد.',
    seoAboutTitle: 'حول 3ToolsPro',
    seoAboutDesc: 'تعرّف على 3ToolsPro ورسالتنا لتقديم أدوات مجانية عبر الإنترنت ودعم المستخدمين حول العالم.',
    seoContactTitle: 'تواصل مع 3ToolsPro',
    seoContactDesc: 'تواصل مع فريق 3ToolsPro للدعم أو الملاحظات أو الاستفسارات عن الشراكات.',
    seoHowToUseTitle: 'كيفية استخدام 3ToolsPro',
    seoHowToUseDesc: 'إرشادات خطوة بخطوة لاستخدام أدوات 3ToolsPro بفعالية والحصول على نتائج احترافية.',
    seoPrivacyTitle: 'سياسة الخصوصية | 3ToolsPro',
    seoPrivacyDesc: 'اقرأ كيف نتعامل مع البيانات والخصوصية والأمان لمستخدمي 3ToolsPro.',
    seoTermsTitle: 'شروط الخدمة | 3ToolsPro',
    seoTermsDesc: 'راجع شروط الخدمة لاستخدام 3ToolsPro وأدواته المجانية عبر الإنترنت.',
    seoWordCounterTitle: 'عداد الكلمات | 3ToolsPro',
    seoWordCounterDesc: 'احسب الكلمات والأحرف والجمل والفقرات فورًا. مثالي للكتّاب والطلاب وتحسين محركات البحث مع تحليل خاص داخل المتصفح.',
    seoTextCaseTitle: 'محول حالة النص | 3ToolsPro',
    seoTextCaseDesc: 'حوّل النص إلى أحرف كبيرة أو صغيرة أو عنوان أو جملة والمزيد. تنسيق سريع ودقيق لمهام الكتابة والبرمجة.',
    seoTextCompareTitle: 'أداة مقارنة النصوص | 3ToolsPro',
    seoTextCompareDesc: 'قارن بين نصين سطرًا بسطر للعثور على الإضافات والحذف والتغييرات. مثالي للتحرير والمراجعات وفحص المحتوى.',
    seoLoremIpsumTitle: 'مولد النص الوهمي | 3ToolsPro',
    seoLoremIpsumDesc: 'أنشئ نصًا وهميًا Lorem Ipsum قابلاً للتخصيص حسب الفقرات أو الكلمات. مفيد للنماذج الأولية والتخطيطات ومسودات التصميم.',
    seoJsonFormatterTitle: 'منسق JSON | 3ToolsPro',
    seoJsonFormatterDesc: 'نسق وتحقق من صحة وصغر حجم JSON مع إخراج قابل للقراءة وأخطاء فورية. مثالي للمطورين وتنظيف البيانات.',
    seoBase64Title: 'مشفر/فاك Base64 | 3ToolsPro',
    seoBase64Desc: 'شفر أو فك تشفير سلاسل Base64 بأمان في متصفحك. رائع لنقل البيانات والاختبار وسير عمل التطوير.',
    seoUrlEncoderTitle: 'مشفر/فاك URL | 3ToolsPro',
    seoUrlEncoderDesc: 'شفر أو فك تشفير URLs للتعامل مع المسافات والأحرف الخاصة بشكل صحيح. مفيد لنماذج الويب وواجهات برمجة التطبيقات وتصحيح الأخطاء.',
    seoPasswordGeneratorTitle: 'مولد كلمات المرور | 3ToolsPro',
    seoPasswordGeneratorDesc: 'أنشئ كلمات مرور قوية وآمنة مع خيارات طول وأحرف قابلة للتخصيص. يُنشأ محليًا للخصوصية.',
    seoRandomNumberTitle: 'مولد الأرقام العشوائية | 3ToolsPro',
    seoRandomNumberDesc: 'أنشئ أرقامًا عشوائية ضمن نطاق، مع نتائج فريدة اختيارية. مفيد للألعاب والاختبار والاختيارات السريعة.',
    seoAgeCalculatorTitle: 'حاسبة العمر | 3ToolsPro',
    seoAgeCalculatorDesc: 'احسب عمرك الدقيق مع إحصائيات مفصلة، بما في ذلك الأشهر والأيام وعيد الميلاد القادم. سريع وخاص.',
    seoUnitConverterTitle: 'محول الوحدات | 3ToolsPro',
    seoUnitConverterDesc: 'حوّل وحدات الطول والوزن ودرجة الحرارة والحجم والوقت فورًا بنتائج دقيقة وواجهة سهلة.',
    seoWheelTitle: 'أداة عجلة الحظ | 3ToolsPro',
    seoWheelDesc: 'دور عجلة قابلة للتخصيص لاختيار الطعام أو أي عنصر. احفظ قائمتك محليًا واحصل على نتائج فورية على أي جهاز.',

    // Footer
    footerTagline: 'أدوات مجانية احترافية للجميع',
    footerCopyright: '© 2025 3ToolsPro. جميع الحقوق محفوظة.',
    quickLinks: 'روابط سريعة',
    legalInfo: 'قانوني ومعلومات',

    // Common
    copy: 'نسخ',
    copied: 'تم النسخ!',
    clear: 'مسح',
    generate: 'إنشاء',
    encode: 'تشفير',
    decode: 'فك التشفير',
    format: 'تنسيق',
    validate: 'تحقق',
    compare: 'مقارنة',
    calculate: 'حساب',
    owner: 'المالك',
    email: 'البريد الإلكتروني',
    supportEmail: 'بريد الدعم',

    // About Page
    aboutUs: 'من نحن',
    aboutSubtitle: 'تعرف على 3ToolsPro ومهمتنا',
    ourMission: 'مهمتنا',
    missionText: 'تم إنشاء 3ToolsPro لتوفير أدوات مجانية عالية الجودة تجعل المهام اليومية أسهل. نؤمن بأن أدوات الإنتاجية يجب أن تكون متاحة للجميع بدون حواجز.',
    missionText2: 'تقدم منصتنا مجموعة متنامية من الأدوات المجانية لمعالجة النصوص وتحويل البيانات والأمان والحسابات. جميع الأدوات تعمل في متصفحك مما يضمن خصوصية بياناتك.',
    whatWeOffer: 'ما نقدمه',
    offer1: 'أدوات نصية: عداد الكلمات، محول الحالة، مقارنة النصوص',
    offer2: 'أدوات تحويل البيانات: منسق JSON، مشفر Base64، مشفر URL',
    offer3: 'أدوات الأمان: مولد كلمات مرور مع خيارات قابلة للتخصيص',
    offer4: 'دردشة AI للإجابات السريعة والتعلم',
    offer5: 'دليل منظم لأفضل أدوات AI وموارد البرمجة',
    contactInfo: 'معلومات الاتصال',

    // Contact Page
    contactUs: 'اتصل بنا',
    contactSubtitle: 'تواصل معنا - نحب أن نسمع منك',
    socialMedia: 'تواصل عبر وسائل التواصل',
    needHelp: 'تحتاج مساعدة؟',
    contactText: 'إذا كان لديك أسئلة أو اقتراحات حول أدواتنا، لا تتردد في التواصل. نرد عادةً خلال 24-48 ساعة.',

    // Privacy Policy
    privacyPolicy: 'سياسة الخصوصية',
    lastUpdated: 'آخر تحديث',
    introduction: 'مقدمة',
    privacyIntro: 'في 3ToolsPro، نأخذ خصوصيتك بجدية. توضح هذه السياسة كيف نجمع ونستخدم ونحمي معلوماتك. باستخدام خدماتنا، توافق على جمع المعلومات واستخدامها وفقاً لهذه السياسة.',
    dataCollection: 'المعلومات التي نجمعها',
    dataCollectionText: 'نجمع الحد الأدنى من المعلومات لتقديم خدماتنا وتحسينها:',
    dataItem1: 'بيانات الاستخدام: الصفحات المزارة، الأدوات المستخدمة (عبر Google Analytics)',
    dataItem2: 'معلومات الجهاز: نوع المتصفح، نظام التشغيل، دقة الشاشة',
    dataItem3: 'عنوان IP: لأغراض الأمان والتحليلات (مجهول الهوية)',
    howWeUseData: 'كيف نستخدم معلوماتك',
    useItem1: 'لتوفير وصيانة أدواتنا وخدماتنا المجانية',
    useItem2: 'لتحليل أنماط الاستخدام وتحسين تجربة المستخدم',
    useItem3: 'لعرض إعلانات ذات صلة عبر Google AdSense',
    cookies: 'ملفات تعريف الارتباط',
    cookiesText: 'نستخدم ملفات تعريف الارتباط لتحسين تجربتك. تساعدنا على تذكر تفضيلاتك وتوفير بيانات التحليلات. يمكنك تعطيلها في إعدادات المتصفح.',
    thirdParty: 'خدمات الطرف الثالث',
    thirdPartyText: 'نستخدم خدمات الطرف الثالث التالية:',
    dataSecurity: 'أمان البيانات',
    dataSecurityText: 'جميع الأدوات تعمل في متصفحك. بياناتك تُعالج محلياً ولا تُرسل لخوادمنا. لا نخزن أي محتوى تدخله.',
    yourRights: 'حقوقك',
    right1: 'الوصول: يمكنك طلب معلومات حول البيانات التي نجمعها',
    right2: 'الحذف: يمكنك طلب حذف أي بيانات شخصية',
    right3: 'إلغاء الاشتراك: يمكنك إلغاء تتبع التحليلات',
    privacyContactText: 'إذا كان لديك أسئلة حول سياسة الخصوصية، اتصل بنا:',

    // Terms of Service
    termsOfService: 'شروط الخدمة',
    acceptanceOfTerms: 'قبول الشروط',
    acceptanceText: 'بالوصول إلى 3ToolsPro واستخدامه، توافق على الالتزام بهذه الشروط. إذا لم توافق، لا تستخدم خدماتنا.',
    useOfService: 'استخدام الخدمة',
    useOfServiceText: 'أدواتنا مجانية للاستخدام الشخصي والتجاري وفقاً للشروط التالية:',
    serviceRule1: 'يمكنك استخدام أدواتنا لأي غرض قانوني',
    serviceRule2: 'لا تحاول عكس هندسة أو نسخ أدواتنا',
    serviceRule3: 'لا تستخدم خدماتنا في أنشطة غير قانونية',
    serviceRule4: 'لا تحاول إرهاق أو تعطيل خدماتنا',
    intellectualProperty: 'الملكية الفكرية',
    intellectualPropertyText: 'جميع المحتوى والتصميم والكود محمي بقوانين الملكية الفكرية.',
    userContent: 'محتوى المستخدم',
    userContentText: 'بياناتك تُعالج في متصفحك ولا تُخزن على خوادمنا. تحتفظ بجميع حقوق محتواك.',
    disclaimerText: 'أدواتنا مقدمة "كما هي" بدون ضمانات. لا نضمن أنها خالية من الأخطاء.',
    disclaimerWarning: 'الاستخدام على مسؤوليتك. لسنا مسؤولين عن أي فقدان للبيانات.',
    limitationOfLiability: 'تحديد المسؤولية',
    limitationText: 'لن نكون مسؤولين عن أي أضرار غير مباشرة ناشئة عن استخدام خدماتنا.',
    modifications: 'تعديلات الشروط',
    modificationsText: 'نحتفظ بحق تعديل هذه الشروط في أي وقت. التغييرات سارية فور نشرها.',
    governingLaw: 'القانون الحاكم',
    governingLawText: 'تخضع هذه الشروط لقوانين مصر. أي نزاعات تُحل في محاكم مصر.',
    termsContactText: 'إذا كان لديك أسئلة حول شروط الخدمة، اتصل بنا:',

    // How To Use Page
    howToUse: 'كيفية الاستخدام',
    howToUseSubtitle: 'ابدأ مع 3ToolsPro - سهل ومجاني!',
    step1Title: 'الخطوة 1: اختر أداتك',
    step1Text: 'تصفح مجموعتنا من الأدوات المجانية. نقدم:',
    step1Item1: 'أدوات النص: عداد الكلمات، محول الحالة، مقارنة النصوص',
    step1Item2: 'أدوات البيانات: منسق JSON، مشفر Base64، مشفر URL',
    step1Item3: 'أدوات مساعدة: مولد كلمات المرور، حاسبة العمر، محول الوحدات',
    step2Title: 'الخطوة 2: استخدم الأداة',
    step2Text: 'كل أداة سهلة الاستخدام:',
    step2Item1: 'أدخل أو الصق بياناتك في منطقة الإدخال',
    step2Item2: 'انقر زر الإجراء (تحويل، إنشاء، تنسيق)',
    step2Item3: 'شاهد نتائجك فوراً - بدون انتظار!',
    step3Title: 'الخطوة 3: انسخ أو استخدم نتائجك',
    step3Text: 'بعد الحصول على نتائجك:',
    step3Item1: 'انقر زر "نسخ" للنسخ للحافظة',
    step3Item2: 'حمّل النتائج عند توفرها',
    step3Item3: 'امسح وابدأ من جديد',
    step4Title: 'الخطوة 4: استكشف المزيد',
    step4Text: 'تحقق من دليل أدوات AI، تصفح موارد أخبار كرة القدم والبرمجة والألعاب. جرب دردشة AI المجانية!',
    helpText: 'إذا احتجت مساعدة أو لديك اقتراحات، تواصل معنا:',

    wordCounterPage: {
      title: 'عداد الكلمات',
      subtitle: 'احسب عدد الكلمات والحروف والجمل والفقرات ووقت القراءة فورًا',
      whyTitle: 'لماذا تستخدم أداة عداد الكلمات؟',
      why1: 'مراجعة طول المقال لتحسين السيو',
      why2: 'حساب عدد الأحرف لحدود السوشيال ميديا',
      why3: 'تحسين إنتاجية ودقة الكتابة',
      why4: 'تقدير وقت القراءة تلقائيًا',
      why5: 'تحليل النص فورًا بدون رفع ملفات',
      howTitle: 'طريقة استخدام أداة عداد الكلمات:',
      how1: 'اكتب أو الصق النص في المربع بالأعلى',
      how2: 'الإحصائيات تتحدث تلقائيًا أثناء الكتابة',
      how3: 'يتم حساب وقت القراءة على أساس 200 كلمة بالدقيقة',
      how4: 'كل المعالجة تتم داخل المتصفح ولا يتم حفظ النص',
      faq: 'الأسئلة الشائعة',
      faq1q: 'هل الأداة مجانية؟',
      faq1a: 'نعم، الأداة مجانية بالكامل بدون حدود.',
      faq2q: 'هل يتم حفظ النص؟',
      faq2a: 'لا، يتم تحليل النص محليًا داخل المتصفح فقط.',
      faq3q: 'من يمكنه استخدام الأداة؟',
      faq3a: 'الكتّاب والطلاب والمسوقون والمطورون وكل من يعمل على النصوص.',
      toolWordCounterDesc: "احسب عدد الكلمات والحروف فورًا.",
toolJSONFormatterDesc: "تنسيق والتحقق من بيانات JSON بسهولة.",
toolPasswordGeneratorDesc: "إنشاء كلمات مرور قوية وعشوائية.",
toolBase64EncoderDesc: "تحويل النصوص إلى Base64 والعكس بسهولة.",
toolAgeCalculatorDesc: "احسب العمر من تاريخ الميلاد فورًا.",
toolTextCaseConverterDesc: "تحويل النص بين حالات الحروف المختلفة."

    },
    seo: {
      wordCounterTitle: 'أداة عداد الكلمات المجانية - حساب الكلمات والحروف أونلاين',
      wordCounterDesc: 'أداة مجانية لحساب عدد الكلمات والحروف والجمل ووقت القراءة بشكل فوري.'
    }
  },
  fr: {
    // Navigation
    home: 'Accueil',
    tools: 'Outils',
    aiChat: 'Chat IA Gratuit',
    aiToolsDirectory: 'Répertoire IA',
    footballNews: 'Actualités Football',
    programming: 'Programmation',
    gaming: 'Jeux',
    gamesHub: 'Jeux de réflexion',
    gamesHubTitle: 'Jeux d\'entraînement cérébral et de QI',
    gamesHubSubtitle: 'Jouez gratuitement à des jeux de mémoire, de logique, de réaction et de code pour améliorer votre concentration et garder votre cerveau actif.',
    seoGamesTitle: 'Jeux de QI en ligne | 3ToolsPro',
    seoGamesDesc: 'Jouez gratuitement à des jeux de QI et d\'entraînement cérébral en ligne, y compris des défis de mémoire, de puzzle, de réaction et de code. Adapté aux mobiles et entièrement basé sur le navigateur.',
    gameWhatIsTitle: 'Qu\'est-ce que',
    gameHowToPlayTitle: 'Comment jouer',
    gameSkillsTitle: 'Compétences améliorées',
    gameBenefitsTitle: 'Avantages',
    gameFaqTitle: 'FAQ',
    gameRelatedTitle: 'Outils et jeux associés',
    gameScore: 'Score',
    gameBest: 'Meilleur',
    gameQuestion: 'Question',
    gameNextQuestion: 'Question suivante',
    difficultyEasy: 'Facile',
    difficultyMedium: 'Moyen',
    difficultyHard: 'Difficile',
    codeOutputTitle: 'Deviner la sortie du code',
    codeOutputSubtitle: 'Un jeu cérébral pour développeurs afin d\'aiguiser le raisonnement JavaScript.',
    seoCodeOutputTitle: 'Jeu Deviner la sortie du code | 3ToolsPro',
    seoCodeOutputDesc: 'Jouez gratuitement à un jeu de QI de codage et devinez la sortie JavaScript. Entraînez la logique, l\'état d\'esprit de débogage et l\'intuition du développeur dans votre navigateur.',
    codeOutputWhatIs: 'Deviner la sortie du code est un défi de codage léger pour les développeurs et les apprenants. Il entraîne l\'analyse rapide de la syntaxe, de la portée et du comportement d\'exécution.',
    codeOutputHow1: 'Choisissez un niveau de difficulté.',
    codeOutputHow2: 'Lisez attentivement l\'extrait JavaScript.',
    codeOutputHow3: 'Sélectionnez la sortie que vous pensez être correcte.',
    codeOutputHow4: 'Passez à la question suivante et améliorez votre score.',
    codeOutputSkill1: 'État d\'esprit de débogage',
    codeOutputSkill2: 'Fondamentaux JavaScript',
    codeOutputSkill3: 'Intuition de la complexité temporelle',
    codeOutputBenefit1: 'Engagement plus élevé des développeurs',
    codeOutputBenefit2: 'Pratique utile pour les entretiens',
    codeOutputBenefit3: 'Habitude d\'apprentissage quotidienne rapide',
    codeOutputFaq1Q: 'Les questions sont-elles adaptées aux débutants ?',
    codeOutputFaq1A: 'Oui. Le mode facile est conçu pour une pratique fondamentale.',
    codeOutputFaq2Q: 'Le score est-il sauvegardé ?',
    codeOutputFaq2A: 'Le meilleur score est sauvegardé localement dans votre navigateur.',
    memoryGameTitle: 'Jeu de cartes mémoire',
    memoryGameSubtitle: 'Associez toutes les paires en le moins de coups possible et battez votre record personnel.',
    seoMemoryGameTitle: 'Jeu de cartes mémoire | 3ToolsPro',
    seoMemoryGameDesc: 'Jouez gratuitement à un jeu de cartes mémoire en ligne pour entraîner votre concentration et votre mémoire à court terme. Suivez votre meilleur score et améliorez votre concentration avec ce jeu cérébral.',
    memoryWhatIs: 'Ce jeu cérébral léger aide les enfants et les adultes à renforcer leur mémoire visuelle et leur concentration en associant des paires de symboles.',
    memoryHow1: 'Appuyez sur une carte pour la révéler.',
    memoryHow2: 'Appuyez sur une deuxième carte pour trouver une paire.',
    memoryHow3: 'Continuez à associer des paires jusqu\'à ce que le plateau soit résolu.',
    memoryHow4: 'Essayez de terminer avec moins de coups à chaque manche.',
    memorySkill1: 'Mémoire de travail',
    memorySkill2: 'Attention visuelle',
    memorySkill3: 'Reconnaissance des formes',
    memoryBenefit1: 'Exercice cérébral quotidien rapide',
    memoryBenefit2: 'Gameplay familial',
    memoryBenefit3: 'Aucun compte ou téléchargement requis',
    memoryFaq1Q: 'Ce jeu sauvegarde-t-il mon meilleur score ?',
    memoryFaq1A: 'Oui, votre meilleur nombre de coups est stocké dans localStorage sur cet appareil.',
    memoryFaq2Q: 'Les enfants peuvent-ils jouer à ce jeu ?',
    memoryFaq2A: 'Oui, il utilise des visuels simples et des commandes adaptées au tactile.',
    numberPuzzleTitle: 'Puzzle numérique',
    numberPuzzleSubtitle: 'Glissez les tuiles dans l\'ordre correct de 1 à 8.',
    seoNumberPuzzleTitle: 'Jeu de puzzle numérique | 3ToolsPro',
    seoNumberPuzzleDesc: 'Jouez gratuitement à un jeu de puzzle numérique 3x3 en ligne. Améliorez vos compétences en résolution de problèmes et en logique, suivez vos meilleurs coups et profitez d\'un défi rapide dans le navigateur.',
    numberPuzzleSolved: 'Excellent travail ! Puzzle résolu en {moves} coups.',
    numberPuzzleWhatIs: 'Le puzzle numérique est un jeu de logique classique où vous glissez des tuiles numérotées pour restaurer l\'ordre correct.',
    numberPuzzleHow1: 'Appuyez sur une tuile à côté de l\'espace vide.',
    numberPuzzleHow2: 'Continuez à déplacer les tuiles une par une.',
    numberPuzzleHow3: 'Disposez les nombres de 1 à 8 dans l\'ordre.',
    numberPuzzleHow4: 'Rejouez et améliorez votre meilleur score.',
    numberPuzzleSkill1: 'Résolution de problèmes',
    numberPuzzleSkill2: 'Planification anticipée',
    numberPuzzleSkill3: 'Raisonnement spatial',
    numberPuzzleBenefit1: 'Exercice cérébral rapide',
    numberPuzzleBenefit2: 'Améliore la patience et la concentration',
    numberPuzzleBenefit3: 'Fonctionne parfaitement sur mobile et ordinateur',
    numberPuzzleFaq1Q: 'Ce jeu nécessite-t-il Internet ?',
    numberPuzzleFaq1A: 'Non. Une fois chargé, le jeu est entièrement côté client.',
    numberPuzzleFaq2Q: 'Le meilleur score est-il sauvegardé ?',
    numberPuzzleFaq2A: 'Oui, votre meilleur nombre de coups est sauvegardé dans localStorage.',
    reactionTestTitle: 'Test de réaction rapide',
    reactionTestSubtitle: 'Mesurez votre vitesse de réflexe et conservez votre meilleur score.',
    seoReactionTestTitle: 'Test de réaction rapide | 3ToolsPro',
    seoReactionTestDesc: 'Testez gratuitement votre vitesse de réaction en ligne. Suivez votre meilleur score de réflexe et améliorez votre concentration avec un jeu de navigateur léger.',
    reactionWhatIs: 'Le test de réaction rapide est un jeu de réflexe simple qui mesure la rapidité avec laquelle vous réagissez à un signal visuel.',
    reactionHow1: 'Appuyez sur Démarrer pour armer le test.',
    reactionHow2: 'Attendez que le panneau devienne vert.',
    reactionHow3: 'Appuyez immédiatement lorsque "prêt" apparaît.',
    reactionHow4: 'Répétez et améliorez votre meilleur temps.',
    reactionSkill1: 'Vitesse de réflexe',
    reactionSkill2: 'Concentration visuelle',
    reactionSkill3: 'Contrôle de la réponse',
    reactionBenefit1: 'Défi quotidien rapide',
    reactionBenefit2: 'Idéal pour tous les âges',
    reactionBenefit3: 'Aucune inscription ou installation',
    reactionFaq1Q: 'Quel est un bon temps de réaction ?',
    reactionFaq1A: 'Pour beaucoup de gens, 200–300 ms est un bon résultat.',
    reactionFaq2Q: 'Puis-je l\'utiliser sur mobile ?',
    reactionFaq2A: 'Oui, le jeu est optimisé pour les taps mobiles.',
    gameMoves: 'Coups',
    gameRestart: 'Redémarrer',
    selectLanguage: 'Choisir la langue',
    more: 'Plus',
    resources: 'Ressources',

    // Home Page
    heroTitle: 'Outils en ligne gratuits pour accélérer votre travail',
    heroSubtitle: 'Outils professionnels pour les tâches quotidiennes. Rapides, sécurisés et sans inscription.',
    startUsing: 'Commencer',
    ourTools: 'Nos Outils',
    ourToolsSubtitle: 'Tous nos outils sont 100% gratuits, fonctionnent instantanément dans votre navigateur et ne nécessitent aucune inscription.',
    allFree: '100% Gratuit',
    instantResults: 'Résultats instantanés',
    noSignup: 'Sans inscription',
    freeAIChat: 'Chat IA Gratuit',

    // Shared UI
    adLabel: 'Publicité',
    adAreaAriaLabel: 'Zone de contenu sponsorisé',
    adPlaceholderLabel: 'Emplacement Google AdSense',
    adPlaceholderBetweenSections: 'Emplacement publicitaire dans le contenu',
    visitSite: 'Visiter le site',
    noSitesFound: 'Aucun site trouvé',
    selectDifferentRegion: 'Essayez de sélectionner une autre région',
    aiServiceUnavailable: 'Service temporairement indisponible',
    aiUnexpectedError: 'Une erreur est survenue. Veuillez réessayer.',

    // Home Card Descriptions
    aiChatDesc: 'Discutez gratuitement avec l\'IA - Usage limité',
    aiToolsDesc: 'Découvrez les meilleurs outils IA',
    footballDesc: 'Dernières actualités football du monde',
    programmingDesc: 'Ressources pour développeurs',
    gamingDesc: 'Meilleures plateformes de jeux',

    // Tools Page
    toolsPageTitle: 'Outils en ligne gratuits',
    toolsPageSubtitle: 'Outils professionnels pour les tâches quotidiennes. Rapides, sécurisés et sans inscription.',

    // Tool Categories
    categoryAll: 'Tous',
    categoryTextContent: 'Texte & Contenu',
    categoryDeveloper: 'Développeur',
    categoryUtility: 'Utilitaire',

    // Tool Names
    toolWordCounter: 'Compteur de mots',
    toolTextCaseConverter: 'Convertisseur de casse',
    toolTextCompare: 'Comparateur de texte',
    toolLoremIpsum: 'Générateur Lorem Ipsum',
    toolJSONFormatter: 'Formateur JSON',
    toolBase64Encoder: 'Encodeur/Décodeur Base64',
    toolURLEncoder: 'Encodeur/Décodeur URL',
    toolPasswordGenerator: 'Générateur de mots de passe',
    toolRandomNumber: 'Générateur de nombres aléatoires',
    toolAgeCalculator: 'Calculateur d\'âge',
    toolUnitConverter: 'Convertisseur d\'unités',
    toolWheelOfFortune: 'Roue de la Fortune',
    toolWheelOfFortuneDesc: 'Faites tourner une roue personnalisable pour choisir un aliment ou un objet aléatoire',

    // AI Chat Status
    connectionStatus: 'Statut',
    aiStatusOnline: 'En ligne',
    aiStatusOffline: 'Mode hors ligne',
    aiLocalModeNotice: 'Le service IA est actuellement indisponible, vous utilisez donc des réponses hors ligne.',
    openChatGPT: 'Ouvrir ChatGPT',
    aiLocalResponse1: 'Je suis hors ligne pour le moment, mais je peux toujours vous aider. Essayez de reformuler votre question ou demandez un aperçu rapide.',
    aiLocalResponse2: 'Voici une suggestion rapide : divisez la tâche en étapes et commencez par la partie la plus importante.',
    aiLocalResponse3: 'Si vous avez besoin de résultats détaillés, réessayez plus tard. Pour l\'instant, je peux fournir un bref résumé ou une liste de contrôle.',

    // Wheel of Fortune UI
    wheelTitle: 'Roue de la Fortune (Sélecteur de nourriture)',
    wheelSubtitle: 'Ajoutez des options, faites tourner la roue et obtenez un choix aléatoire instantanément.',
    wheelSpin: 'Faire tourner la roue',
    wheelSpinning: 'Rotation...',
    wheelResultLabel: 'Résultat sélectionné',
    wheelResultPlaceholder: 'Ajoutez des éléments et tournez pour choisir',
    wheelManageTitle: 'Gérer vos éléments',
    wheelManageSubtitle: 'Ajoutez des aliments ou des options et conservez-les sur cet appareil.',
    wheelInputPlaceholder: 'Tapez un aliment ou un objet',
    wheelAdd: 'Ajouter',
    wheelEmpty: 'Aucun élément pour l\'instant. Ajoutez-en au moins deux pour tourner.',
    wheelRemove: 'Retirer',
    wheelReset: 'Réinitialiser la liste',

    // Tool Content - Age Calculator
    toolAgeWhatTitle: 'Qu\'est-ce que le calculateur d\'âge ?',
    toolAgeWhatDesc: 'Le calculateur d\'âge vous aide à connaître votre âge exact et les étapes clés à partir d\'une date de naissance.',
    toolAgeHowTitle: 'Comment utiliser le calculateur d\'âge',
    toolAgeHow1: 'Sélectionnez votre date de naissance.',
    toolAgeHow2: 'Cliquez sur calculer pour voir les détails de votre âge.',
    toolAgeHow3: 'Consultez les totaux comme les jours, les mois et le prochain anniversaire.',
    toolAgeBenefitsTitle: 'Avantages',
    toolAgeBenefit1: 'Obtenez des détails précis sur l\'âge instantanément.',
    toolAgeBenefit2: 'Voyez des totaux utiles comme les jours et les mois.',
    toolAgeBenefit3: 'Tout fonctionne localement pour la confidentialité.',
    toolAgeFaqTitle: 'FAQ',
    toolAgeFaq1Q: 'Le calcul est-il précis ?',
    toolAgeFaq1A: 'Oui, il utilise la date et l\'heure de votre appareil local pour des résultats précis.',
    toolAgeFaq2Q: 'Ma date est-elle stockée quelque part ?',
    toolAgeFaq2A: 'Non. Tous les calculs se font dans votre navigateur.',

    // Tool Content - Base64
    toolBase64WhatTitle: 'Qu\'est-ce que l\'encodeur/décodeur Base64 ?',
    toolBase64WhatDesc: 'Cet outil convertit le texte en et depuis Base64 pour un transfert et des tests sécurisés.',
    toolBase64HowTitle: 'Comment utiliser l\'outil Base64',
    toolBase64How1: 'Choisissez le mode encodeur ou décodeur.',
    toolBase64How2: 'Collez votre texte ou votre chaîne Base64.',
    toolBase64How3: 'Cliquez sur traiter et copiez le résultat.',
    toolBase64BenefitsTitle: 'Avantages',
    toolBase64Benefit1: 'Convertissez rapidement des données sans téléversement.',
    toolBase64Benefit2: 'Utile pour le développement et le débogage.',
    toolBase64Benefit3: 'Fonctionne entièrement dans votre navigateur.',
    toolBase64FaqTitle: 'FAQ',
    toolBase64Faq1Q: 'Base64 est-il un cryptage ?',
    toolBase64Faq1A: 'Non, Base64 est un format d\'encodage et peut être facilement inversé.',
    toolBase64Faq2Q: 'L\'outil stocke-t-il mes données ?',
    toolBase64Faq2A: 'Non. Vos données restent sur votre appareil.',

    // Tool Content - JSON Formatter
    toolJsonWhatTitle: 'Qu\'est-ce que le formateur JSON ?',
    toolJsonWhatDesc: 'Formatez, validez et minifiez JSON avec une sortie claire et des erreurs instantanées.',
    toolJsonHowTitle: 'Comment utiliser le formateur JSON',
    toolJsonHow1: 'Collez JSON dans la zone de saisie.',
    toolJsonHow2: 'Choisissez formater, minifier ou valider.',
    toolJsonHow3: 'Copiez la sortie une fois prête.',
    toolJsonBenefitsTitle: 'Avantages',
    toolJsonBenefit1: 'Améliorez la lisibilité pour le débogage.',
    toolJsonBenefit2: 'Attrapez les erreurs rapidement avec la validation.',
    toolJsonBenefit3: 'Minifiez JSON pour une utilisation en production.',
    toolJsonFaqTitle: 'FAQ',
    toolJsonFaq1Q: 'Prend-il en charge les tableaux ?',
    toolJsonFaq1A: 'Oui, les tableaux et les objets sont pris en charge.',
    toolJsonFaq2Q: 'Mes données sont-elles envoyées à un serveur ?',
    toolJsonFaq2A: 'Non, tout se passe dans votre navigateur.',

    // Tool Content - Lorem Ipsum
    toolLoremWhatTitle: 'Qu\'est-ce que le générateur Lorem Ipsum ?',
    toolLoremWhatDesc: 'Générez du texte de remplacement pour remplir les mises en page, les maquettes et les ébauches de conception.',
    toolLoremHowTitle: 'Comment utiliser le générateur Lorem Ipsum',
    toolLoremHow1: 'Sélectionnez les paragraphes et les mots par paragraphe.',
    toolLoremHow2: 'Choisissez de commencer par "Lorem" ou non.',
    toolLoremHow3: 'Cliquez sur générer et copiez la sortie.',
    toolLoremBenefitsTitle: 'Avantages',
    toolLoremBenefit1: 'Créez rapidement un remplissage de mise en page réaliste.',
    toolLoremBenefit2: 'Personnalisez la longueur pour n\'importe quel projet.',
    toolLoremBenefit3: 'Aucun téléchargement ou inscription requis.',
    toolLoremFaqTitle: 'FAQ',
    toolLoremFaq1Q: 'Puis-je changer la longueur ?',
    toolLoremFaq1A: 'Oui, vous pouvez contrôler les paragraphes et le nombre de mots.',
    toolLoremFaq2Q: 'Le texte est-il libre de droits ?',
    toolLoremFaq2A: 'Oui, c\'est un texte de remplacement standard.',

    // Tool Content - Password Generator
    toolPasswordWhatTitle: 'Qu\'est-ce que le générateur de mots de passe ?',
    toolPasswordWhatDesc: 'Créez des mots de passe forts avec des options de longueur et de caractères personnalisables.',
    toolPasswordHowTitle: 'Comment utiliser le générateur de mots de passe',
    toolPasswordHow1: 'Ajustez les paramètres de longueur et de caractères.',
    toolPasswordHow2: 'Cliquez sur générer pour créer un mot de passe.',
    toolPasswordHow3: 'Copiez le mot de passe pour l\'utiliser.',
    toolPasswordBenefitsTitle: 'Avantages',
    toolPasswordBenefit1: 'Créez des mots de passe sécurisés instantanément.',
    toolPasswordBenefit2: 'Personnalisez la force selon vos besoins.',
    toolPasswordBenefit3: 'Généré localement pour la confidentialité.',
    toolPasswordFaqTitle: 'FAQ',
    toolPasswordFaq1Q: 'Les mots de passe sont-ils stockés ?',
    toolPasswordFaq1A: 'Non, les mots de passe sont générés localement et jamais sauvegardés.',
    toolPasswordFaq2Q: 'Quelle doit être la longueur des mots de passe ?',
    toolPasswordFaq2A: 'Nous recommandons 12 caractères ou plus pour une sécurité renforcée.',

    // Tool Content - Random Number
    toolRandomWhatTitle: 'Qu\'est-ce que le générateur de nombres aléatoires ?',
    toolRandomWhatDesc: 'Générez des nombres aléatoires dans une plage personnalisée pour les jeux, les tests ou la sélection.',
    toolRandomHowTitle: 'Comment utiliser le générateur de nombres aléatoires',
    toolRandomHow1: 'Définissez votre plage minimale et maximale.',
    toolRandomHow2: 'Choisissez combien de nombres générer.',
    toolRandomHow3: 'Cliquez sur générer et copiez les résultats.',
    toolRandomBenefitsTitle: 'Avantages',
    toolRandomBenefit1: 'Choix aléatoires rapides pour toute tâche.',
    toolRandomBenefit2: 'Prise en charge des résultats uniques ou en double.',
    toolRandomBenefit3: 'Fonctionne instantanément dans votre navigateur.',
    toolRandomFaqTitle: 'FAQ',
    toolRandomFaq1Q: 'Puis-je éviter les doublons ?',
    toolRandomFaq1A: 'Oui, désactivez les doublons pour obtenir des nombres uniques.',
    toolRandomFaq2Q: 'Combien de nombres puis-je générer ?',
    toolRandomFaq2A: 'Jusqu\'à 100 nombres par exécution.',

    // Tool Content - Text Case Converter
    toolCaseWhatTitle: 'Qu\'est-ce que le convertisseur de casse ?',
    toolCaseWhatDesc: 'Convertissez le texte en différentes casses pour l\'écriture, le formatage et le codage.',
    toolCaseHowTitle: 'Comment utiliser le convertisseur de casse',
    toolCaseHow1: 'Collez ou tapez votre texte.',
    toolCaseHow2: 'Sélectionnez la casse que vous souhaitez appliquer.',
    toolCaseHow3: 'Copiez le texte mis à jour.',
    toolCaseBenefitsTitle: 'Avantages',
    toolCaseBenefit1: 'Uniformisez instantanément le formatage du texte.',
    toolCaseBenefit2: 'Utile pour les titres, en-têtes et code.',
    toolCaseBenefit3: 'Aucune donnée ne quitte votre navigateur.',
    toolCaseFaqTitle: 'FAQ',
    toolCaseFaq1Q: 'Puis-je convertir un texte long ?',
    toolCaseFaq1A: 'Oui, les grands blocs de texte sont pris en charge.',
    toolCaseFaq2Q: 'Conserve-t-il la ponctuation ?',
    toolCaseFaq2A: 'Oui, la ponctuation reste inchangée.',

    // Tool Content - Text Compare
    toolCompareWhatTitle: 'Qu\'est-ce que l\'outil de comparaison de texte ?',
    toolCompareWhatDesc: 'Comparez deux textes ligne par ligne pour trouver les changements, ajouts et suppressions.',
    toolCompareHowTitle: 'Comment utiliser l\'outil de comparaison de texte',
    toolCompareHow1: 'Collez le texte original dans la première boîte.',
    toolCompareHow2: 'Collez le texte modifié dans la deuxième boîte.',
    toolCompareHow3: 'Cliquez sur comparer pour voir les différences.',
    toolCompareBenefitsTitle: 'Avantages',
    toolCompareBenefit1: 'Repérez rapidement les changements lors des révisions.',
    toolCompareBenefit2: 'Mise en évidence claire des modifications et mises à jour.',
    toolCompareBenefit3: 'Idéal pour les rédacteurs et les développeurs.',
    toolCompareFaqTitle: 'FAQ',
    toolCompareFaq1Q: 'Compare-t-il ligne par ligne ?',
    toolCompareFaq1A: 'Oui, il compare le texte ligne par ligne.',
    toolCompareFaq2Q: 'Mon texte est-il stocké ?',
    toolCompareFaq2A: 'Non, les comparaisons se font localement.',

    // Tool Content - URL Encoder
    toolUrlWhatTitle: 'Qu\'est-ce que l\'encodeur/décodeur URL ?',
    toolUrlWhatDesc: 'Encodez ou décodez des URLs pour gérer en toute sécurité les caractères spéciaux dans les liens web.',
    toolUrlHowTitle: 'Comment utiliser l\'encodeur URL',
    toolUrlHow1: 'Sélectionnez le mode encodeur ou décodeur.',
    toolUrlHow2: 'Collez votre URL ou texte.',
    toolUrlHow3: 'Cliquez sur traiter et copiez le résultat.',
    toolUrlBenefitsTitle: 'Avantages',
    toolUrlBenefit1: 'Évitez les liens brisés dans les formulaires web.',
    toolUrlBenefit2: 'Idéal pour les API et les chaînes de requête.',
    toolUrlBenefit3: 'Traitement rapide basé sur le navigateur.',
    toolUrlFaqTitle: 'FAQ',
    toolUrlFaq1Q: 'Quels caractères sont encodés ?',
    toolUrlFaq1A: 'Les espaces et les caractères spéciaux sont convertis en codes sécurisés.',
    toolUrlFaq2Q: 'Prend-il en charge les URLs complètes ?',
    toolUrlFaq2A: 'Oui, il fonctionne avec les URLs complètes et les chaînes de requête.',

    // Tool Content - Unit Converter
    toolUnitWhatTitle: 'Qu\'est-ce que le convertisseur d\'unités ?',
    toolUnitWhatDesc: 'Convertissez entre les unités courantes pour la longueur, le poids, la température, le volume et le temps.',
    toolUnitHowTitle: 'Comment utiliser le convertisseur d\'unités',
    toolUnitHow1: 'Choisissez une catégorie comme la longueur ou la température.',
    toolUnitHow2: 'Sélectionnez les unités à convertir.',
    toolUnitHow3: 'Entrez une valeur pour voir les résultats instantanément.',
    toolUnitBenefitsTitle: 'Avantages',
    toolUnitBenefit1: 'Conversions précises en quelques secondes.',
    toolUnitBenefit2: 'Prend en charge plusieurs catégories.',
    toolUnitBenefit3: 'Facile à utiliser sur n\'importe quel appareil.',
    toolUnitFaqTitle: 'FAQ',
    toolUnitFaq1Q: 'Quelles unités sont prises en charge ?',
    toolUnitFaq1A: 'Longueur, poids, température, volume et temps.',
    toolUnitFaq2Q: 'La conversion est-elle précise ?',
    toolUnitFaq2A: 'Oui, des facteurs de conversion standard sont utilisés.',

    // Tool Content - Wheel of Fortune
    wheelWhatTitle: 'Qu\'est-ce que l\'outil Roue de la Fortune ?',
    wheelWhatDesc: 'Un sélecteur interactif amusant qui vous aide à décider en faisant tourner une roue personnalisable.',
    wheelHowTitle: 'Comment utiliser la Roue de la Fortune',
    wheelHow1: 'Ajoutez des aliments ou des objets à votre liste.',
    wheelHow2: 'Cliquez sur tourner pour animer la roue.',
    wheelHow3: 'Voyez le résultat sélectionné instantanément.',
    wheelBenefitsTitle: 'Avantages',
    wheelBenefit1: 'Idéal pour les décisions rapides et les choix de groupe.',
    wheelBenefit2: 'Les éléments sont sauvegardés localement sur votre appareil.',
    wheelBenefit3: 'Fonctionne parfaitement sur mobile et ordinateur.',
    wheelFaqTitle: 'FAQ',
    wheelFaq1Q: 'Mes éléments sont-ils sauvegardés ?',
    wheelFaq1A: 'Oui, les éléments sont stockés dans localStorage sur votre appareil.',
    wheelFaq2Q: 'Puis-je réinitialiser la liste ?',
    wheelFaq2A: 'Oui, utilisez le bouton réinitialiser pour effacer tous les éléments.',

    // Tools Features
    featureFast: 'Ultra rapide',
    featureFastDesc: 'Tous les outils fonctionnent dans votre navigateur',
    featureSecure: '100% Sécurisé',
    featureSecureDesc: 'Vos données ne quittent jamais votre appareil',
    featureFree: 'Totalement gratuit',
    featureFreeDesc: 'Sans inscription, sans limites, sans frais cachés',

    // AI Chat
    freeAIChatTitle: 'Chat IA Gratuit',
    freeAIChatSubtitle: 'Discutez avec l\'assistant IA',
    fairUsagePolicy: 'Chat IA Gratuit – Politique d\'usage équitable',
    disclaimer: 'Avertissement',
    aiDisclaimer: 'Ceci est un chat IA gratuit. Les réponses sont générées par un modèle IA et peuvent ne pas toujours être exactes. Pour un chat professionnel illimité, essayez ChatGPT, Claude ou Gemini.',
    startConversation: 'Commencez une conversation ! Demandez-moi n\'importe quoi.',
    exampleQuestions: 'Essayez: "Raconte-moi une blague" ou "Qu\'est-ce que l\'IA?"',
    aiThinking: 'L\'IA réfléchit...',
    typePlaceholder: 'Tapez votre message...',
    sendMessage: 'Envoyer',
    pressEnter: 'Appuyez sur Entrée',
    freeServiceNotice: 'Service gratuit avec limites d\'usage',
    aboutFreeAIChat: 'À propos du Chat IA',
    poweredByHF: 'Propulsé par Hugging Face - IA gratuite et open-source',
    refreshToReset: 'Actualisez pour une nouvelle conversation',
    responsesDelay: 'Réponses en 3-5 secondes',
    engagementOnly: 'Ce chat est pour l\'apprentissage',
    unlimitedAI: 'Pour un chat illimité: ChatGPT, Claude ou Gemini',
    aiNoResponse: 'Désolé, impossible de générer une réponse.',
    aiFallbackMessage: 'Je rencontre des difficultés de connexion. Réessayez ou actualisez la page.',

    // AI Tools Page
    aiToolsTitle: 'Répertoire des outils IA',
    aiToolsSubtitle: 'Découvrez les meilleurs outils IA',
    searchPlaceholder: 'Que voulez-vous faire?',
    allCategories: 'Toutes catégories',
    visitTool: 'Visiter',
    free: 'Gratuit',
    foundToolsFor: '{count} outils trouvés pour "{query}"',
    noAIToolsFound: 'Aucun outil IA trouvé',
    adjustSearchFilter: 'Essayez d\'ajuster votre recherche ou le filtre',

    // Football
    footballTitle: 'Sites d\'actualités football',
    footballSubtitle: 'Dernières actualités football du monde entier',

    // Programming
    programmingTitle: 'Ressources de programmation',
    programmingSubtitle: 'Apprenez et progressez comme développeur',

    // Gaming
    gamingTitle: 'Sites de jeux',
    gamingSubtitle: 'Meilleures plateformes de jeux',

    // SEO
    seoHomeTitle: '3ToolsPro - Outils en ligne gratuits pour le quotidien',
    seoHomeDesc: 'Accédez à des outils gratuits pour le texte, les développeurs et les utilitaires. Rapides, sûrs et conçus pour des résultats professionnels.',
    seoToolsTitle: 'Bibliothèque d’outils en ligne gratuits | 3ToolsPro',
    seoToolsDesc: 'Parcourez une collection d’outils gratuits pour la productivité, le texte, le développement et les utilitaires.',
    seoAiChatTitle: 'Chat IA gratuit avec usage équitable | 3ToolsPro',
    seoAiChatDesc: 'Discutez avec un assistant IA gratuit pour des réponses rapides. Des limites d’usage équitable s’appliquent pour tous.',
    seoAiToolsTitle: 'Répertoire d’outils IA | 3ToolsPro',
    seoAiToolsDesc: 'Explorez des outils IA vérifiés pour l’écriture, l’image, la vidéo et la productivité.',
    seoFootballTitle: 'Sources d’actualités football | 3ToolsPro',
    seoFootballDesc: 'Trouvez des sites d’actualités football fiables dans le monde entier.',
    seoProgrammingTitle: 'Ressources de programmation | 3ToolsPro',
    seoProgrammingDesc: 'Découvrez des ressources, documentation, outils et liens d’apprentissage pour développeurs.',
    seoGamingTitle: 'Ressources gaming | 3ToolsPro',
    seoGamingDesc: 'Explorez plateformes, téléchargements, actualités et communautés de jeux.',
    seoAboutTitle: 'À propos de 3ToolsPro',
    seoAboutDesc: 'Découvrez 3ToolsPro, notre mission et notre engagement pour des outils gratuits en ligne.',
    seoContactTitle: 'Contactez 3ToolsPro',
    seoContactDesc: 'Contactez l’équipe 3ToolsPro pour support, retours ou partenariats.',
    seoHowToUseTitle: 'Comment utiliser 3ToolsPro',
    seoHowToUseDesc: 'Guide étape par étape pour utiliser efficacement les outils 3ToolsPro.',
    seoPrivacyTitle: 'Politique de confidentialité | 3ToolsPro',
    seoPrivacyDesc: 'Découvrez comment 3ToolsPro traite les données, la confidentialité et la sécurité.',
    seoTermsTitle: 'Conditions d’utilisation | 3ToolsPro',
    seoTermsDesc: 'Consultez les conditions d’utilisation de 3ToolsPro et de ses outils gratuits.',
    seoWordCounterTitle: 'Compteur de mots | 3ToolsPro',
    seoWordCounterDesc: 'Comptez les mots, caractères, phrases et paragraphes instantanément. Parfait pour les rédacteurs, étudiants et vérifications SEO avec une analyse privée dans le navigateur.',
    seoTextCaseTitle: 'Convertisseur de casse | 3ToolsPro',
    seoTextCaseDesc: 'Convertissez le texte en majuscules, minuscules, casse titre, casse phrase, etc. Formatage rapide et précis pour les tâches d\'écriture et de codage.',
    seoTextCompareTitle: 'Outil de comparaison de texte | 3ToolsPro',
    seoTextCompareDesc: 'Comparez deux textes ligne par ligne pour trouver les ajouts, suppressions et changements. Idéal pour l\'édition, les révisions et les vérifications de contenu.',
    seoLoremIpsumTitle: 'Générateur Lorem Ipsum | 3ToolsPro',
    seoLoremIpsumDesc: 'Générez du texte de remplacement Lorem Ipsum personnalisable par paragraphes ou mots. Utile pour les maquettes, mises en page et ébauches de conception.',
    seoJsonFormatterTitle: 'Formateur JSON | 3ToolsPro',
    seoJsonFormatterDesc: 'Formatez, validez et minifiez JSON avec une sortie lisible et des erreurs instantanées. Parfait pour les développeurs et le nettoyage de données.',
    seoBase64Title: 'Encodeur/Décodeur Base64 | 3ToolsPro',
    seoBase64Desc: 'Encodez ou décodez des chaînes Base64 en toute sécurité dans votre navigateur. Idéal pour le transfert de données, les tests et les flux de développement.',
    seoUrlEncoderTitle: 'Encodeur/Décodeur URL | 3ToolsPro',
    seoUrlEncoderDesc: 'Encodez ou décodez des URLs pour gérer correctement les espaces et les caractères spéciaux. Utile pour les formulaires web, les API et le débogage.',
    seoPasswordGeneratorTitle: 'Générateur de mots de passe | 3ToolsPro',
    seoPasswordGeneratorDesc: 'Créez des mots de passe forts et sécurisés avec des options de longueur et de caractères personnalisables. Généré localement pour la confidentialité.',
    seoRandomNumberTitle: 'Générateur de nombres aléatoires | 3ToolsPro',
    seoRandomNumberDesc: 'Générez des nombres aléatoires dans une plage, avec des résultats uniques optionnels. Utile pour les jeux, les tests et les choix rapides.',
    seoAgeCalculatorTitle: 'Calculateur d\'âge | 3ToolsPro',
    seoAgeCalculatorDesc: 'Calculez votre âge exact avec des statistiques détaillées, y compris les mois, les jours et le prochain anniversaire. Rapide et privé.',
    seoUnitConverterTitle: 'Convertisseur d\'unités | 3ToolsPro',
    seoUnitConverterDesc: 'Convertissez instantanément les unités de longueur, de poids, de température, de volume et de temps avec des résultats précis et une interface facile.',
    seoWheelTitle: 'Sélecteur Roue de la Fortune | 3ToolsPro',
    seoWheelDesc: 'Faites tourner une roue personnalisable pour choisir de la nourriture ou n\'importe quel article. Sauvegardez votre liste localement et obtenez des résultats instantanés sur n\'importe quel appareil.',

    // Footer
    footerTagline: 'Outils gratuits professionnels pour tous',
    footerCopyright: '© 2025 3ToolsPro. Tous droits réservés.',
    quickLinks: 'Liens rapides',
    legalInfo: 'Juridique & Info',

    // Common
    copy: 'Copier',
    copied: 'Copié!',
    clear: 'Effacer',
    generate: 'Générer',
    encode: 'Encoder',
    decode: 'Décoder',
    format: 'Formater',
    validate: 'Valider',
    compare: 'Comparer',
    calculate: 'Calculer',
    owner: 'Propriétaire',
    email: 'E-mail',
    supportEmail: 'E-mail support',

    // About Page
    aboutUs: 'À propos',
    aboutSubtitle: 'Découvrez 3ToolsPro et notre mission',
    ourMission: 'Notre mission',
    missionText: '3ToolsPro a été créé pour fournir des outils gratuits de haute qualité. Nous croyons que les outils de productivité doivent être accessibles à tous.',
    missionText2: 'Notre plateforme offre une collection d\'outils gratuits. Tous fonctionnent dans votre navigateur, garantissant la confidentialité.',
    whatWeOffer: 'Ce que nous offrons',
    offer1: 'Outils texte: Compteur de mots, convertisseur de casse',
    offer2: 'Outils de conversion: JSON, Base64, URL',
    offer3: 'Outils de sécurité: Générateur de mots de passe',
    offer4: 'Chat IA pour réponses rapides',
    offer5: 'Répertoire des meilleurs outils IA',
    contactInfo: 'Coordonnées',

    // Contact Page
    contactUs: 'Contactez-nous',
    contactSubtitle: 'Prenez contact - nous aimerions vous entendre',
    socialMedia: 'Réseaux sociaux',
    needHelp: 'Besoin d\'aide?',
    contactText: 'Si vous avez des questions, n\'hésitez pas à nous contacter. Nous répondons sous 24-48 heures.',

    // Privacy Policy
    privacyPolicy: 'Politique de confidentialité',
    lastUpdated: 'Dernière mise à jour',
    introduction: 'Introduction',
    privacyIntro: 'Chez 3ToolsPro, nous prenons votre confidentialité au sérieux. Cette politique explique comment nous collectons et protégeons vos informations.',
    dataCollection: 'Informations collectées',
    dataCollectionText: 'Nous collectons un minimum d\'informations:',
    dataItem1: 'Données d\'utilisation: Pages visitées (via Google Analytics)',
    dataItem2: 'Informations appareil: Type de navigateur, OS',
    dataItem3: 'Adresse IP: Pour sécurité (anonymisée)',
    howWeUseData: 'Utilisation des informations',
    useItem1: 'Fournir et maintenir nos outils gratuits',
    useItem2: 'Analyser l\'utilisation et améliorer l\'expérience',
    useItem3: 'Afficher des publicités via Google AdSense',
    cookies: 'Cookies',
    cookiesText: 'Nous utilisons des cookies pour améliorer votre expérience et mémoriser vos préférences.',
    thirdParty: 'Services tiers',
    thirdPartyText: 'Nous utilisons les services tiers suivants:',
    dataSecurity: 'Sécurité des données',
    dataSecurityText: 'Tous les outils fonctionnent dans votre navigateur. Vos données ne sont pas envoyées à nos serveurs.',
    yourRights: 'Vos droits',
    right1: 'Accès: Demander les données collectées',
    right2: 'Suppression: Demander la suppression',
    right3: 'Opt-out: Désactiver le suivi',
    privacyContactText: 'Questions sur la confidentialité? Contactez-nous:',

    // Terms of Service
    termsOfService: 'Conditions d\'utilisation',
    acceptanceOfTerms: 'Acceptation des conditions',
    acceptanceText: 'En utilisant 3ToolsPro, vous acceptez ces conditions. Si vous n\'êtes pas d\'accord, n\'utilisez pas nos services.',
    useOfService: 'Utilisation du service',
    useOfServiceText: 'Nos outils sont gratuits pour usage personnel et commercial:',
    serviceRule1: 'Utilisez nos outils pour tout usage légal',
    serviceRule2: 'Ne tentez pas de copier nos outils',
    serviceRule3: 'N\'utilisez pas nos services pour des activités illégales',
    serviceRule4: 'Ne surchargez pas nos services',
    intellectualProperty: 'Propriété intellectuelle',
    intellectualPropertyText: 'Tout le contenu est protégé par les lois de propriété intellectuelle.',
    userContent: 'Contenu utilisateur',
    userContentText: 'Vos données sont traitées localement et non stockées sur nos serveurs.',
    disclaimerText: 'Nos outils sont fournis "tels quels" sans garantie.',
    disclaimerWarning: 'UTILISEZ À VOS RISQUES. Nous ne sommes pas responsables des pertes de données.',
    limitationOfLiability: 'Limitation de responsabilité',
    limitationText: 'Nous ne serons pas responsables des dommages indirects.',
    modifications: 'Modifications',
    modificationsText: 'Nous pouvons modifier ces conditions à tout moment.',
    governingLaw: 'Loi applicable',
    governingLawText: 'Ces conditions sont régies par les lois d\'Égypte.',
    termsContactText: 'Questions sur les conditions? Contactez-nous:',

    // How To Use Page
    howToUse: 'Comment utiliser',
    howToUseSubtitle: 'Commencez avec 3ToolsPro - facile et gratuit!',
    step1Title: 'Étape 1: Choisissez votre outil',
    step1Text: 'Parcourez notre collection d\'outils gratuits:',
    step1Item1: 'Outils texte: Compteur de mots, convertisseur',
    step1Item2: 'Outils données: JSON, Base64, URL',
    step1Item3: 'Utilitaires: Mots de passe, âge, unités',
    step2Title: 'Étape 2: Utilisez l\'outil',
    step2Text: 'Chaque outil est simple:',
    step2Item1: 'Entrez vos données',
    step2Item2: 'Cliquez sur le bouton d\'action',
    step2Item3: 'Résultats instantanés!',
    step3Title: 'Étape 3: Copiez vos résultats',
    step3Text: 'Une fois terminé:',
    step3Item1: 'Cliquez "Copier"',
    step3Item2: 'Téléchargez si disponible',
    step3Item3: 'Effacez et recommencez',
    step4Title: 'Étape 4: Explorez',
    step4Text: 'Consultez notre répertoire IA, ressources football, programmation et jeux. Essayez le chat IA gratuit!',
    helpText: 'Besoin d\'aide ou suggestions? Contactez-nous:',

    wordCounterPage: {
      title: 'Compteur de mots',
      subtitle: 'Comptez les mots, caractères, phrases, paragraphes et le temps de lecture instantanément',
      whyTitle: 'Pourquoi utiliser ce compteur de mots ?',
      why1: 'Vérifier la longueur des articles pour l’optimisation SEO',
      why2: 'Compter les caractères pour les limites des réseaux sociaux',
      why3: 'Améliorer la productivité et la précision de l’écriture',
      why4: 'Estimer automatiquement le temps de lecture',
      why5: 'Analyser le texte instantanément sans téléverser de fichiers',
      howTitle: 'Comment utiliser l’outil Compteur de mots :',
      how1: 'Tapez ou collez votre texte dans la zone ci-dessus',
      how2: 'Les statistiques se mettent à jour automatiquement pendant la saisie',
      how3: 'Le temps de lecture est calculé sur la base de 200 mots par minute',
      how4: 'Tout le traitement se fait dans votre navigateur — votre texte n’est pas stocké',
      faq: 'FAQ',
      faq1q: 'Cet outil est-il gratuit ?',
      faq1a: 'Oui, cet outil est entièrement gratuit avec une utilisation illimitée.',
      faq2q: 'Mon texte est-il enregistré ?',
      faq2a: 'Non. Tout le traitement se fait localement dans votre navigateur.',
      faq3q: 'Qui peut utiliser cet outil ?',
      faq3a: 'Rédacteurs, étudiants, marketeurs, développeurs et toute personne travaillant avec du texte.',
  toolWordCounterDesc: "Comptez instantanément les mots et les caractères.",
  toolJSONFormatterDesc: "Formatez, validez et embellissez les données JSON.",
  toolPasswordGeneratorDesc: "Générez des mots de passe sécurisés et aléatoires.",
  toolBase64EncoderDesc: "Encodez et décodez facilement des chaînes Base64.",
  toolAgeCalculatorDesc: "Calculez l'âge à partir de la date de naissance instantanément.",
  toolTextCaseConverterDesc: "Convertissez le texte entre différents styles de casse."
    },
    seo: {
      wordCounterTitle: 'Compteur de mots gratuit - Comptez mots, caractères et phrases en ligne',
      wordCounterDesc: 'Outil gratuit pour compter mots, caractères, phrases et temps de lecture instantanément.'
    }
  },
  es: {
    // Navigation
    home: 'Inicio',
    tools: 'Herramientas',
    aiChat: 'Chat IA Gratis',
    aiToolsDirectory: 'Directorio IA',
    footballNews: 'Noticias Fútbol',
    programming: 'Programación',
    gaming: 'Juegos',
    gamesHub: 'Juegos de inteligencia',
    gamesHubTitle: 'Juegos de entrenamiento cerebral y CI',
    gamesHubSubtitle: 'Juega gratis a juegos de memoria, lógica, reacción y programación para mejorar la concentración y mantener tu cerebro activo.',
    seoGamesTitle: 'Juegos de CI en línea | 3ToolsPro',
    seoGamesDesc: 'Juega gratis a juegos de CI y entrenamiento cerebral en línea, incluyendo desafíos de memoria, rompecabezas, reacción y código. Compatible con móviles y completamente basado en navegador.',
    gameWhatIsTitle: 'Qué es',
    gameHowToPlayTitle: 'Cómo jugar',
    gameSkillsTitle: 'Habilidades mejoradas',
    gameBenefitsTitle: 'Beneficios',
    gameFaqTitle: 'FAQ',
    gameRelatedTitle: 'Herramientas y juegos relacionados',
    gameScore: 'Puntuación',
    gameBest: 'Mejor',
    gameQuestion: 'Pregunta',
    gameNextQuestion: 'Siguiente pregunta',
    difficultyEasy: 'Fácil',
    difficultyMedium: 'Medio',
    difficultyHard: 'Difícil',
    codeOutputTitle: 'Adivinar la salida del código',
    codeOutputSubtitle: 'Un juego mental para desarrolladores para agudizar el razonamiento en JavaScript.',
    seoCodeOutputTitle: 'Juego Adivinar la salida del código | 3ToolsPro',
    seoCodeOutputDesc: 'Juega gratis a un juego de CI de programación y adivina la salida de JavaScript. Practica lógica, mentalidad de depuración e intuición de desarrollador en tu navegador.',
    codeOutputWhatIs: 'Adivinar la salida del código es un desafío de programación ligero para desarrolladores y estudiantes. Entrena el análisis rápido de sintaxis, alcance y comportamiento en tiempo de ejecución.',
    codeOutputHow1: 'Elige un nivel de dificultad.',
    codeOutputHow2: 'Lee el fragmento de JavaScript con atención.',
    codeOutputHow3: 'Selecciona la salida que creas correcta.',
    codeOutputHow4: 'Pasa a la siguiente pregunta y mejora tu puntuación.',
    codeOutputSkill1: 'Mentalidad de depuración',
    codeOutputSkill2: 'Fundamentos de JavaScript',
    codeOutputSkill3: 'Intuición de complejidad temporal',
    codeOutputBenefit1: 'Mayor compromiso del desarrollador',
    codeOutputBenefit2: 'Práctica útil para entrevistas',
    codeOutputBenefit3: 'Hábito de aprendizaje diario rápido',
    codeOutputFaq1Q: '¿Las preguntas son aptas para principiantes?',
    codeOutputFaq1A: 'Sí. El modo fácil está diseñado para la práctica fundamental.',
    codeOutputFaq2Q: '¿Se guarda la puntuación?',
    codeOutputFaq2A: 'La mejor puntuación se guarda localmente en tu navegador.',
    memoryGameTitle: 'Juego de cartas de memoria',
    memoryGameSubtitle: 'Empareja todos los pares en la menor cantidad de movimientos y supera tu mejor marca personal.',
    seoMemoryGameTitle: 'Juego de cartas de memoria | 3ToolsPro',
    seoMemoryGameDesc: 'Juega gratis a un juego de cartas de memoria en línea para entrenar la concentración y la memoria a corto plazo. Sigue tu mejor puntuación y mejora la concentración con este juego cerebral.',
    memoryWhatIs: 'Este juego cerebral ligero ayuda a niños y adultos a fortalecer la memoria visual y la concentración emparejando pares de símbolos.',
    memoryHow1: 'Toca una carta para revelarla.',
    memoryHow2: 'Toca una segunda carta para encontrar una coincidencia.',
    memoryHow3: 'Sigue emparejando hasta que el tablero esté resuelto.',
    memoryHow4: 'Intenta terminar con menos movimientos cada ronda.',
    memorySkill1: 'Memoria de trabajo',
    memorySkill2: 'Atención visual',
    memorySkill3: 'Reconocimiento de patrones',
    memoryBenefit1: 'Ejercicio cerebral diario rápido',
    memoryBenefit2: 'Juego familiar',
    memoryBenefit3: 'No requiere cuenta ni descarga',
    memoryFaq1Q: '¿Este juego guarda mi mejor puntuación?',
    memoryFaq1A: 'Sí, tu mejor número de movimientos se almacena en localStorage en este dispositivo.',
    memoryFaq2Q: '¿Pueden jugar los niños?',
    memoryFaq2A: 'Sí, utiliza imágenes simples y controles táctiles.',
    numberPuzzleTitle: 'Rompecabezas numérico',
    numberPuzzleSubtitle: 'Desliza las fichas al orden correcto del 1 al 8.',
    seoNumberPuzzleTitle: 'Juego de rompecabezas numérico | 3ToolsPro',
    seoNumberPuzzleDesc: 'Juega gratis a un juego de rompecabezas numérico 3x3 en línea. Mejora tus habilidades de resolución de problemas y lógica, sigue tus mejores movimientos y disfruta de un desafío rápido en el navegador.',
    numberPuzzleSolved: '¡Buen trabajo! Rompecabezas resuelto en {moves} movimientos.',
    numberPuzzleWhatIs: 'El rompecabezas numérico es un juego de lógica clásico donde deslizas fichas numeradas para restaurar el orden correcto.',
    numberPuzzleHow1: 'Toca una ficha junto al espacio vacío.',
    numberPuzzleHow2: 'Continúa moviendo fichas de una en una.',
    numberPuzzleHow3: 'Ordena los números del 1 al 8.',
    numberPuzzleHow4: 'Repite y mejora tu mejor puntuación.',
    numberPuzzleSkill1: 'Resolución de problemas',
    numberPuzzleSkill2: 'Planificación anticipada',
    numberPuzzleSkill3: 'Razonamiento espacial',
    numberPuzzleBenefit1: 'Ejercicio cerebral rápido',
    numberPuzzleBenefit2: 'Mejora la paciencia y la concentración',
    numberPuzzleBenefit3: 'Funciona sin problemas en móvil y escritorio',
    numberPuzzleFaq1Q: '¿Este juego requiere internet?',
    numberPuzzleFaq1A: 'No. Una vez cargado, el juego es completamente del lado del cliente.',
    numberPuzzleFaq2Q: '¿Se guarda la mejor puntuación?',
    numberPuzzleFaq2A: 'Sí, tu mejor número de movimientos se guarda en localStorage.',
    reactionTestTitle: 'Prueba de reacción rápida',
    reactionTestSubtitle: 'Mide tu velocidad de reflejos y mantén tu mejor puntuación.',
    seoReactionTestTitle: 'Prueba de reacción rápida | 3ToolsPro',
    seoReactionTestDesc: 'Prueba tu velocidad de reacción en línea gratis. Sigue tu mejor puntuación de reflejos y mejora la concentración con un juego de navegador ligero.',
    reactionWhatIs: 'La prueba de reacción rápida es un juego de reflejos simple que mide la rapidez con la que reaccionas a una señal visual.',
    reactionHow1: 'Presiona Inicio para armar la prueba.',
    reactionHow2: 'Espera hasta que el panel se ponga verde.',
    reactionHow3: 'Toca inmediatamente cuando aparezca "listo".',
    reactionHow4: 'Repite y mejora tu mejor tiempo.',
    reactionSkill1: 'Velocidad de reflejos',
    reactionSkill2: 'Enfoque visual',
    reactionSkill3: 'Control de respuesta',
    reactionBenefit1: 'Desafío diario rápido',
    reactionBenefit2: 'Excelente para todas las edades',
    reactionBenefit3: 'Sin registro ni instalación',
    reactionFaq1Q: '¿Cuál es un buen tiempo de reacción?',
    reactionFaq1A: 'Para muchas personas, 200–300 ms es un buen resultado.',
    reactionFaq2Q: '¿Puedo usarlo en móvil?',
    reactionFaq2A: 'Sí, el juego está optimizado para toques en móvil.',
    gameMoves: 'Movimientos',
    gameRestart: 'Reiniciar',
    selectLanguage: 'Seleccionar idioma',
    more: 'Más',
    resources: 'Recursos',

    // Home Page
    heroTitle: 'Herramientas en línea gratuitas para acelerar tu trabajo',
    heroSubtitle: 'Herramientas profesionales para tareas diarias. Rápidas, seguras y sin registro.',
    startUsing: 'Empezar',
    ourTools: 'Nuestras Herramientas',
    ourToolsSubtitle: 'Todas nuestras herramientas son 100% gratis, funcionan instantáneamente y no requieren registro.',
    allFree: '100% Gratis',
    instantResults: 'Resultados instantáneos',
    noSignup: 'Sin registro',
    freeAIChat: 'Chat IA Gratis',

    // Shared UI
    adLabel: 'Anuncio',
    adAreaAriaLabel: 'Área de contenido patrocinado',
    adPlaceholderLabel: 'Ubicación de Google AdSense',
    adPlaceholderBetweenSections: 'Ubicación de anuncio en contenido',
    visitSite: 'Visitar sitio',
    noSitesFound: 'No se encontraron sitios',
    selectDifferentRegion: 'Intenta seleccionar otra región',
    aiServiceUnavailable: 'Servicio no disponible temporalmente',
    aiUnexpectedError: 'Algo salió mal. Por favor, inténtalo de nuevo.',

    // Home Card Descriptions
    aiChatDesc: 'Chatea gratis con IA - Uso limitado',
    aiToolsDesc: 'Descubre las mejores herramientas IA',
    footballDesc: 'Últimas noticias de fútbol del mundo',
    programmingDesc: 'Recursos para desarrolladores',
    gamingDesc: 'Mejores plataformas de juegos',

    // Tools Page
    toolsPageTitle: 'Herramientas en línea gratuitas',
    toolsPageSubtitle: 'Herramientas profesionales para tareas diarias. Rápidas, seguras y sin registro.',

    // Tool Categories
    categoryAll: 'Todas',
    categoryTextContent: 'Texto y Contenido',
    categoryDeveloper: 'Desarrollador',
    categoryUtility: 'Utilidad',

    // Tool Names
    toolWordCounter: 'Contador de palabras',
    toolTextCaseConverter: 'Convertidor de mayúsculas',
    toolTextCompare: 'Comparador de texto',
    toolLoremIpsum: 'Generador Lorem Ipsum',
    toolJSONFormatter: 'Formateador JSON',
    toolBase64Encoder: 'Codificador/Decodificador Base64',
    toolURLEncoder: 'Codificador/Decodificador URL',
    toolPasswordGenerator: 'Generador de contraseñas',
    toolRandomNumber: 'Generador de números aleatorios',
    toolAgeCalculator: 'Calculadora de edad',
    toolUnitConverter: 'Convertidor de unidades',
    toolWheelOfFortune: 'Ruleta de la Fortuna',
    toolWheelOfFortuneDesc: 'Gira una ruleta personalizable para elegir una comida o artículo aleatorio',

    // AI Chat Status
    connectionStatus: 'Estado',
    aiStatusOnline: 'En línea',
    aiStatusOffline: 'Modo sin conexión',
    aiLocalModeNotice: 'El servicio de IA no está disponible actualmente, por lo que estás usando respuestas sin conexión.',
    openChatGPT: 'Abrir ChatGPT',
    aiLocalResponse1: 'Estoy desconectado ahora, pero aún puedo ayudar. Intenta refinar tu pregunta o pide un esquema rápido.',
    aiLocalResponse2: 'Aquí hay una sugerencia rápida: divide la tarea en pasos y comienza con la parte más importante.',
    aiLocalResponse3: 'Si necesitas resultados detallados, inténtalo más tarde. Por ahora, puedo proporcionar un breve resumen o lista de verificación.',

    // Wheel of Fortune UI
    wheelTitle: 'Ruleta de la Fortuna (Selector de comida)',
    wheelSubtitle: 'Añade opciones, gira la ruleta y obtén una selección aleatoria al instante.',
    wheelSpin: 'Girar la ruleta',
    wheelSpinning: 'Girando...',
    wheelResultLabel: 'Resultado seleccionado',
    wheelResultPlaceholder: 'Añade elementos y gira para elegir',
    wheelManageTitle: 'Gestiona tus elementos',
    wheelManageSubtitle: 'Añade comidas u opciones y mantenlos guardados en este dispositivo.',
    wheelInputPlaceholder: 'Escribe una comida o artículo',
    wheelAdd: 'Añadir',
    wheelEmpty: 'Aún no hay elementos. Añade al menos dos para girar.',
    wheelRemove: 'Eliminar',
    wheelReset: 'Restablecer lista',

    // Tool Content - Age Calculator
    toolAgeWhatTitle: '¿Qué es la calculadora de edad?',
    toolAgeWhatDesc: 'La calculadora de edad te ayuda a encontrar tu edad exacta y los hitos clave a partir de una fecha de nacimiento.',
    toolAgeHowTitle: 'Cómo usar la calculadora de edad',
    toolAgeHow1: 'Selecciona tu fecha de nacimiento.',
    toolAgeHow2: 'Haz clic en calcular para ver los detalles de tu edad.',
    toolAgeHow3: 'Revisa totales como días, meses y próximo cumpleaños.',
    toolAgeBenefitsTitle: 'Beneficios',
    toolAgeBenefit1: 'Obtén detalles precisos de edad al instante.',
    toolAgeBenefit2: 'Ve totales útiles como días y meses.',
    toolAgeBenefit3: 'Todo funciona localmente para privacidad.',
    toolAgeFaqTitle: 'FAQ',
    toolAgeFaq1Q: '¿Es preciso el cálculo?',
    toolAgeFaq1A: 'Sí, usa la fecha y hora de tu dispositivo local para obtener resultados precisos.',
    toolAgeFaq2Q: '¿Se almacena mi fecha en algún lugar?',
    toolAgeFaq2A: 'No. Todos los cálculos ocurren en tu navegador.',

    // Tool Content - Base64
    toolBase64WhatTitle: '¿Qué es el codificador/decodificador Base64?',
    toolBase64WhatDesc: 'Esta herramienta convierte texto a y desde Base64 para transferencia y pruebas seguras.',
    toolBase64HowTitle: 'Cómo usar la herramienta Base64',
    toolBase64How1: 'Elige modo codificar o decodificar.',
    toolBase64How2: 'Pega tu texto o cadena Base64.',
    toolBase64How3: 'Haz clic en procesar y copia el resultado.',
    toolBase64BenefitsTitle: 'Beneficios',
    toolBase64Benefit1: 'Convierte datos rápidamente sin cargas.',
    toolBase64Benefit2: 'Útil para desarrollo y depuración.',
    toolBase64Benefit3: 'Funciona completamente en tu navegador.',
    toolBase64FaqTitle: 'FAQ',
    toolBase64Faq1Q: '¿Es Base64 cifrado?',
    toolBase64Faq1A: 'No, Base64 es un formato de codificación y se puede revertir fácilmente.',
    toolBase64Faq2Q: '¿La herramienta almacena mis datos?',
    toolBase64Faq2A: 'No. Tus datos permanecen en tu dispositivo.',

    // Tool Content - JSON Formatter
    toolJsonWhatTitle: '¿Qué es el formateador JSON?',
    toolJsonWhatDesc: 'Formatea, valida y minimiza JSON con salida clara y errores instantáneos.',
    toolJsonHowTitle: 'Cómo usar el formateador JSON',
    toolJsonHow1: 'Pega JSON en el cuadro de entrada.',
    toolJsonHow2: 'Elige formatear, minimizar o validar.',
    toolJsonHow3: 'Copia la salida cuando esté lista.',
    toolJsonBenefitsTitle: 'Beneficios',
    toolJsonBenefit1: 'Mejora la legibilidad para depuración.',
    toolJsonBenefit2: 'Detecta errores rápidamente con validación.',
    toolJsonBenefit3: 'Minimiza JSON para uso en producción.',
    toolJsonFaqTitle: 'FAQ',
    toolJsonFaq1Q: '¿Soporta arreglos?',
    toolJsonFaq1A: 'Sí, se admiten arreglos y objetos.',
    toolJsonFaq2Q: '¿Se envían mis datos a un servidor?',
    toolJsonFaq2A: 'No, todo se ejecuta en tu navegador.',

    // Tool Content - Lorem Ipsum
    toolLoremWhatTitle: '¿Qué es el generador Lorem Ipsum?',
    toolLoremWhatDesc: 'Genera texto de relleno para llenar diseños, maquetas y borradores de diseño.',
    toolLoremHowTitle: 'Cómo usar el generador Lorem Ipsum',
    toolLoremHow1: 'Selecciona párrafos y palabras por párrafo.',
    toolLoremHow2: 'Elige si comenzar con "Lorem".',
    toolLoremHow3: 'Haz clic en generar y copia la salida.',
    toolLoremBenefitsTitle: 'Beneficios',
    toolLoremBenefit1: 'Crea relleno de diseño realista rápidamente.',
    toolLoremBenefit2: 'Personaliza la longitud para cualquier proyecto.',
    toolLoremBenefit3: 'No se requieren descargas ni registros.',
    toolLoremFaqTitle: 'FAQ',
    toolLoremFaq1Q: '¿Puedo cambiar la longitud?',
    toolLoremFaq1A: 'Sí, puedes controlar los párrafos y el recuento de palabras.',
    toolLoremFaq2Q: '¿El texto está libre de derechos de autor?',
    toolLoremFaq2A: 'Sí, es texto de relleno estándar.',

    // Tool Content - Password Generator
    toolPasswordWhatTitle: '¿Qué es el generador de contraseñas?',
    toolPasswordWhatDesc: 'Crea contraseñas seguras con opciones de longitud y caracteres personalizables.',
    toolPasswordHowTitle: 'Cómo usar el generador de contraseñas',
    toolPasswordHow1: 'Ajusta la configuración de longitud y caracteres.',
    toolPasswordHow2: 'Haz clic en generar para crear una contraseña.',
    toolPasswordHow3: 'Copia la contraseña para usarla.',
    toolPasswordBenefitsTitle: 'Beneficios',
    toolPasswordBenefit1: 'Crea contraseñas seguras al instante.',
    toolPasswordBenefit2: 'Personaliza la fuerza según las necesidades.',
    toolPasswordBenefit3: 'Generado localmente para privacidad.',
    toolPasswordFaqTitle: 'FAQ',
    toolPasswordFaq1Q: '¿Se almacenan las contraseñas?',
    toolPasswordFaq1A: 'No, las contraseñas se generan localmente y nunca se guardan.',
    toolPasswordFaq2Q: '¿Qué longitud deben tener las contraseñas?',
    toolPasswordFaq2A: 'Recomendamos 12+ caracteres para una seguridad sólida.',

    // Tool Content - Random Number
    toolRandomWhatTitle: '¿Qué es el generador de números aleatorios?',
    toolRandomWhatDesc: 'Genera números aleatorios dentro de un rango personalizado para juegos, pruebas o selección.',
    toolRandomHowTitle: 'Cómo usar el generador de números aleatorios',
    toolRandomHow1: 'Establece tu rango mínimo y máximo.',
    toolRandomHow2: 'Elige cuántos números generar.',
    toolRandomHow3: 'Haz clic en generar y copia los resultados.',
    toolRandomBenefitsTitle: 'Beneficios',
    toolRandomBenefit1: 'Selecciones aleatorias rápidas para cualquier tarea.',
    toolRandomBenefit2: 'Soporte para resultados únicos o duplicados.',
    toolRandomBenefit3: 'Funciona instantáneamente en tu navegador.',
    toolRandomFaqTitle: 'FAQ',
    toolRandomFaq1Q: '¿Puedo evitar duplicados?',
    toolRandomFaq1A: 'Sí, desactiva los duplicados para obtener números únicos.',
    toolRandomFaq2Q: '¿Cuántos números puedo generar?',
    toolRandomFaq2A: 'Hasta 100 números por ejecución.',

    // Tool Content - Text Case Converter
    toolCaseWhatTitle: '¿Qué es el convertidor de mayúsculas?',
    toolCaseWhatDesc: 'Convierte texto a diferentes formatos para escritura, formato y codificación.',
    toolCaseHowTitle: 'Cómo usar el convertidor de mayúsculas',
    toolCaseHow1: 'Pega o escribe tu texto.',
    toolCaseHow2: 'Selecciona el formato que deseas aplicar.',
    toolCaseHow3: 'Copia el texto actualizado.',
    toolCaseBenefitsTitle: 'Beneficios',
    toolCaseBenefit1: 'Estandariza el formato de texto al instante.',
    toolCaseBenefit2: 'Útil para títulos, encabezados y código.',
    toolCaseBenefit3: 'Ningún dato sale de tu navegador.',
    toolCaseFaqTitle: 'FAQ',
    toolCaseFaq1Q: '¿Puedo convertir texto grande?',
    toolCaseFaq1A: 'Sí, se admiten grandes bloques de texto.',
    toolCaseFaq2Q: '¿Mantiene la puntuación?',
    toolCaseFaq2A: 'Sí, la puntuación permanece sin cambios.',

    // Tool Content - Text Compare
    toolCompareWhatTitle: '¿Qué es la herramienta de comparación de texto?',
    toolCompareWhatDesc: 'Compara dos textos línea por línea para encontrar cambios, adiciones y eliminaciones.',
    toolCompareHowTitle: 'Cómo usar la herramienta de comparación de texto',
    toolCompareHow1: 'Pega el texto original en el primer cuadro.',
    toolCompareHow2: 'Pega el texto modificado en el segundo cuadro.',
    toolCompareHow3: 'Haz clic en comparar para ver las diferencias.',
    toolCompareBenefitsTitle: 'Beneficios',
    toolCompareBenefit1: 'Detecta cambios rápidamente durante las revisiones.',
    toolCompareBenefit2: 'Resaltado claro para ediciones y actualizaciones.',
    toolCompareBenefit3: 'Ideal para escritores y desarrolladores.',
    toolCompareFaqTitle: 'FAQ',
    toolCompareFaq1Q: '¿Compara línea por línea?',
    toolCompareFaq1A: 'Sí, compara texto línea por línea.',
    toolCompareFaq2Q: '¿Se almacena mi texto?',
    toolCompareFaq2A: 'No, las comparaciones se ejecutan localmente.',

    // Tool Content - URL Encoder
    toolUrlWhatTitle: '¿Qué es el codificador/decodificador URL?',
    toolUrlWhatDesc: 'Codifica o decodifica URLs para manejar de forma segura caracteres especiales en enlaces web.',
    toolUrlHowTitle: 'Cómo usar el codificador URL',
    toolUrlHow1: 'Selecciona modo codificar o decodificar.',
    toolUrlHow2: 'Pega tu URL o texto.',
    toolUrlHow3: 'Haz clic en procesar y copia el resultado.',
    toolUrlBenefitsTitle: 'Beneficios',
    toolUrlBenefit1: 'Evita enlaces rotos en formularios web.',
    toolUrlBenefit2: 'Excelente para APIs y cadenas de consulta.',
    toolUrlBenefit3: 'Procesamiento rápido basado en navegador.',
    toolUrlFaqTitle: 'FAQ',
    toolUrlFaq1Q: '¿Qué caracteres se codifican?',
    toolUrlFaq1A: 'Los espacios y caracteres especiales se convierten en códigos seguros.',
    toolUrlFaq2Q: '¿Soporta URLs completas?',
    toolUrlFaq2A: 'Sí, funciona con URLs completas y cadenas de consulta.',

    // Tool Content - Unit Converter
    toolUnitWhatTitle: '¿Qué es el convertidor de unidades?',
    toolUnitWhatDesc: 'Convierte entre unidades comunes de longitud, peso, temperatura, volumen y tiempo.',
    toolUnitHowTitle: 'Cómo usar el convertidor de unidades',
    toolUnitHow1: 'Elige una categoría como longitud o temperatura.',
    toolUnitHow2: 'Selecciona las unidades a convertir.',
    toolUnitHow3: 'Ingresa un valor para ver los resultados al instante.',
    toolUnitBenefitsTitle: 'Beneficios',
    toolUnitBenefit1: 'Conversiones precisas en segundos.',
    toolUnitBenefit2: 'Soporta múltiples categorías.',
    toolUnitBenefit3: 'Fácil de usar en cualquier dispositivo.',
    toolUnitFaqTitle: 'FAQ',
    toolUnitFaq1Q: '¿Qué unidades están soportadas?',
    toolUnitFaq1A: 'Longitud, peso, temperatura, volumen y tiempo.',
    toolUnitFaq2Q: '¿La conversión es precisa?',
    toolUnitFaq2A: 'Sí, se utilizan factores de conversión estándar.',

    // Tool Content - Wheel of Fortune
    wheelWhatTitle: '¿Qué es la herramienta Ruleta de la Fortuna?',
    wheelWhatDesc: 'Un selector interactivo divertido que te ayuda a decidir girando una ruleta personalizable.',
    wheelHowTitle: 'Cómo usar la Ruleta de la Fortuna',
    wheelHow1: 'Añade comidas o artículos a tu lista.',
    wheelHow2: 'Haz clic en girar para animar la ruleta.',
    wheelHow3: 'Ve el resultado seleccionado al instante.',
    wheelBenefitsTitle: 'Beneficios',
    wheelBenefit1: 'Excelente para decisiones rápidas y selecciones en grupo.',
    wheelBenefit2: 'Los artículos se guardan localmente en tu dispositivo.',
    wheelBenefit3: 'Funciona sin problemas en móvil y escritorio.',
    wheelFaqTitle: 'FAQ',
    wheelFaq1Q: '¿Se guardan mis artículos?',
    wheelFaq1A: 'Sí, los artículos se almacenan en localStorage en tu dispositivo.',
    wheelFaq2Q: '¿Puedo restablecer la lista?',
    wheelFaq2A: 'Sí, usa el botón de restablecer para borrar todos los artículos.',

    // Tools Features
    featureFast: 'Ultra rápido',
    featureFastDesc: 'Todas las herramientas funcionan en tu navegador',
    featureSecure: '100% Seguro',
    featureSecureDesc: 'Tus datos nunca salen de tu dispositivo',
    featureFree: 'Totalmente gratis',
    featureFreeDesc: 'Sin registro, sin límites, sin costos ocultos',

    // AI Chat
    freeAIChatTitle: 'Chat IA Gratis',
    freeAIChatSubtitle: 'Chatea con el asistente IA',
    fairUsagePolicy: 'Chat IA Gratis – Política de uso justo',
    disclaimer: 'Aviso',
    aiDisclaimer: 'Este es un chat IA gratuito. Las respuestas son generadas por IA y pueden no ser siempre exactas. Para chat profesional ilimitado, prueba ChatGPT, Claude o Gemini.',
    startConversation: '¡Empieza una conversación! Pregúntame lo que quieras.',
    exampleQuestions: 'Prueba: "Cuéntame un chiste" o "¿Qué es la IA?"',
    aiThinking: 'IA pensando...',
    typePlaceholder: 'Escribe tu mensaje...',
    sendMessage: 'Enviar',
    pressEnter: 'Presiona Enter',
    freeServiceNotice: 'Servicio gratuito con límites de uso',
    aboutFreeAIChat: 'Sobre el Chat IA',
    poweredByHF: 'Impulsado por Hugging Face - IA gratuita y open-source',
    refreshToReset: 'Actualiza para nueva conversación',
    responsesDelay: 'Respuestas en 3-5 segundos',
    engagementOnly: 'Este chat es para aprendizaje',
    unlimitedAI: 'Para chat ilimitado: ChatGPT, Claude o Gemini',
    aiNoResponse: 'Lo siento, no pude generar respuesta.',
    aiFallbackMessage: 'Tengo problemas de conexión. Intenta de nuevo o actualiza.',

    // AI Tools Page
    aiToolsTitle: 'Directorio de herramientas IA',
    aiToolsSubtitle: 'Descubre las mejores herramientas IA',
    searchPlaceholder: '¿Qué quieres hacer?',
    allCategories: 'Todas las categorías',
    visitTool: 'Visitar',
    free: 'Gratis',
    foundToolsFor: 'Se encontraron {count} herramientas para "{query}"',
    noAIToolsFound: 'No se encontraron herramientas IA',
    adjustSearchFilter: 'Intenta ajustar tu búsqueda o filtro',

    // Football
    footballTitle: 'Sitios de noticias de fútbol',
    footballSubtitle: 'Últimas noticias de fútbol del mundo',

    // Programming
    programmingTitle: 'Recursos de programación',
    programmingSubtitle: 'Aprende y crece como desarrollador',

    // Gaming
    gamingTitle: 'Sitios de juegos',
    gamingSubtitle: 'Mejores plataformas de juegos',

    // SEO
    seoHomeTitle: '3ToolsPro - Herramientas online gratis para tu día a día',
    seoHomeDesc: 'Accede a herramientas gratis de texto, desarrollo y utilidades. Rápidas, seguras y pensadas para resultados profesionales.',
    seoToolsTitle: 'Biblioteca de herramientas online gratis | 3ToolsPro',
    seoToolsDesc: 'Explora una colección de herramientas gratuitas para productividad, texto, desarrollo y utilidades.',
    seoAiChatTitle: 'Chat IA gratis con uso justo | 3ToolsPro',
    seoAiChatDesc: 'Chatea con un asistente IA gratuito para respuestas rápidas e ideas. Se aplican límites de uso justo.',
    seoAiToolsTitle: 'Directorio de herramientas IA | 3ToolsPro',
    seoAiToolsDesc: 'Descubre herramientas IA verificadas para escritura, imagen, video y productividad.',
    seoFootballTitle: 'Fuentes de noticias de fútbol | 3ToolsPro',
    seoFootballDesc: 'Encuentra sitios confiables de noticias de fútbol de todo el mundo.',
    seoProgrammingTitle: 'Recursos de programación | 3ToolsPro',
    seoProgrammingDesc: 'Descubre recursos, documentación, herramientas y enlaces de aprendizaje para desarrolladores.',
    seoGamingTitle: 'Recursos de gaming | 3ToolsPro',
    seoGamingDesc: 'Explora plataformas, descargas, noticias y comunidades de juegos.',
    seoAboutTitle: 'Sobre 3ToolsPro',
    seoAboutDesc: 'Conoce 3ToolsPro, nuestra misión y cómo ofrecemos herramientas online gratuitas.',
    seoContactTitle: 'Contacto 3ToolsPro',
    seoContactDesc: 'Contacta con el equipo de 3ToolsPro para soporte, comentarios o alianzas.',
    seoHowToUseTitle: 'Cómo usar 3ToolsPro',
    seoHowToUseDesc: 'Guía paso a paso para usar las herramientas de 3ToolsPro con eficacia.',
    seoPrivacyTitle: 'Política de privacidad | 3ToolsPro',
    seoPrivacyDesc: 'Lee cómo 3ToolsPro maneja los datos, la privacidad y la seguridad.',
    seoTermsTitle: 'Términos de servicio | 3ToolsPro',
    seoTermsDesc: 'Revisa los términos de servicio de 3ToolsPro y sus herramientas gratuitas.',
    seoWordCounterTitle: 'Contador de palabras | 3ToolsPro',
    seoWordCounterDesc: 'Cuenta palabras, caracteres, oraciones y párrafos al instante. Perfecto para escritores, estudiantes y verificaciones SEO con análisis privado en el navegador.',
    seoTextCaseTitle: 'Convertidor de mayúsculas | 3ToolsPro',
    seoTextCaseDesc: 'Convierte texto a mayúsculas, minúsculas, título, oración y más. Formato rápido y preciso para tareas de escritura y codificación.',
    seoTextCompareTitle: 'Herramienta de comparación de texto | 3ToolsPro',
    seoTextCompareDesc: 'Compara dos textos línea por línea para encontrar adiciones, eliminaciones y cambios. Ideal para edición, revisiones y verificaciones de contenido.',
    seoLoremIpsumTitle: 'Generador Lorem Ipsum | 3ToolsPro',
    seoLoremIpsumDesc: 'Genera texto de relleno Lorem Ipsum personalizable por párrafos o palabras. Útil para maquetas, diseños y borradores de diseño.',
    seoJsonFormatterTitle: 'Formateador JSON | 3ToolsPro',
    seoJsonFormatterDesc: 'Formatea, valida y minimiza JSON con salida legible y errores instantáneos. Perfecto para desarrolladores y limpieza de datos.',
    seoBase64Title: 'Codificador/Decodificador Base64 | 3ToolsPro',
    seoBase64Desc: 'Codifica o decodifica cadenas Base64 de forma segura en tu navegador. Ideal para transferencia de datos, pruebas y flujos de desarrollo.',
    seoUrlEncoderTitle: 'Codificador/Decodificador URL | 3ToolsPro',
    seoUrlEncoderDesc: 'Codifica o decodifica URLs para manejar espacios y caracteres especiales correctamente. Útil para formularios web, APIs y depuración.',
    seoPasswordGeneratorTitle: 'Generador de contraseñas | 3ToolsPro',
    seoPasswordGeneratorDesc: 'Crea contraseñas fuertes y seguras con opciones de longitud y caracteres personalizables. Generado localmente para privacidad.',
    seoRandomNumberTitle: 'Generador de números aleatorios | 3ToolsPro',
    seoRandomNumberDesc: 'Genera números aleatorios dentro de un rango, con resultados únicos opcionales. Útil para juegos, pruebas y selecciones rápidas.',
    seoAgeCalculatorTitle: 'Calculadora de edad | 3ToolsPro',
    seoAgeCalculatorDesc: 'Calcula tu edad exacta con estadísticas detalladas, incluyendo meses, días y próximo cumpleaños. Rápida y privada.',
    seoUnitConverterTitle: 'Convertidor de unidades | 3ToolsPro',
    seoUnitConverterDesc: 'Convierte unidades de longitud, peso, temperatura, volumen y tiempo al instante con resultados precisos y una interfaz fácil.',
    seoWheelTitle: 'Selector de Ruleta de la Fortuna | 3ToolsPro',
    seoWheelDesc: 'Gira una ruleta personalizable para elegir comida o cualquier artículo. Guarda tu lista localmente y obtén resultados instantáneos en cualquier dispositivo.',

    // Footer
    footerTagline: 'Herramientas gratuitas profesionales para todos',
    footerCopyright: '© 2025 3ToolsPro. Todos los derechos reservados.',
    quickLinks: 'Enlaces rápidos',
    legalInfo: 'Legal e Info',

    // Common
    copy: 'Copiar',
    copied: '¡Copiado!',
    clear: 'Limpiar',
    generate: 'Generar',
    encode: 'Codificar',
    decode: 'Decodificar',
    format: 'Formatear',
    validate: 'Validar',
    compare: 'Comparar',
    calculate: 'Calcular',
    owner: 'Propietario',
    email: 'Correo',
    supportEmail: 'Correo soporte',

    // About Page
    aboutUs: 'Sobre nosotros',
    aboutSubtitle: 'Conoce 3ToolsPro y nuestra misión',
    ourMission: 'Nuestra misión',
    missionText: '3ToolsPro fue creado para proporcionar herramientas gratuitas de alta calidad. Creemos que las herramientas de productividad deben ser accesibles para todos.',
    missionText2: 'Nuestra plataforma ofrece una colección de herramientas gratuitas. Todas funcionan en tu navegador, garantizando la privacidad.',
    whatWeOffer: 'Lo que ofrecemos',
    offer1: 'Herramientas de texto: Contador de palabras, convertidor',
    offer2: 'Herramientas de conversión: JSON, Base64, URL',
    offer3: 'Herramientas de seguridad: Generador de contraseñas',
    offer4: 'Chat IA para respuestas rápidas',
    offer5: 'Directorio de las mejores herramientas IA',
    contactInfo: 'Información de contacto',

    // Contact Page
    contactUs: 'Contáctanos',
    contactSubtitle: 'Ponte en contacto - nos encantaría saber de ti',
    socialMedia: 'Redes sociales',
    needHelp: '¿Necesitas ayuda?',
    contactText: 'Si tienes preguntas, no dudes en contactarnos. Respondemos en 24-48 horas.',

    // Privacy Policy
    privacyPolicy: 'Política de privacidad',
    lastUpdated: 'Última actualización',
    introduction: 'Introducción',
    privacyIntro: 'En 3ToolsPro, tomamos tu privacidad en serio. Esta política explica cómo recopilamos y protegemos tu información.',
    dataCollection: 'Información recopilada',
    dataCollectionText: 'Recopilamos información mínima:',
    dataItem1: 'Datos de uso: Páginas visitadas (via Google Analytics)',
    dataItem2: 'Información del dispositivo: Tipo de navegador, SO',
    dataItem3: 'Dirección IP: Para seguridad (anonimizada)',
    howWeUseData: 'Uso de la información',
    useItem1: 'Proporcionar y mantener nuestras herramientas',
    useItem2: 'Analizar uso y mejorar experiencia',
    useItem3: 'Mostrar anuncios via Google AdSense',
    cookies: 'Cookies',
    cookiesText: 'Usamos cookies para mejorar tu experiencia y recordar tus preferencias.',
    thirdParty: 'Servicios de terceros',
    thirdPartyText: 'Usamos los siguientes servicios de terceros:',
    dataSecurity: 'Seguridad de datos',
    dataSecurityText: 'Todas las herramientas funcionan en tu navegador. Tus datos no se envían a nuestros servidores.',
    yourRights: 'Tus derechos',
    right1: 'Acceso: Solicitar datos recopilados',
    right2: 'Eliminación: Solicitar eliminación',
    right3: 'Opt-out: Desactivar seguimiento',
    privacyContactText: '¿Preguntas sobre privacidad? Contáctanos:',

    // Terms of Service
    termsOfService: 'Términos de servicio',
    acceptanceOfTerms: 'Aceptación de términos',
    acceptanceText: 'Al usar 3ToolsPro, aceptas estos términos. Si no estás de acuerdo, no uses nuestros servicios.',
    useOfService: 'Uso del servicio',
    useOfServiceText: 'Nuestras herramientas son gratuitas para uso personal y comercial:',
    serviceRule1: 'Usa nuestras herramientas para cualquier propósito legal',
    serviceRule2: 'No intentes copiar nuestras herramientas',
    serviceRule3: 'No uses nuestros servicios para actividades ilegales',
    serviceRule4: 'No sobrecargues nuestros servicios',
    intellectualProperty: 'Propiedad intelectual',
    intellectualPropertyText: 'Todo el contenido está protegido por leyes de propiedad intelectual.',
    userContent: 'Contenido del usuario',
    userContentText: 'Tus datos se procesan localmente y no se almacenan en nuestros servidores.',
    disclaimerText: 'Nuestras herramientas se proporcionan "tal cual" sin garantía.',
    disclaimerWarning: 'USA BAJO TU PROPIO RIESGO. No somos responsables de pérdida de datos.',
    limitationOfLiability: 'Limitación de responsabilidad',
    limitationText: 'No seremos responsables de daños indirectos.',
    modifications: 'Modificaciones',
    modificationsText: 'Podemos modificar estos términos en cualquier momento.',
    governingLaw: 'Ley aplicable',
    governingLawText: 'Estos términos se rigen por las leyes de Egipto.',
    termsContactText: '¿Preguntas sobre los términos? Contáctanos:',

    // How To Use Page
    howToUse: 'Cómo usar',
    howToUseSubtitle: '¡Empieza con 3ToolsPro - fácil y gratis!',
    step1Title: 'Paso 1: Elige tu herramienta',
    step1Text: 'Explora nuestra colección de herramientas gratuitas:',
    step1Item1: 'Herramientas de texto: Contador de palabras, convertidor',
    step1Item2: 'Herramientas de datos: JSON, Base64, URL',
    step1Item3: 'Utilidades: Contraseñas, edad, unidades',
    step2Title: 'Paso 2: Usa la herramienta',
    step2Text: 'Cada herramienta es simple:',
    step2Item1: 'Ingresa tus datos',
    step2Item2: 'Haz clic en el botón de acción',
    step2Item3: '¡Resultados instantáneos!',
    step3Title: 'Paso 3: Copia tus resultados',
    step3Text: 'Una vez terminado:',
    step3Item1: 'Haz clic en "Copiar"',
    step3Item2: 'Descarga si está disponible',
    step3Item3: 'Limpia y empieza de nuevo',
    step4Title: 'Paso 4: Explora',
    step4Text: '¡Consulta nuestro directorio IA, recursos de fútbol, programación y juegos. Prueba el chat IA gratis!',
    helpText: '¿Necesitas ayuda o sugerencias? Contáctanos:',

    wordCounterPage: {
      title: 'Contador de palabras',
      subtitle: 'Cuenta palabras, caracteres, oraciones, párrafos y tiempo de lectura al instante',
      whyTitle: '¿Por qué usar este contador de palabras?',
      why1: 'Verificar la longitud de artículos para optimización SEO',
      why2: 'Contar caracteres para límites de redes sociales',
      why3: 'Mejorar la productividad y precisión al escribir',
      why4: 'Estimar automáticamente el tiempo de lectura',
      why5: 'Analizar el texto al instante sin subir archivos',
      howTitle: 'Cómo usar la herramienta Contador de palabras:',
      how1: 'Escribe o pega tu texto en el cuadro superior',
      how2: 'Las estadísticas se actualizan automáticamente mientras escribes',
      how3: 'El tiempo de lectura se calcula en base a 200 palabras por minuto',
      how4: 'Todo el procesamiento ocurre en tu navegador — tu texto no se guarda',
      faq: 'FAQ',
      faq1q: '¿Este contador de palabras es gratuito?',
      faq1a: 'Sí, esta herramienta es completamente gratuita y sin límites.',
      faq2q: '¿Se guarda mi texto?',
      faq2a: 'No. Todo el procesamiento ocurre localmente en tu navegador.',
      faq3q: '¿Quién puede usar esta herramienta?',
      faq3a: 'Escritores, estudiantes, marketers, desarrolladores y cualquiera que trabaje con texto.',
        toolWordCounterDesc: "Cuenta palabras y caracteres al instante.",
  toolJSONFormatterDesc: "Formatea, valida y embellece datos JSON.",
  toolPasswordGeneratorDesc: "Genera contraseñas seguras y aleatorias.",
  toolBase64EncoderDesc: "Codifica y decodifica cadenas Base64 fácilmente.",
  toolAgeCalculatorDesc: "Calcula la edad a partir de la fecha de nacimiento al instante.",
  toolTextCaseConverterDesc: "Convierte texto entre diferentes formatos de mayúsculas y minúsculas."
    },
    seo: {
      wordCounterTitle: 'Contador de palabras gratis - Cuenta palabras y caracteres en línea',
      wordCounterDesc: 'Herramienta gratuita para contar palabras, caracteres, oraciones y tiempo de lectura al instante.'
    }
  },
  de: {
    // Navigation
    home: 'Startseite',
    tools: 'Werkzeuge',
    aiChat: 'KI-Chat Gratis',
    aiToolsDirectory: 'KI-Verzeichnis',
    footballNews: 'Fußball-News',
    programming: 'Programmierung',
    gaming: 'Gaming',
    gamesHub: 'IQ-Spiele',
    gamesHubTitle: 'IQ- und Gehirntrainingsspiele',
    gamesHubSubtitle: 'Spiele kostenlos Gedächtnis-, Logik-, Reaktions- und Codierspiele, um deine Konzentration zu verbessern und dein Gehirn aktiv zu halten.',
    seoGamesTitle: 'IQ-Spiele online | 3ToolsPro',
    seoGamesDesc: 'Spiele kostenlos IQ- und Gehirntrainingsspiele online, einschließlich Gedächtnis-, Puzzle-, Reaktions- und Code-Herausforderungen. Mobilfreundlich und vollständig browserbasiert.',
    gameWhatIsTitle: 'Was ist',
    gameHowToPlayTitle: 'Spielanleitung',
    gameSkillsTitle: 'Verbesserte Fähigkeiten',
    gameBenefitsTitle: 'Vorteile',
    gameFaqTitle: 'FAQ',
    gameRelatedTitle: 'Verwandte Tools und Spiele',
    gameScore: 'Punktzahl',
    gameBest: 'Beste',
    gameQuestion: 'Frage',
    gameNextQuestion: 'Nächste Frage',
    difficultyEasy: 'Einfach',
    difficultyMedium: 'Mittel',
    difficultyHard: 'Schwer',
    codeOutputTitle: 'Codeausgabe erraten',
    codeOutputSubtitle: 'Ein Entwickler-Gehirnspiel zur Schärfung des JavaScript-Denkens.',
    seoCodeOutputTitle: 'Spiel Codeausgabe erraten | 3ToolsPro',
    seoCodeOutputDesc: 'Spiele ein kostenloses Programmier-IQ-Spiel und errate die JavaScript-Ausgabe. Übe Logik, Debugging-Denkweise und zeitsparende Entwicklerintuition in deinem Browser.',
    codeOutputWhatIs: 'Codeausgabe erraten ist eine leichte Programmierherausforderung für Entwickler und Lernende. Es trainiert die schnelle Analyse von Syntax, Gültigkeitsbereich und Laufzeitverhalten.',
    codeOutputHow1: 'Wähle einen Schwierigkeitsgrad.',
    codeOutputHow2: 'Lies das JavaScript-Snippet sorgfältig.',
    codeOutputHow3: 'Wähle die Ausgabe, die du für richtig hältst.',
    codeOutputHow4: 'Gehe zur nächsten Frage und verbessere deine Punktzahl.',
    codeOutputSkill1: 'Debugging-Denkweise',
    codeOutputSkill2: 'JavaScript-Grundlagen',
    codeOutputSkill3: 'Intuition für Zeitkomplexität',
    codeOutputBenefit1: 'Höheres Entwicklerengagement',
    codeOutputBenefit2: 'Nützliche Vorstellungsgesprächspraxis',
    codeOutputBenefit3: 'Schnelle tägliche Lerngewohnheit',
    codeOutputFaq1Q: 'Sind die Fragen anfängerfreundlich?',
    codeOutputFaq1A: 'Ja. Der einfache Modus ist für grundlegende Übungen ausgelegt.',
    codeOutputFaq2Q: 'Wird die Punktzahl gespeichert?',
    codeOutputFaq2A: 'Die beste Punktzahl wird lokal in deinem Browser gespeichert.',
    memoryGameTitle: 'Memory-Kartenspiel',
    memoryGameSubtitle: 'Finde alle Paare mit möglichst wenigen Zügen und schlage deine persönliche Bestleistung.',
    seoMemoryGameTitle: 'Memory-Kartenspiel | 3ToolsPro',
    seoMemoryGameDesc: 'Spiele ein kostenloses Online-Memory-Kartenspiel, um Konzentration und Kurzzeitgedächtnis zu trainieren. Verfolge deine beste Punktzahl und verbessere deine Konzentration mit diesem Gehirnspiel.',
    memoryWhatIs: 'Dieses leichte Gehirnspiel hilft Kindern und Erwachsenen, visuelles Gedächtnis und Konzentration zu stärken, indem sie Symbolpaare zuordnen.',
    memoryHow1: 'Tippe auf eine Karte, um sie aufzudecken.',
    memoryHow2: 'Tippe auf eine zweite Karte, um ein passendes Paar zu finden.',
    memoryHow3: 'Ordne weiterhin Paare zu, bis das Spielfeld gelöst ist.',
    memoryHow4: 'Versuche, jede Runde mit weniger Zügen zu beenden.',
    memorySkill1: 'Arbeitsgedächtnis',
    memorySkill2: 'Visuelle Aufmerksamkeit',
    memorySkill3: 'Mustererkennung',
    memoryBenefit1: 'Schnelle tägliche Gehirnübung',
    memoryBenefit2: 'Familienfreundliches Gameplay',
    memoryBenefit3: 'Kein Konto oder Download erforderlich',
    memoryFaq1Q: 'Speichert dieses Spiel meine beste Punktzahl?',
    memoryFaq1A: 'Ja, deine beste Zuganzahl wird im localStorage auf diesem Gerät gespeichert.',
    memoryFaq2Q: 'Können Kinder dieses Spiel spielen?',
    memoryFaq2A: 'Ja, es verwendet einfache Grafiken und berührungsfreundliche Steuerung.',
    numberPuzzleTitle: 'Zahlenpuzzle',
    numberPuzzleSubtitle: 'Schiebe die Kacheln in die richtige Reihenfolge von 1 bis 8.',
    seoNumberPuzzleTitle: 'Zahlenpuzzle-Spiel | 3ToolsPro',
    seoNumberPuzzleDesc: 'Spiele ein kostenloses 3x3-Zahlenpuzzle-Spiel online. Verbessere deine Problemlösungs- und Logikfähigkeiten, verfolge deine besten Züge und genieße eine schnelle Browser-Herausforderung.',
    numberPuzzleSolved: 'Großartige Arbeit! Puzzle in {moves} Zügen gelöst.',
    numberPuzzleWhatIs: 'Zahlenpuzzle ist ein klassisches Logikspiel, bei dem du nummerierte Kacheln verschiebst, um die richtige Reihenfolge wiederherzustellen.',
    numberPuzzleHow1: 'Tippe auf eine Kachel neben dem leeren Feld.',
    numberPuzzleHow2: 'Bewege die Kacheln Schritt für Schritt weiter.',
    numberPuzzleHow3: 'Ordne die Zahlen von 1 bis 8 der Reihe nach an.',
    numberPuzzleHow4: 'Wiederhole und verbessere deine beste Punktzahl.',
    numberPuzzleSkill1: 'Problemlösung',
    numberPuzzleSkill2: 'Vorausplanung',
    numberPuzzleSkill3: 'Räumliches Denken',
    numberPuzzleBenefit1: 'Schnelles Gehirntraining',
    numberPuzzleBenefit2: 'Verbessert Geduld und Konzentration',
    numberPuzzleBenefit3: 'Funktioniert reibungslos auf Mobilgeräten und Desktops',
    numberPuzzleFaq1Q: 'Benötigt dieses Spiel Internet?',
    numberPuzzleFaq1A: 'Nein. Einmal geladen, ist das Spiel vollständig clientseitig.',
    numberPuzzleFaq2Q: 'Wird die beste Punktzahl gespeichert?',
    numberPuzzleFaq2A: 'Ja, deine beste Zuganzahl wird im localStorage gespeichert.',
    reactionTestTitle: 'Schnellreaktionstest',
    reactionTestSubtitle: 'Messe deine Reflexgeschwindigkeit und behalte deine beste Punktzahl.',
    seoReactionTestTitle: 'Schnellreaktionstest | 3ToolsPro',
    seoReactionTestDesc: 'Teste deine Reaktionsgeschwindigkeit kostenlos online. Verfolge deine beste Reflexpunktzahl und verbessere deine Konzentration mit einem leichten Browserspiel.',
    reactionWhatIs: 'Der Schnellreaktionstest ist ein einfaches Reflexspiel, das misst, wie schnell du auf ein visuelles Signal reagierst.',
    reactionHow1: 'Drücke auf Start, um den Test zu aktivieren.',
    reactionHow2: 'Warte, bis das Panel grün wird.',
    reactionHow3: 'Tippe sofort, wenn "bereit" erscheint.',
    reactionHow4: 'Wiederhole und verbessere deine beste Zeit.',
    reactionSkill1: 'Reflexgeschwindigkeit',
    reactionSkill2: 'Visuelle Konzentration',
    reactionSkill3: 'Reaktionskontrolle',
    reactionBenefit1: 'Schnelle tägliche Herausforderung',
    reactionBenefit2: 'Großartig für alle Altersgruppen',
    reactionBenefit3: 'Keine Anmeldung oder Installation',
    reactionFaq1Q: 'Was ist eine gute Reaktionszeit?',
    reactionFaq1A: 'Für viele Menschen sind 200–300 ms ein gutes Ergebnis.',
    reactionFaq2Q: 'Kann ich dies auf dem Handy nutzen?',
    reactionFaq2A: 'Ja, das Spiel ist für mobile Berührungen optimiert.',
    gameMoves: 'Züge',
    gameRestart: 'Neustart',
    selectLanguage: 'Sprache wählen',
    more: 'Mehr',
    resources: 'Ressourcen',

    // Home Page
    heroTitle: 'Kostenlose Online-Tools für schnelleres Arbeiten',
    heroSubtitle: 'Professionelle Tools für alltägliche Aufgaben. Schnell, sicher und ohne Registrierung.',
    startUsing: 'Jetzt starten',
    ourTools: 'Unsere Tools',
    ourToolsSubtitle: 'Alle Tools sind 100% kostenlos, funktionieren sofort und erfordern keine Registrierung.',
    allFree: '100% Kostenlos',
    instantResults: 'Sofortige Ergebnisse',
    noSignup: 'Ohne Registrierung',
    freeAIChat: 'KI-Chat Gratis',

    // Shared UI
    adLabel: 'Werbung',
    adAreaAriaLabel: 'Bereich für gesponserte Inhalte',
    adPlaceholderLabel: 'Google AdSense Platzierung',
    adPlaceholderBetweenSections: 'In-Content-Anzeigenplatzierung',
    visitSite: 'Website besuchen',
    noSitesFound: 'Keine Websites gefunden',
    selectDifferentRegion: 'Versuche, eine andere Region auszuwählen',
    aiServiceUnavailable: 'Dienst vorübergehend nicht verfügbar',
    aiUnexpectedError: 'Etwas ist schief gelaufen. Bitte versuche es erneut.',

    // Home Card Descriptions
    aiChatDesc: 'Kostenlos mit KI chatten - Begrenzte Nutzung',
    aiToolsDesc: 'Entdecken Sie die besten KI-Tools',
    footballDesc: 'Neueste Fußball-News weltweit',
    programmingDesc: 'Ressourcen für Entwickler',
    gamingDesc: 'Beste Gaming-Plattformen',

    // Tools Page
    toolsPageTitle: 'Kostenlose Online-Tools',
    toolsPageSubtitle: 'Professionelle Tools für alltägliche Aufgaben. Schnell, sicher und ohne Registrierung.',

    // Tool Categories
    categoryAll: 'Alle',
    categoryTextContent: 'Text & Inhalt',
    categoryDeveloper: 'Entwickler',
    categoryUtility: 'Hilfsmittel',

    // Tool Names
    toolWordCounter: 'Wortzähler',
    toolTextCaseConverter: 'Groß-/Kleinschreibung',
    toolTextCompare: 'Textvergleich',
    toolLoremIpsum: 'Lorem Ipsum Generator',
    toolJSONFormatter: 'JSON-Formatierer',
    toolBase64Encoder: 'Base64 Encoder/Decoder',
    toolURLEncoder: 'URL Encoder/Decoder',
    toolPasswordGenerator: 'Passwort-Generator',
    toolRandomNumber: 'Zufallszahlen-Generator',
    toolAgeCalculator: 'Altersrechner',
    toolUnitConverter: 'Einheitenumrechner',
    toolWheelOfFortune: 'Glücksrad',
    toolWheelOfFortuneDesc: 'Drehe ein anpassbares Rad, um ein zufälliges Lebensmittel oder einen Gegenstand auszuwählen',

    // AI Chat Status
    connectionStatus: 'Status',
    aiStatusOnline: 'Online',
    aiStatusOffline: 'Offline-Modus',
    aiLocalModeNotice: 'Der KI-Dienst ist derzeit nicht verfügbar, daher verwendest du Offline-Antworten.',
    openChatGPT: 'ChatGPT öffnen',
    aiLocalResponse1: 'Ich bin gerade offline, kann aber trotzdem helfen. Versuche, deine Frage zu präzisieren oder bitte um eine kurze Übersicht.',
    aiLocalResponse2: 'Hier ist ein schneller Vorschlag: Zerlege die Aufgabe in Schritte und beginne mit dem wichtigsten Teil.',
    aiLocalResponse3: 'Wenn du detaillierte Ergebnisse benötigst, versuche es später noch einmal. Für den Moment kann ich eine kurze Zusammenfassung oder Checkliste bereitstellen.',

    // Wheel of Fortune UI
    wheelTitle: 'Glücksrad (Lebensmittelauswahl)',
    wheelSubtitle: 'Füge Optionen hinzu, drehe das Rad und erhalte sofort eine zufällige Auswahl.',
    wheelSpin: 'Rad drehen',
    wheelSpinning: 'Dreht...',
    wheelResultLabel: 'Ausgewähltes Ergebnis',
    wheelResultPlaceholder: 'Elemente hinzufügen und drehen, um auszuwählen',
    wheelManageTitle: 'Elemente verwalten',
    wheelManageSubtitle: 'Füge Lebensmittel oder Optionen hinzu und behalte sie auf diesem Gerät gespeichert.',
    wheelInputPlaceholder: 'Gib ein Lebensmittel oder einen Gegenstand ein',
    wheelAdd: 'Hinzufügen',
    wheelEmpty: 'Noch keine Elemente. Füge mindestens zwei hinzu, um zu drehen.',
    wheelRemove: 'Entfernen',
    wheelReset: 'Liste zurücksetzen',

    // Tool Content - Age Calculator
    toolAgeWhatTitle: 'Was ist der Altersrechner?',
    toolAgeWhatDesc: 'Der Altersrechner hilft dir, dein genaues Alter und wichtige Meilensteine anhand eines Geburtsdatums zu ermitteln.',
    toolAgeHowTitle: 'Wie man den Altersrechner benutzt',
    toolAgeHow1: 'Wähle dein Geburtsdatum.',
    toolAgeHow2: 'Klicke auf Berechnen, um deine Altersdetails anzuzeigen.',
    toolAgeHow3: 'Überprüfe Gesamtzahlen wie Tage, Monate und den nächsten Geburtstag.',
    toolAgeBenefitsTitle: 'Vorteile',
    toolAgeBenefit1: 'Erhalte genaue Altersdetails sofort.',
    toolAgeBenefit2: 'Siehe nützliche Gesamtzahlen wie Tage und Monate.',
    toolAgeBenefit3: 'Alles läuft lokal für Datenschutz.',
    toolAgeFaqTitle: 'FAQ',
    toolAgeFaq1Q: 'Ist die Berechnung genau?',
    toolAgeFaq1A: 'Ja, es verwendet das lokale Datum und die Uhrzeit deines Geräts für präzise Ergebnisse.',
    toolAgeFaq2Q: 'Wird mein Datum irgendwo gespeichert?',
    toolAgeFaq2A: 'Nein. Alle Berechnungen finden in deinem Browser statt.',

    // Tool Content - Base64
    toolBase64WhatTitle: 'Was ist der Base64 Encoder/Decoder?',
    toolBase64WhatDesc: 'Dieses Tool konvertiert Text zu und von Base64 für sichere Übertragung und Tests.',
    toolBase64HowTitle: 'Wie man das Base64-Tool benutzt',
    toolBase64How1: 'Wähle den Kodierungs- oder Dekodierungsmodus.',
    toolBase64How2: 'Füge deinen Text oder Base64-String ein.',
    toolBase64How3: 'Klicke auf Verarbeiten und kopiere das Ergebnis.',
    toolBase64BenefitsTitle: 'Vorteile',
    toolBase64Benefit1: 'Schnelle Datenkonvertierung ohne Uploads.',
    toolBase64Benefit2: 'Hilfreich für Entwicklung und Debugging.',
    toolBase64Benefit3: 'Läuft vollständig in deinem Browser.',
    toolBase64FaqTitle: 'FAQ',
    toolBase64Faq1Q: 'Ist Base64 Verschlüsselung?',
    toolBase64Faq1A: 'Nein, Base64 ist ein Kodierungsformat und kann leicht rückgängig gemacht werden.',
    toolBase64Faq2Q: 'Speichert das Tool meine Daten?',
    toolBase64Faq2A: 'Nein. Deine Daten bleiben auf deinem Gerät.',

    // Tool Content - JSON Formatter
    toolJsonWhatTitle: 'Was ist der JSON-Formatierer?',
    toolJsonWhatDesc: 'Formatiere, validiere und minifiziere JSON mit klarer Ausgabe und sofortigen Fehlern.',
    toolJsonHowTitle: 'Wie man den JSON-Formatierer benutzt',
    toolJsonHow1: 'Füge JSON in das Eingabefeld ein.',
    toolJsonHow2: 'Wähle Formatieren, Minifizieren oder Validieren.',
    toolJsonHow3: 'Kopiere die Ausgabe, wenn sie bereit ist.',
    toolJsonBenefitsTitle: 'Vorteile',
    toolJsonBenefit1: 'Verbessere die Lesbarkeit für das Debugging.',
    toolJsonBenefit2: 'Erfasse Fehler schnell mit Validierung.',
    toolJsonBenefit3: 'Minifiziere JSON für den Produktionseinsatz.',
    toolJsonFaqTitle: 'FAQ',
    toolJsonFaq1Q: 'Unterstützt es Arrays?',
    toolJsonFaq1A: 'Ja, Arrays und Objekte werden unterstützt.',
    toolJsonFaq2Q: 'Werden meine Daten an einen Server gesendet?',
    toolJsonFaq2A: 'Nein, alles läuft in deinem Browser.',

    // Tool Content - Lorem Ipsum
    toolLoremWhatTitle: 'Was ist der Lorem Ipsum Generator?',
    toolLoremWhatDesc: 'Generiere Platzhaltertext zum Füllen von Layouts, Mockups und Designentwürfen.',
    toolLoremHowTitle: 'Wie man den Lorem Ipsum Generator benutzt',
    toolLoremHow1: 'Wähle Absätze und Wörter pro Absatz.',
    toolLoremHow2: 'Wähle, ob mit "Lorem" begonnen werden soll.',
    toolLoremHow3: 'Klicke auf Generieren und kopiere die Ausgabe.',
    toolLoremBenefitsTitle: 'Vorteile',
    toolLoremBenefit1: 'Erstelle schnell realistischen Layout-Füller.',
    toolLoremBenefit2: 'Passe die Länge für jedes Projekt an.',
    toolLoremBenefit3: 'Keine Downloads oder Anmeldungen erforderlich.',
    toolLoremFaqTitle: 'FAQ',
    toolLoremFaq1Q: 'Kann ich die Länge ändern?',
    toolLoremFaq1A: 'Ja, du kannst Absätze und Wortanzahl steuern.',
    toolLoremFaq2Q: 'Ist der Text urheberrechtsfrei?',
    toolLoremFaq2A: 'Ja, es ist standardmäßiger Platzhaltertext.',

    // Tool Content - Password Generator
    toolPasswordWhatTitle: 'Was ist der Passwort-Generator?',
    toolPasswordWhatDesc: 'Erstelle starke Passwörter mit anpassbaren Längen- und Zeichenoptionen.',
    toolPasswordHowTitle: 'Wie man den Passwort-Generator benutzt',
    toolPasswordHow1: 'Passe Länge und Zeicheneinstellungen an.',
    toolPasswordHow2: 'Klicke auf Generieren, um ein Passwort zu erstellen.',
    toolPasswordHow3: 'Kopiere das Passwort zur Verwendung.',
    toolPasswordBenefitsTitle: 'Vorteile',
    toolPasswordBenefit1: 'Erstelle sofort sichere Passwörter.',
    toolPasswordBenefit2: 'Passe die Stärke je nach Bedarf an.',
    toolPasswordBenefit3: 'Lokal generiert für Datenschutz.',
    toolPasswordFaqTitle: 'FAQ',
    toolPasswordFaq1Q: 'Werden Passwörter gespeichert?',
    toolPasswordFaq1A: 'Nein, Passwörter werden lokal generiert und nie gespeichert.',
    toolPasswordFaq2Q: 'Wie lang sollten Passwörter sein?',
    toolPasswordFaq2A: 'Wir empfehlen 12+ Zeichen für starke Sicherheit.',

    // Tool Content - Random Number
    toolRandomWhatTitle: 'Was ist der Zufallszahlen-Generator?',
    toolRandomWhatDesc: 'Generiere Zufallszahlen innerhalb eines benutzerdefinierten Bereichs für Spiele, Tests oder Auswahl.',
    toolRandomHowTitle: 'Wie man den Zufallszahlen-Generator benutzt',
    toolRandomHow1: 'Lege deinen Mindest- und Höchstbereich fest.',
    toolRandomHow2: 'Wähle, wie viele Zahlen generiert werden sollen.',
    toolRandomHow3: 'Klicke auf Generieren und kopiere die Ergebnisse.',
    toolRandomBenefitsTitle: 'Vorteile',
    toolRandomBenefit1: 'Schnelle zufällige Auswahl für jede Aufgabe.',
    toolRandomBenefit2: 'Unterstützung für eindeutige oder doppelte Ergebnisse.',
    toolRandomBenefit3: 'Funktioniert sofort in deinem Browser.',
    toolRandomFaqTitle: 'FAQ',
    toolRandomFaq1Q: 'Kann ich Duplikate vermeiden?',
    toolRandomFaq1A: 'Ja, deaktiviere Duplikate, um eindeutige Zahlen zu erhalten.',
    toolRandomFaq2Q: 'Wie viele Zahlen kann ich generieren?',
    toolRandomFaq2A: 'Bis zu 100 Zahlen pro Durchlauf.',

    // Tool Content - Text Case Converter
    toolCaseWhatTitle: 'Was ist der Textfallkonverter?',
    toolCaseWhatDesc: 'Konvertiere Text in verschiedene Schreibweisen zum Schreiben, Formatieren und Codieren.',
    toolCaseHowTitle: 'Wie man den Textfallkonverter benutzt',
    toolCaseHow1: 'Füge deinen Text ein oder tippe ihn.',
    toolCaseHow2: 'Wähle die gewünschte Schreibweise aus.',
    toolCaseHow3: 'Kopiere den aktualisierten Text.',
    toolCaseBenefitsTitle: 'Vorteile',
    toolCaseBenefit1: 'Standardisiere die Textformatierung sofort.',
    toolCaseBenefit2: 'Nützlich für Titel, Überschriften und Code.',
    toolCaseBenefit3: 'Keine Daten verlassen deinen Browser.',
    toolCaseFaqTitle: 'FAQ',
    toolCaseFaq1Q: 'Kann ich großen Text konvertieren?',
    toolCaseFaq1A: 'Ja, große Textblöcke werden unterstützt.',
    toolCaseFaq2Q: 'Behält es die Zeichensetzung bei?',
    toolCaseFaq2A: 'Ja, die Zeichensetzung bleibt unverändert.',

    // Tool Content - Text Compare
    toolCompareWhatTitle: 'Was ist das Textvergleichstool?',
    toolCompareWhatDesc: 'Vergleiche zwei Texte zeilenweise, um Änderungen, Hinzufügungen und Löschungen zu finden.',
    toolCompareHowTitle: 'Wie man das Textvergleichstool benutzt',
    toolCompareHow1: 'Füge den Originaltext in das erste Feld ein.',
    toolCompareHow2: 'Füge den geänderten Text in das zweite Feld ein.',
    toolCompareHow3: 'Klicke auf Vergleichen, um Unterschiede anzuzeigen.',
    toolCompareBenefitsTitle: 'Vorteile',
    toolCompareBenefit1: 'Erkenne Änderungen schnell bei Überprüfungen.',
    toolCompareBenefit2: 'Klare Hervorhebungen für Bearbeitungen und Aktualisierungen.',
    toolCompareBenefit3: 'Ideal für Autoren und Entwickler.',
    toolCompareFaqTitle: 'FAQ',
    toolCompareFaq1Q: 'Vergleicht es zeilenweise?',
    toolCompareFaq1A: 'Ja, es vergleicht Text zeilenweise.',
    toolCompareFaq2Q: 'Wird mein Text gespeichert?',
    toolCompareFaq2A: 'Nein, Vergleiche werden lokal durchgeführt.',

    // Tool Content - URL Encoder
    toolUrlWhatTitle: 'Was ist der URL Encoder/Decoder?',
    toolUrlWhatDesc: 'Kodiere oder dekodiere URLs, um Sonderzeichen in Weblinks sicher zu handhaben.',
    toolUrlHowTitle: 'Wie man den URL-Encoder benutzt',
    toolUrlHow1: 'Wähle den Kodierungs- oder Dekodierungsmodus.',
    toolUrlHow2: 'Füge deine URL oder deinen Text ein.',
    toolUrlHow3: 'Klicke auf Verarbeiten und kopiere das Ergebnis.',
    toolUrlBenefitsTitle: 'Vorteile',
    toolUrlBenefit1: 'Vermeide defekte Links in Webformularen.',
    toolUrlBenefit2: 'Großartig für APIs und Abfragezeichenfolgen.',
    toolUrlBenefit3: 'Schnelle, browserbasierte Verarbeitung.',
    toolUrlFaqTitle: 'FAQ',
    toolUrlFaq1Q: 'Welche Zeichen werden kodiert?',
    toolUrlFaq1A: 'Leerzeichen und Sonderzeichen werden in sichere Codes umgewandelt.',
    toolUrlFaq2Q: 'Unterstützt es vollständige URLs?',
    toolUrlFaq2A: 'Ja, es funktioniert mit vollständigen URLs und Abfragezeichenfolgen.',

    // Tool Content - Unit Converter
    toolUnitWhatTitle: 'Was ist der Einheitenumrechner?',
    toolUnitWhatDesc: 'Konvertiere zwischen gängigen Einheiten für Länge, Gewicht, Temperatur, Volumen und Zeit.',
    toolUnitHowTitle: 'Wie man den Einheitenumrechner benutzt',
    toolUnitHow1: 'Wähle eine Kategorie wie Länge oder Temperatur.',
    toolUnitHow2: 'Wähle die umzurechnenden Einheiten aus.',
    toolUnitHow3: 'Gib einen Wert ein, um sofort Ergebnisse zu sehen.',
    toolUnitBenefitsTitle: 'Vorteile',
    toolUnitBenefit1: 'Genaue Umrechnungen in Sekunden.',
    toolUnitBenefit2: 'Unterstützt mehrere Kategorien.',
    toolUnitBenefit3: 'Einfach auf jedem Gerät zu verwenden.',
    toolUnitFaqTitle: 'FAQ',
    toolUnitFaq1Q: 'Welche Einheiten werden unterstützt?',
    toolUnitFaq1A: 'Länge, Gewicht, Temperatur, Volumen und Zeit.',
    toolUnitFaq2Q: 'Ist die Umrechnung genau?',
    toolUnitFaq2A: 'Ja, es werden standardmäßige Umrechnungsfaktoren verwendet.',

    // Tool Content - Wheel of Fortune
    wheelWhatTitle: 'Was ist das Glücksrad-Tool?',
    wheelWhatDesc: 'Ein unterhaltsamer, interaktiver Auswähler, der dir hilft, Entscheidungen zu treffen, indem du ein anpassbares Rad drehst.',
    wheelHowTitle: 'Wie man das Glücksrad benutzt',
    wheelHow1: 'Füge Lebensmittel oder Gegenstände zu deiner Liste hinzu.',
    wheelHow2: 'Klicke auf Drehen, um das Rad zu animieren.',
    wheelHow3: 'Siehe das ausgewählte Ergebnis sofort.',
    wheelBenefitsTitle: 'Vorteile',
    wheelBenefit1: 'Großartig für schnelle Entscheidungen und Gruppenauswahlen.',
    wheelBenefit2: 'Elemente werden lokal auf deinem Gerät gespeichert.',
    wheelBenefit3: 'Funktioniert reibungslos auf Mobilgeräten und Desktops.',
    wheelFaqTitle: 'FAQ',
    wheelFaq1Q: 'Werden meine Elemente gespeichert?',
    wheelFaq1A: 'Ja, Elemente werden im localStorage auf deinem Gerät gespeichert.',
    wheelFaq2Q: 'Kann ich die Liste zurücksetzen?',
    wheelFaq2A: 'Ja, verwende die Schaltfläche Zurücksetzen, um alle Elemente zu löschen.',

    // Tools Features
    featureFast: 'Blitzschnell',
    featureFastDesc: 'Alle Tools laufen direkt im Browser',
    featureSecure: '100% Sicher',
    featureSecureDesc: 'Ihre Daten verlassen nie Ihr Gerät',
    featureFree: 'Komplett kostenlos',
    featureFreeDesc: 'Keine Registrierung, keine Limits, keine Kosten',

    // AI Chat
    freeAIChatTitle: 'KI-Chat Gratis',
    freeAIChatSubtitle: 'Mit dem KI-Assistenten chatten',
    fairUsagePolicy: 'KI-Chat Gratis – Fair-Use-Richtlinie',
    disclaimer: 'Hinweis',
    aiDisclaimer: 'Dies ist ein kostenloser KI-Chat. Antworten werden von KI generiert und sind möglicherweise nicht immer genau. Für unbegrenzten professionellen Chat: ChatGPT, Claude oder Gemini.',
    startConversation: 'Starten Sie eine Unterhaltung! Fragen Sie mich alles.',
    exampleQuestions: 'Versuchen Sie: "Erzähl mir einen Witz" oder "Was ist KI?"',
    aiThinking: 'KI denkt...',
    typePlaceholder: 'Nachricht eingeben...',
    sendMessage: 'Senden',
    pressEnter: 'Enter drücken',
    freeServiceNotice: 'Kostenloser Service mit Nutzungslimits',
    aboutFreeAIChat: 'Über KI-Chat',
    poweredByHF: 'Powered by Hugging Face - Kostenlose Open-Source-KI',
    refreshToReset: 'Aktualisieren für neue Unterhaltung',
    responsesDelay: 'Antworten in 3-5 Sekunden',
    engagementOnly: 'Dieser Chat ist zum Lernen',
    unlimitedAI: 'Für unbegrenzten Chat: ChatGPT, Claude oder Gemini',
    aiNoResponse: 'Entschuldigung, konnte keine Antwort generieren.',
    aiFallbackMessage: 'Verbindungsprobleme. Bitte erneut versuchen oder aktualisieren.',

    // AI Tools Page
    aiToolsTitle: 'KI-Tools-Verzeichnis',
    aiToolsSubtitle: 'Entdecken Sie die besten KI-Tools',
    searchPlaceholder: 'Was möchten Sie tun?',
    allCategories: 'Alle Kategorien',
    visitTool: 'Besuchen',
    free: 'Kostenlos',
    foundToolsFor: '{count} Tools gefunden für "{query}"',
    noAIToolsFound: 'Keine KI-Tools gefunden',
    adjustSearchFilter: 'Versuchen Sie, Ihre Suche oder den Filter anzupassen',

    // Football
    footballTitle: 'Fußball-News-Websites',
    footballSubtitle: 'Neueste Fußball-News weltweit',

    // Programming
    programmingTitle: 'Programmier-Ressourcen',
    programmingSubtitle: 'Lernen und wachsen als Entwickler',

    // Gaming
    gamingTitle: 'Gaming-Websites',
    gamingSubtitle: 'Beste Gaming-Plattformen',

    // SEO
    seoHomeTitle: '3ToolsPro – Kostenlose Online-Tools für den Alltag',
    seoHomeDesc: 'Kostenlose Tools für Text, Entwicklung und Utilities. Schnell, sicher und für professionelle Ergebnisse entwickelt.',
    seoToolsTitle: 'Bibliothek kostenloser Online-Tools | 3ToolsPro',
    seoToolsDesc: 'Stöbern Sie in einer kuratierten Sammlung kostenloser Tools für Produktivität, Text, Entwicklung und Utilities.',
    seoAiChatTitle: 'Kostenloser KI-Chat mit Fair-Use | 3ToolsPro',
    seoAiChatDesc: 'Chatten Sie mit einem kostenlosen KI-Assistenten für schnelle Antworten und Ideen. Fair-Use-Limits gelten.',
    seoAiToolsTitle: 'KI-Tools-Verzeichnis | 3ToolsPro',
    seoAiToolsDesc: 'Entdecken Sie geprüfte KI-Tools für Schreiben, Bild, Video und Produktivität.',
    seoFootballTitle: 'Fußball-News-Quellen | 3ToolsPro',
    seoFootballDesc: 'Finden Sie vertrauenswürdige Fußball-News-Websites aus aller Welt.',
    seoProgrammingTitle: 'Programmier-Ressourcen | 3ToolsPro',
    seoProgrammingDesc: 'Ressourcen, Dokumentation, Tools und Lernlinks für Entwickler aller Stufen.',
    seoGamingTitle: 'Gaming-Ressourcen | 3ToolsPro',
    seoGamingDesc: 'Entdecken Sie Plattformen, Downloads, News und Communities an einem Ort.',
    seoAboutTitle: 'Über 3ToolsPro',
    seoAboutDesc: 'Erfahren Sie mehr über 3ToolsPro, unsere Mission und kostenlose Online-Tools.',
    seoContactTitle: 'Kontakt zu 3ToolsPro',
    seoContactDesc: 'Kontaktieren Sie das 3ToolsPro-Team für Support, Feedback oder Partnerschaften.',
    seoHowToUseTitle: 'So nutzen Sie 3ToolsPro',
    seoHowToUseDesc: 'Schritt-für-Schritt-Anleitung für die effektive Nutzung der 3ToolsPro-Tools.',
    seoPrivacyTitle: 'Datenschutzerklärung | 3ToolsPro',
    seoPrivacyDesc: 'Lesen Sie, wie 3ToolsPro Daten, Datenschutz und Sicherheit behandelt.',
    seoTermsTitle: 'Nutzungsbedingungen | 3ToolsPro',
    seoTermsDesc: 'Lesen Sie die Nutzungsbedingungen für 3ToolsPro und seine kostenlosen Tools.',
    seoWordCounterTitle: 'Wortzähler | 3ToolsPro',
    seoWordCounterDesc: 'Zähle Wörter, Zeichen, Sätze und Absätze sofort. Perfekt für Autoren, Studenten und SEO-Überprüfungen mit privater, browserinterner Analyse.',
    seoTextCaseTitle: 'Textfallkonverter | 3ToolsPro',
    seoTextCaseDesc: 'Konvertiere Text in Großbuchstaben, Kleinbuchstaben, Titel, Satz und mehr. Schnelle, genaue Formatierung für Schreib- und Codieraufgaben.',
    seoTextCompareTitle: 'Textvergleichstool | 3ToolsPro',
    seoTextCompareDesc: 'Vergleiche zwei Texte zeilenweise, um Hinzufügungen, Löschungen und Änderungen zu finden. Ideal für Bearbeitung, Überprüfungen und Inhaltskontrollen.',
    seoLoremIpsumTitle: 'Lorem Ipsum Generator | 3ToolsPro',
    seoLoremIpsumDesc: 'Generiere anpassbaren Lorem Ipsum Platzhaltertext nach Absätzen oder Wörtern. Nützlich für Mockups, Layouts und Designentwürfe.',
    seoJsonFormatterTitle: 'JSON-Formatierer | 3ToolsPro',
    seoJsonFormatterDesc: 'Formatiere, validiere und minifiziere JSON mit lesbarer Ausgabe und sofortigen Fehlern. Perfekt für Entwickler und Datenbereinigung.',
    seoBase64Title: 'Base64 Encoder/Decoder | 3ToolsPro',
    seoBase64Desc: 'Kodiere oder dekodiere Base64-Strings sicher in deinem Browser. Ideal für Datenübertragung, Tests und Entwicklungsworkflows.',
    seoUrlEncoderTitle: 'URL Encoder/Decoder | 3ToolsPro',
    seoUrlEncoderDesc: 'Kodiere oder dekodiere URLs, um Leerzeichen und Sonderzeichen korrekt zu behandeln. Hilfreich für Webformulare, APIs und Debugging.',
    seoPasswordGeneratorTitle: 'Passwort-Generator | 3ToolsPro',
    seoPasswordGeneratorDesc: 'Erstelle starke, sichere Passwörter mit anpassbaren Längen- und Zeichenoptionen. Lokal generiert für Datenschutz.',
    seoRandomNumberTitle: 'Zufallszahlen-Generator | 3ToolsPro',
    seoRandomNumberDesc: 'Generiere Zufallszahlen innerhalb eines Bereichs, mit optionalen eindeutigen Ergebnissen. Nützlich für Spiele, Tests und schnelle Auswahlen.',
    seoAgeCalculatorTitle: 'Altersrechner | 3ToolsPro',
    seoAgeCalculatorDesc: 'Berechne dein genaues Alter mit detaillierten Statistiken, einschließlich Monaten, Tagen und dem nächsten Geburtstag. Schnell und privat.',
    seoUnitConverterTitle: 'Einheitenumrechner | 3ToolsPro',
    seoUnitConverterDesc: 'Konvertiere Längen-, Gewichts-, Temperatur-, Volumen- und Zeiteinheiten sofort mit genauen Ergebnissen und einer einfachen Oberfläche.',
    seoWheelTitle: 'Glücksrad-Auswähler | 3ToolsPro',
    seoWheelDesc: 'Drehe ein anpassbares Rad, um Lebensmittel oder beliebige Gegenstände auszuwählen. Speichere deine Liste lokal und erhalte sofortige Ergebnisse auf jedem Gerät.',

    // Footer
    footerTagline: 'Professionelle kostenlose Tools für alle',
    footerCopyright: '© 2025 3ToolsPro. Alle Rechte vorbehalten.',
    quickLinks: 'Schnelllinks',
    legalInfo: 'Rechtliches & Info',

    // Common
    copy: 'Kopieren',
    copied: 'Kopiert!',
    clear: 'Löschen',
    generate: 'Generieren',
    encode: 'Kodieren',
    decode: 'Dekodieren',
    format: 'Formatieren',
    validate: 'Validieren',
    compare: 'Vergleichen',
    calculate: 'Berechnen',
    owner: 'Eigentümer',
    email: 'E-Mail',
    supportEmail: 'Support-E-Mail',

    // About Page
    aboutUs: 'Über uns',
    aboutSubtitle: 'Erfahren Sie mehr über 3ToolsPro und unsere Mission',
    ourMission: 'Unsere Mission',
    missionText: '3ToolsPro wurde geschaffen, um kostenlose hochwertige Tools bereitzustellen. Wir glauben, dass Produktivitätstools für alle zugänglich sein sollten.',
    missionText2: 'Unsere Plattform bietet eine Sammlung kostenloser Tools. Alle laufen in Ihrem Browser und garantieren Datenschutz.',
    whatWeOffer: 'Was wir bieten',
    offer1: 'Text-Tools: Wortzähler, Konverter',
    offer2: 'Konvertierungs-Tools: JSON, Base64, URL',
    offer3: 'Sicherheits-Tools: Passwort-Generator',
    offer4: 'KI-Chat für schnelle Antworten',
    offer5: 'Verzeichnis der besten KI-Tools',
    contactInfo: 'Kontaktinformationen',

    // Contact Page
    contactUs: 'Kontakt',
    contactSubtitle: 'Nehmen Sie Kontakt auf - wir freuen uns von Ihnen zu hören',
    socialMedia: 'Soziale Medien',
    needHelp: 'Brauchen Sie Hilfe?',
    contactText: 'Bei Fragen kontaktieren Sie uns. Wir antworten in 24-48 Stunden.',

    // Privacy Policy
    privacyPolicy: 'Datenschutzrichtlinie',
    lastUpdated: 'Zuletzt aktualisiert',
    introduction: 'Einführung',
    privacyIntro: 'Bei 3ToolsPro nehmen wir Ihren Datenschutz ernst. Diese Richtlinie erklärt, wie wir Ihre Informationen sammeln und schützen.',
    dataCollection: 'Gesammelte Informationen',
    dataCollectionText: 'Wir sammeln minimale Informationen:',
    dataItem1: 'Nutzungsdaten: Besuchte Seiten (via Google Analytics)',
    dataItem2: 'Geräteinformationen: Browsertyp, OS',
    dataItem3: 'IP-Adresse: Für Sicherheit (anonymisiert)',
    howWeUseData: 'Verwendung der Informationen',
    useItem1: 'Bereitstellung und Wartung unserer Tools',
    useItem2: 'Nutzungsanalyse und Verbesserung',
    useItem3: 'Anzeigen via Google AdSense',
    cookies: 'Cookies',
    cookiesText: 'Wir verwenden Cookies zur Verbesserung Ihrer Erfahrung und zum Speichern Ihrer Präferenzen.',
    thirdParty: 'Drittanbieter-Dienste',
    thirdPartyText: 'Wir nutzen folgende Drittanbieter-Dienste:',
    dataSecurity: 'Datensicherheit',
    dataSecurityText: 'Alle Tools laufen in Ihrem Browser. Ihre Daten werden nicht an unsere Server gesendet.',
    yourRights: 'Ihre Rechte',
    right1: 'Zugriff: Gesammelte Daten anfordern',
    right2: 'Löschung: Löschung anfordern',
    right3: 'Opt-out: Tracking deaktivieren',
    privacyContactText: 'Fragen zum Datenschutz? Kontaktieren Sie uns:',

    // Terms of Service
    termsOfService: 'Nutzungsbedingungen',
    acceptanceOfTerms: 'Akzeptanz der Bedingungen',
    acceptanceText: 'Durch die Nutzung von 3ToolsPro akzeptieren Sie diese Bedingungen. Wenn Sie nicht einverstanden sind, nutzen Sie unsere Dienste nicht.',
    useOfService: 'Nutzung des Dienstes',
    useOfServiceText: 'Unsere Tools sind kostenlos für persönliche und kommerzielle Nutzung:',
    serviceRule1: 'Nutzen Sie unsere Tools für jeden legalen Zweck',
    serviceRule2: 'Versuchen Sie nicht, unsere Tools zu kopieren',
    serviceRule3: 'Nutzen Sie unsere Dienste nicht für illegale Aktivitäten',
    serviceRule4: 'Überlasten Sie unsere Dienste nicht',
    intellectualProperty: 'Geistiges Eigentum',
    intellectualPropertyText: 'Alle Inhalte sind durch geistige Eigentumsgesetze geschützt.',
    userContent: 'Benutzerinhalte',
    userContentText: 'Ihre Daten werden lokal verarbeitet und nicht auf unseren Servern gespeichert.',
    disclaimerText: 'Unsere Tools werden "wie besehen" ohne Garantie bereitgestellt.',
    disclaimerWarning: 'NUTZUNG AUF EIGENE GEFAHR. Wir sind nicht für Datenverlust verantwortlich.',
    limitationOfLiability: 'Haftungsbeschränkung',
    limitationText: 'Wir haften nicht für indirekte Schäden.',
    modifications: 'Änderungen',
    modificationsText: 'Wir können diese Bedingungen jederzeit ändern.',
    governingLaw: 'Anwendbares Recht',
    governingLawText: 'Diese Bedingungen unterliegen ägyptischem Recht.',
    termsContactText: 'Fragen zu den Bedingungen? Kontaktieren Sie uns:',

    // How To Use Page
    howToUse: 'Anleitung',
    howToUseSubtitle: 'Starten Sie mit 3ToolsPro - einfach und kostenlos!',
    step1Title: 'Schritt 1: Wählen Sie Ihr Tool',
    step1Text: 'Durchsuchen Sie unsere kostenlosen Tools:',
    step1Item1: 'Text-Tools: Wortzähler, Konverter',
    step1Item2: 'Daten-Tools: JSON, Base64, URL',
    step1Item3: 'Hilfsmittel: Passwörter, Alter, Einheiten',
    step2Title: 'Schritt 2: Nutzen Sie das Tool',
    step2Text: 'Jedes Tool ist einfach:',
    step2Item1: 'Geben Sie Ihre Daten ein',
    step2Item2: 'Klicken Sie auf die Aktionsschaltfläche',
    step2Item3: 'Sofortige Ergebnisse!',
    step3Title: 'Schritt 3: Kopieren Sie Ihre Ergebnisse',
    step3Text: 'Nach Abschluss:',
    step3Item1: 'Klicken Sie auf "Kopieren"',
    step3Item2: 'Download wenn verfügbar',
    step3Item3: 'Löschen und neu starten',
    step4Title: 'Schritt 4: Entdecken',
    step4Text: 'Besuchen Sie unser KI-Verzeichnis, Fußball-, Programmier- und Gaming-Ressourcen. Probieren Sie den kostenlosen KI-Chat!',
    helpText: 'Hilfe oder Vorschläge? Kontaktieren Sie uns:',

    wordCounterPage: {
      title: 'Wortzähler',
      subtitle: 'Zählen Sie Wörter, Zeichen, Sätze, Absätze und Lesezeit sofort',
      whyTitle: 'Warum diesen Wortzähler verwenden?',
      why1: 'Artikellänge für SEO-Optimierung prüfen',
      why2: 'Zeichen für Social-Media-Limits zählen',
      why3: 'Schreibproduktivität und Genauigkeit verbessern',
      why4: 'Lesezeit automatisch schätzen',
      why5: 'Text sofort analysieren ohne Dateien hochzuladen',
      howTitle: 'So verwenden Sie das Wortzähler-Tool:',
      how1: 'Text oben eingeben oder einfügen',
      how2: 'Statistiken aktualisieren sich automatisch während der Eingabe',
      how3: 'Die Lesezeit basiert auf 200 Wörtern pro Minute',
      how4: 'Die Verarbeitung erfolgt im Browser — Ihr Text wird nicht gespeichert',
      faq: 'FAQ',
      faq1q: 'Ist dieses Tool kostenlos?',
      faq1a: 'Ja, dieses Tool ist vollständig kostenlos ohne Nutzungsbeschränkung.',
      faq2q: 'Wird mein Text gespeichert?',
      faq2a: 'Nein. Die Verarbeitung erfolgt lokal in Ihrem Browser.',
      faq3q: 'Wer kann dieses Tool verwenden?',
      faq3a: 'Autoren, Studenten, Marketer, Entwickler und alle, die mit Text arbeiten.',
      toolWordCounterDesc: "Zählt Wörter und Zeichen sofort.",
toolJSONFormatterDesc: "Formatiert, validiert und verschönert JSON-Daten.",
toolPasswordGeneratorDesc: "Erstellt sichere zufällige Passwörter.",
toolBase64EncoderDesc: "Kodiert und dekodiert Base64-Strings einfach.",
toolAgeCalculatorDesc: "Berechnet das Alter sofort anhand des Geburtsdatums.",
toolTextCaseConverterDesc: "Konvertiert Text in verschiedene Groß- und Kleinschreibungsformate."

      
    },
    seo: {
      wordCounterTitle: 'Kostenloser Wortzähler - Wörter und Zeichen online zählen',
      wordCounterDesc: 'Kostenloses Tool zum Zählen von Wörtern, Zeichen, Sätzen und Lesezeit in Echtzeit.'
    }
  },
  zh: {
    // Navigation
    home: '首页',
    tools: '工具',
    aiChat: '免费AI聊天',
    aiToolsDirectory: 'AI工具目录',
    footballNews: '足球新闻',
    programming: '编程',
    gaming: '游戏',
    gamesHub: '智商游戏',
    gamesHubTitle: '智商与大脑训练游戏',
    gamesHubSubtitle: '免费玩记忆、逻辑、反应和编程游戏，提高注意力，保持大脑活跃。',
    seoGamesTitle: '在线智商游戏 | 3ToolsPro',
    seoGamesDesc: '免费在线玩智商和大脑训练游戏，包括记忆、拼图、反应和编程挑战。移动友好，完全基于浏览器。',
    gameWhatIsTitle: '什么是',
    gameHowToPlayTitle: '如何玩',
    gameSkillsTitle: '提升的技能',
    gameBenefitsTitle: '益处',
    gameFaqTitle: '常见问题',
    gameRelatedTitle: '相关工具与游戏',
    gameScore: '分数',
    gameBest: '最佳',
    gameQuestion: '问题',
    gameNextQuestion: '下一题',
    difficultyEasy: '简单',
    difficultyMedium: '中等',
    difficultyHard: '困难',
    codeOutputTitle: '代码输出猜测',
    codeOutputSubtitle: '一款针对开发者的脑力游戏，磨练JavaScript推理能力。',
    seoCodeOutputTitle: '代码输出猜测游戏 | 3ToolsPro',
    seoCodeOutputDesc: '免费玩编程智商游戏，猜测JavaScript输出。在浏览器中练习逻辑、调试思维和省时的开发者直觉。',
    codeOutputWhatIs: '代码输出猜测是面向开发者和学习者的轻量级编程挑战。训练对语法、作用域和运行时行为的快速分析。',
    codeOutputHow1: '选择难度级别。',
    codeOutputHow2: '仔细阅读JavaScript代码片段。',
    codeOutputHow3: '选择你认为正确的输出。',
    codeOutputHow4: '进入下一题，提高你的分数。',
    codeOutputSkill1: '调试思维',
    codeOutputSkill2: 'JavaScript基础',
    codeOutputSkill3: '时间复杂度直觉',
    codeOutputBenefit1: '更高的开发者参与度',
    codeOutputBenefit2: '有用的面试练习',
    codeOutputBenefit3: '快速的日常学习习惯',
    codeOutputFaq1Q: '问题对初学者友好吗？',
    codeOutputFaq1A: '是的。简单模式专为基础练习设计。',
    codeOutputFaq2Q: '分数会保存吗？',
    codeOutputFaq2A: '最佳分数会保存在你的浏览器本地。',
    memoryGameTitle: '记忆卡片游戏',
    memoryGameSubtitle: '以最少的步数匹配所有对，并打破你的个人最佳纪录。',
    seoMemoryGameTitle: '记忆卡片游戏 | 3ToolsPro',
    seoMemoryGameDesc: '免费在线玩记忆卡片游戏，训练注意力和短期记忆。通过这款脑力游戏跟踪你的最佳分数并提高专注力。',
    memoryWhatIs: '这款轻量级脑力游戏通过匹配符号对，帮助儿童和成人加强视觉记忆和专注力。',
    memoryHow1: '点击一张卡片将其翻开。',
    memoryHow2: '点击第二张卡片寻找匹配。',
    memoryHow3: '继续匹配对，直到棋盘解决。',
    memoryHow4: '尝试每回合用更少的步数完成。',
    memorySkill1: '工作记忆',
    memorySkill2: '视觉注意力',
    memorySkill3: '模式识别',
    memoryBenefit1: '快速每日大脑锻炼',
    memoryBenefit2: '适合家庭的游戏玩法',
    memoryBenefit3: '无需账户或下载',
    memoryFaq1Q: '这个游戏会保存我的最佳分数吗？',
    memoryFaq1A: '是的，你的最佳移动次数会存储在此设备的localStorage中。',
    memoryFaq2Q: '孩子可以玩这个游戏吗？',
    memoryFaq2A: '可以，它使用简单的视觉效果和触控友好控制。',
    numberPuzzleTitle: '数字拼图',
    numberPuzzleSubtitle: '将方块滑动到从1到8的正确顺序。',
    seoNumberPuzzleTitle: '数字拼图游戏 | 3ToolsPro',
    seoNumberPuzzleDesc: '免费在线玩3x3数字拼图游戏。提高解决问题和逻辑技能，跟踪最佳移动，享受快速的浏览器挑战。',
    numberPuzzleSolved: '做得好！拼图在{moves}步内完成。',
    numberPuzzleWhatIs: '数字拼图是一款经典逻辑游戏，你滑动编号方块以恢复正确顺序。',
    numberPuzzleHow1: '点击空格旁边的方块。',
    numberPuzzleHow2: '继续一次一步移动方块。',
    numberPuzzleHow3: '将数字1到8按顺序排列。',
    numberPuzzleHow4: '重玩并提高你的最佳分数。',
    numberPuzzleSkill1: '问题解决',
    numberPuzzleSkill2: '提前规划',
    numberPuzzleSkill3: '空间推理',
    numberPuzzleBenefit1: '快速大脑锻炼',
    numberPuzzleBenefit2: '提高耐心和专注力',
    numberPuzzleBenefit3: '在移动设备和电脑上流畅运行',
    numberPuzzleFaq1Q: '这个游戏需要互联网吗？',
    numberPuzzleFaq1A: '不需要。一旦加载，游戏完全在客户端运行。',
    numberPuzzleFaq2Q: '最佳分数会被保存吗？',
    numberPuzzleFaq2A: '是的，你的最佳移动次数会保存在localStorage中。',
    reactionTestTitle: '快速反应测试',
    reactionTestSubtitle: '测量你的反射速度并保持最佳分数。',
    seoReactionTestTitle: '快速反应测试 | 3ToolsPro',
    seoReactionTestDesc: '免费在线测试你的反应速度。通过这款轻量级浏览器游戏跟踪你的最佳反射分数并提高专注力。',
    reactionWhatIs: '快速反应测试是一款简单的反射游戏，测量你对视觉信号的反应速度。',
    reactionHow1: '按下开始以启动测试。',
    reactionHow2: '等待面板变绿。',
    reactionHow3: '当"准备"出现时立即点击。',
    reactionHow4: '重复并提高你的最佳时间。',
    reactionSkill1: '反射速度',
    reactionSkill2: '视觉聚焦',
    reactionSkill3: '反应控制',
    reactionBenefit1: '快速每日挑战',
    reactionBenefit2: '适合所有年龄段',
    reactionBenefit3: '无需注册或安装',
    reactionFaq1Q: '什么是好的反应时间？',
    reactionFaq1A: '对许多人来说，200–300毫秒是一个不错的结果。',
    reactionFaq2Q: '我可以在手机上使用吗？',
    reactionFaq2A: '可以，游戏针对移动触摸进行了优化。',
    gameMoves: '步数',
    gameRestart: '重新开始',
    selectLanguage: '选择语言',
    more: '更多',
    resources: '资源',

    // Home Page
    heroTitle: '免费在线工具，加速您的工作',
    heroSubtitle: '专业的日常任务工具。快速、安全，无需注册。',
    startUsing: '开始使用',
    ourTools: '我们的工具',
    ourToolsSubtitle: '所有工具100%免费，即时运行，无需注册。',
    allFree: '100%永久免费',
    instantResults: '即时结果',
    noSignup: '无需注册',
    freeAIChat: '免费AI聊天',

    // Shared UI
    adLabel: '广告',
    adAreaAriaLabel: '赞助内容区域',
    adPlaceholderLabel: 'Google AdSense 广告位',
    adPlaceholderBetweenSections: '内容内广告位',
    visitSite: '访问网站',
    noSitesFound: '未找到网站',
    selectDifferentRegion: '尝试选择其他地区',
    aiServiceUnavailable: '服务暂时不可用',
    aiUnexpectedError: '出错了。请重试。',

    // Home Card Descriptions
    aiChatDesc: '免费与AI聊天 - 有限使用',
    aiToolsDesc: '发现最好的AI工具',
    footballDesc: '世界各地的最新足球新闻',
    programmingDesc: '开发者资源',
    gamingDesc: '最佳游戏平台',

    // Tools Page
    toolsPageTitle: '免费在线工具',
    toolsPageSubtitle: '专业的日常任务工具。快速、安全，无需注册。',

    // Tool Categories
    categoryAll: '全部',
    categoryTextContent: '文本与内容',
    categoryDeveloper: '开发者',
    categoryUtility: '实用工具',

    // Tool Names
    toolWordCounter: '字数统计',
    toolTextCaseConverter: '大小写转换',
    toolTextCompare: '文本比较',
    toolLoremIpsum: 'Lorem Ipsum生成器',
    toolJSONFormatter: 'JSON格式化',
    toolBase64Encoder: 'Base64编码/解码',
    toolURLEncoder: 'URL编码/解码',
    toolPasswordGenerator: '密码生成器',
    toolRandomNumber: '随机数生成器',
    toolAgeCalculator: '年龄计算器',
    toolUnitConverter: '单位转换器',
    toolWheelOfFortune: '命运之轮',
    toolWheelOfFortuneDesc: '旋转可定制的轮盘，随机选择食物或物品',

    // AI Chat Status
    connectionStatus: '状态',
    aiStatusOnline: '在线',
    aiStatusOffline: '离线模式',
    aiLocalModeNotice: 'AI服务当前不可用，因此您正在使用离线响应。',
    openChatGPT: '打开ChatGPT',
    aiLocalResponse1: '我现在离线，但我仍然可以提供帮助。尝试细化你的问题或要求快速大纲。',
    aiLocalResponse2: '这是一个快速建议：将任务分解为步骤，从最重要的部分开始。',
    aiLocalResponse3: '如果你需要详细结果，请稍后再试。目前，我可以提供简要摘要或清单。',

    // Wheel of Fortune UI
    wheelTitle: '命运之轮（食物选择器）',
    wheelSubtitle: '添加选项，旋转轮盘，即时获得随机选择。',
    wheelSpin: '旋转轮盘',
    wheelSpinning: '旋转中...',
    wheelResultLabel: '选择的结果',
    wheelResultPlaceholder: '添加物品并旋转以选择',
    wheelManageTitle: '管理你的物品',
    wheelManageSubtitle: '添加食物或选项，并将其保存在此设备上。',
    wheelInputPlaceholder: '输入食物或物品',
    wheelAdd: '添加',
    wheelEmpty: '暂无物品。至少添加两个才能旋转。',
    wheelRemove: '移除',
    wheelReset: '重置列表',

    // Tool Content - Age Calculator
    toolAgeWhatTitle: '什么是年龄计算器？',
    toolAgeWhatDesc: '年龄计算器帮助你从出生日期找出你的确切年龄和关键里程碑。',
    toolAgeHowTitle: '如何使用年龄计算器',
    toolAgeHow1: '选择你的出生日期。',
    toolAgeHow2: '点击计算以查看你的年龄详情。',
    toolAgeHow3: '查看总计，如天数、月份和下一个生日。',
    toolAgeBenefitsTitle: '益处',
    toolAgeBenefit1: '即时获取准确的年龄详情。',
    toolAgeBenefit2: '查看有用的总计，如天数和月份。',
    toolAgeBenefit3: '一切在本地运行，保护隐私。',
    toolAgeFaqTitle: '常见问题',
    toolAgeFaq1Q: '计算准确吗？',
    toolAgeFaq1A: '是的，它使用你设备的本地日期和时间以获得精确结果。',
    toolAgeFaq2Q: '我的日期会存储在任何地方吗？',
    toolAgeFaq2A: '不会。所有计算都在你的浏览器中进行。',

    // Tool Content - Base64
    toolBase64WhatTitle: '什么是Base64编码/解码器？',
    toolBase64WhatDesc: '此工具将文本与Base64相互转换，用于安全传输和测试。',
    toolBase64HowTitle: '如何使用Base64工具',
    toolBase64How1: '选择编码或解码模式。',
    toolBase64How2: '粘贴你的文本或Base64字符串。',
    toolBase64How3: '点击处理并复制结果。',
    toolBase64BenefitsTitle: '益处',
    toolBase64Benefit1: '快速转换数据，无需上传。',
    toolBase64Benefit2: '对开发和调试有帮助。',
    toolBase64Benefit3: '完全在你的浏览器中运行。',
    toolBase64FaqTitle: '常见问题',
    toolBase64Faq1Q: 'Base64是加密吗？',
    toolBase64Faq1A: '不，Base64是一种编码格式，可以轻松逆转。',
    toolBase64Faq2Q: '工具会存储我的数据吗？',
    toolBase64Faq2A: '不会。你的数据留在你的设备上。',

    // Tool Content - JSON Formatter
    toolJsonWhatTitle: '什么是JSON格式化器？',
    toolJsonWhatDesc: '格式化、验证和压缩JSON，输出清晰，错误即时显示。',
    toolJsonHowTitle: '如何使用JSON格式化器',
    toolJsonHow1: '将JSON粘贴到输入框中。',
    toolJsonHow2: '选择格式化、压缩或验证。',
    toolJsonHow3: '准备就绪后复制输出。',
    toolJsonBenefitsTitle: '益处',
    toolJsonBenefit1: '提高可读性，便于调试。',
    toolJsonBenefit2: '通过验证快速捕捉错误。',
    toolJsonBenefit3: '为生产使用压缩JSON。',
    toolJsonFaqTitle: '常见问题',
    toolJsonFaq1Q: '它支持数组吗？',
    toolJsonFaq1A: '是的，支持数组和对象。',
    toolJsonFaq2Q: '我的数据会发送到服务器吗？',
    toolJsonFaq2A: '不会，一切都在你的浏览器中运行。',

    // Tool Content - Lorem Ipsum
    toolLoremWhatTitle: '什么是Lorem Ipsum生成器？',
    toolLoremWhatDesc: '生成占位文本，用于填充布局、模型和设计草稿。',
    toolLoremHowTitle: '如何使用Lorem Ipsum生成器',
    toolLoremHow1: '选择段落数和每段单词数。',
    toolLoremHow2: '选择是否以“Lorem”开头。',
    toolLoremHow3: '点击生成并复制输出。',
    toolLoremBenefitsTitle: '益处',
    toolLoremBenefit1: '快速创建逼真的布局填充。',
    toolLoremBenefit2: '为任何项目自定义长度。',
    toolLoremBenefit3: '无需下载或注册。',
    toolLoremFaqTitle: '常见问题',
    toolLoremFaq1Q: '我可以更改长度吗？',
    toolLoremFaq1A: '是的，你可以控制段落数和单词数。',
    toolLoremFaq2Q: '文本是否无版权？',
    toolLoremFaq2A: '是的，它是标准的占位文本。',

    // Tool Content - Password Generator
    toolPasswordWhatTitle: '什么是密码生成器？',
    toolPasswordWhatDesc: '使用自定义长度和字符选项创建强密码。',
    toolPasswordHowTitle: '如何使用密码生成器',
    toolPasswordHow1: '调整长度和字符设置。',
    toolPasswordHow2: '点击生成以创建密码。',
    toolPasswordHow3: '复制密码以供使用。',
    toolPasswordBenefitsTitle: '益处',
    toolPasswordBenefit1: '即时创建安全密码。',
    toolPasswordBenefit2: '根据需求自定义强度。',
    toolPasswordBenefit3: '本地生成，保护隐私。',
    toolPasswordFaqTitle: '常见问题',
    toolPasswordFaq1Q: '密码会被存储吗？',
    toolPasswordFaq1A: '不会，密码在本地生成，从不保存。',
    toolPasswordFaq2Q: '密码应该多长？',
    toolPasswordFaq2A: '我们建议使用12个以上字符以确保强安全性。',

    // Tool Content - Random Number
    toolRandomWhatTitle: '什么是随机数生成器？',
    toolRandomWhatDesc: '在自定义范围内生成随机数，用于游戏、测试或选择。',
    toolRandomHowTitle: '如何使用随机数生成器',
    toolRandomHow1: '设置你的最小和最大范围。',
    toolRandomHow2: '选择要生成的数字数量。',
    toolRandomHow3: '点击生成并复制结果。',
    toolRandomBenefitsTitle: '益处',
    toolRandomBenefit1: '为任何任务快速随机选择。',
    toolRandomBenefit2: '支持唯一或重复结果。',
    toolRandomBenefit3: '在你的浏览器中即时工作。',
    toolRandomFaqTitle: '常见问题',
    toolRandomFaq1Q: '我可以避免重复吗？',
    toolRandomFaq1A: '可以，禁用重复以获取唯一数字。',
    toolRandomFaq2Q: '我可以生成多少个数字？',
    toolRandomFaq2A: '每次最多100个数字。',

    // Tool Content - Text Case Converter
    toolCaseWhatTitle: '什么是大小写转换器？',
    toolCaseWhatDesc: '将文本转换为不同的大小写，用于写作、格式化和编码。',
    toolCaseHowTitle: '如何使用大小写转换器',
    toolCaseHow1: '粘贴或输入你的文本。',
    toolCaseHow2: '选择要应用的大小写。',
    toolCaseHow3: '复制更新后的文本。',
    toolCaseBenefitsTitle: '益处',
    toolCaseBenefit1: '即时标准化文本格式。',
    toolCaseBenefit2: '对标题、标头和代码很有用。',
    toolCaseBenefit3: '没有数据离开你的浏览器。',
    toolCaseFaqTitle: '常见问题',
    toolCaseFaq1Q: '我可以转换大量文本吗？',
    toolCaseFaq1A: '可以，支持大块文本。',
    toolCaseFaq2Q: '它会保留标点符号吗？',
    toolCaseFaq2A: '是的，标点符号保持不变。',

    // Tool Content - Text Compare
    toolCompareWhatTitle: '什么是文本比较工具？',
    toolCompareWhatDesc: '逐行比较两个文本，查找更改、添加和删除。',
    toolCompareHowTitle: '如何使用文本比较工具',
    toolCompareHow1: '将原始文本粘贴到第一个框中。',
    toolCompareHow2: '将修改后的文本粘贴到第二个框中。',
    toolCompareHow3: '点击比较以查看差异。',
    toolCompareBenefitsTitle: '益处',
    toolCompareBenefit1: '在审查期间快速发现更改。',
    toolCompareBenefit2: '清晰突出显示编辑和更新。',
    toolCompareBenefit3: '非常适合作家和开发者。',
    toolCompareFaqTitle: '常见问题',
    toolCompareFaq1Q: '它是逐行比较吗？',
    toolCompareFaq1A: '是的，它逐行比较文本。',
    toolCompareFaq2Q: '我的文本会被存储吗？',
    toolCompareFaq2A: '不会，比较在本地运行。',

    // Tool Content - URL Encoder
    toolUrlWhatTitle: '什么是URL编码/解码器？',
    toolUrlWhatDesc: '编码或解码URL，以安全处理网页链接中的特殊字符。',
    toolUrlHowTitle: '如何使用URL编码器',
    toolUrlHow1: '选择编码或解码模式。',
    toolUrlHow2: '粘贴你的URL或文本。',
    toolUrlHow3: '点击处理并复制结果。',
    toolUrlBenefitsTitle: '益处',
    toolUrlBenefit1: '避免网页表单中的链接损坏。',
    toolUrlBenefit2: '非常适合API和查询字符串。',
    toolUrlBenefit3: '快速的基于浏览器的处理。',
    toolUrlFaqTitle: '常见问题',
    toolUrlFaq1Q: '哪些字符会被编码？',
    toolUrlFaq1A: '空格和特殊字符会被转换为安全代码。',
    toolUrlFaq2Q: '它支持完整的URL吗？',
    toolUrlFaq2A: '是的，它适用于完整URL和查询字符串。',

    // Tool Content - Unit Converter
    toolUnitWhatTitle: '什么是单位转换器？',
    toolUnitWhatDesc: '在长度、重量、温度、体积和时间的常用单位之间转换。',
    toolUnitHowTitle: '如何使用单位转换器',
    toolUnitHow1: '选择一个类别，如长度或温度。',
    toolUnitHow2: '选择要转换的单位。',
    toolUnitHow3: '输入一个值以立即查看结果。',
    toolUnitBenefitsTitle: '益处',
    toolUnitBenefit1: '几秒钟内完成准确转换。',
    toolUnitBenefit2: '支持多个类别。',
    toolUnitBenefit3: '在任何设备上易于使用。',
    toolUnitFaqTitle: '常见问题',
    toolUnitFaq1Q: '支持哪些单位？',
    toolUnitFaq1A: '长度、重量、温度、体积和时间。',
    toolUnitFaq2Q: '转换准确吗？',
    toolUnitFaq2A: '是的，使用标准转换因子。',

    // Tool Content - Wheel of Fortune
    wheelWhatTitle: '什么是命运之轮工具？',
    wheelWhatDesc: '一个有趣的交互式选择器，通过旋转可定制的轮盘帮助你决定。',
    wheelHowTitle: '如何使用命运之轮',
    wheelHow1: '将食物或物品添加到你的列表。',
    wheelHow2: '点击旋转以动画显示轮盘。',
    wheelHow3: '立即查看所选结果。',
    wheelBenefitsTitle: '益处',
    wheelBenefit1: '非常适合快速决策和小组选择。',
    wheelBenefit2: '物品在你的设备上本地保存。',
    wheelBenefit3: '在移动设备和电脑上流畅运行。',
    wheelFaqTitle: '常见问题',
    wheelFaq1Q: '我的物品会被保存吗？',
    wheelFaq1A: '是的，物品会存储在你设备上的localStorage中。',
    wheelFaq2Q: '我可以重置列表吗？',
    wheelFaq2A: '可以，使用重置按钮清除所有物品。',

    // Tools Features
    featureFast: '闪电般快速',
    featureFastDesc: '所有工具直接在浏览器中运行',
    featureSecure: '100%安全',
    featureSecureDesc: '您的数据永不离开您的设备',
    featureFree: '完全免费',
    featureFreeDesc: '无需注册，无限制，无隐藏费用',

    // AI Chat
    freeAIChatTitle: '免费AI聊天',
    freeAIChatSubtitle: '与AI助手聊天',
    fairUsagePolicy: '免费AI聊天 – 公平使用政策',
    disclaimer: '免责声明',
    aiDisclaimer: '这是一个免费的AI聊天。回复由AI生成，可能并不总是准确。如需无限制专业聊天，请尝试ChatGPT、Claude或Gemini。',
    startConversation: '开始对话！问我任何问题。',
    exampleQuestions: '试试："给我讲个笑话"或"什么是AI？"',
    aiThinking: 'AI思考中...',
    typePlaceholder: '输入消息...',
    sendMessage: '发送',
    pressEnter: '按Enter发送',
    freeServiceNotice: '免费服务，有使用限制',
    aboutFreeAIChat: '关于AI聊天',
    poweredByHF: '由Hugging Face提供支持 - 免费开源AI',
    refreshToReset: '刷新页面开始新对话',
    responsesDelay: '回复通常在3-5秒内',
    engagementOnly: '此聊天用于学习',
    unlimitedAI: '无限制聊天：ChatGPT、Claude或Gemini',
    aiNoResponse: '抱歉，无法生成回复。',
    aiFallbackMessage: '连接问题。请重试或刷新页面。',

    // AI Tools Page
    aiToolsTitle: 'AI工具目录',
    aiToolsSubtitle: '发现最好的AI工具',
    searchPlaceholder: '您想做什么？',
    allCategories: '所有类别',
    visitTool: '访问',
    free: '免费',
    foundToolsFor: '为"{query}"找到{count}个工具',
    noAIToolsFound: '未找到AI工具',
    adjustSearchFilter: '尝试调整搜索或类别筛选',

    // Football
    footballTitle: '足球新闻网站',
    footballSubtitle: '世界各地的最新足球新闻',

    // Programming
    programmingTitle: '编程资源',
    programmingSubtitle: '作为开发者学习和成长',

    // Gaming
    gamingTitle: '游戏网站',
    gamingSubtitle: '最佳游戏平台',

    // SEO
    seoHomeTitle: '3ToolsPro - 免费在线工具，提升日常效率',
    seoHomeDesc: '提供文本、开发者和实用工具的免费在线工具。快速、安全，适合专业使用。',
    seoToolsTitle: '免费在线工具库 | 3ToolsPro',
    seoToolsDesc: '浏览精选的免费在线工具，涵盖生产力、文本、开发和实用需求。',
    seoAiChatTitle: '免费AI聊天（公平使用）| 3ToolsPro',
    seoAiChatDesc: '与免费AI助手聊天，获取快速回答和灵感。为保证公平使用，设有使用限制。',
    seoAiToolsTitle: 'AI工具目录 | 3ToolsPro',
    seoAiToolsDesc: '探索经过筛选的AI工具，覆盖写作、图像、视频和效率。',
    seoFootballTitle: '足球新闻来源 | 3ToolsPro',
    seoFootballDesc: '发现全球可靠的足球新闻网站，随时掌握最新动态。',
    seoProgrammingTitle: '编程资源 | 3ToolsPro',
    seoProgrammingDesc: '为各级开发者提供资源、文档、工具和学习链接。',
    seoGamingTitle: '游戏资源 | 3ToolsPro',
    seoGamingDesc: '一站式查看游戏平台、下载、新闻和社区资源。',
    seoAboutTitle: '关于3ToolsPro',
    seoAboutDesc: '了解3ToolsPro以及我们提供免费在线工具的使命。',
    seoContactTitle: '联系3ToolsPro',
    seoContactDesc: '联系3ToolsPro团队获取支持、反馈或合作咨询。',
    seoHowToUseTitle: '如何使用3ToolsPro',
    seoHowToUseDesc: '分步指南，帮助高效使用3ToolsPro工具并获得专业结果。',
    seoPrivacyTitle: '隐私政策 | 3ToolsPro',
    seoPrivacyDesc: '了解3ToolsPro如何处理数据、隐私与安全。',
    seoTermsTitle: '服务条款 | 3ToolsPro',
    seoTermsDesc: '查看使用3ToolsPro及其免费工具的服务条款。',
    seoWordCounterTitle: '字数统计 | 3ToolsPro',
    seoWordCounterDesc: '即时统计单词、字符、句子和段落。非常适合作家、学生和SEO检查，在浏览器中进行私密分析。',
    seoTextCaseTitle: '大小写转换器 | 3ToolsPro',
    seoTextCaseDesc: '将文本转换为大写、小写、标题、句子等格式。快速准确的格式化，适用于写作和编码任务。',
    seoTextCompareTitle: '文本比较工具 | 3ToolsPro',
    seoTextCompareDesc: '逐行比较两个文本，查找添加、删除和更改。非常适合编辑、审阅和内容检查。',
    seoLoremIpsumTitle: 'Lorem Ipsum生成器 | 3ToolsPro',
    seoLoremIpsumDesc: '按段落或单词生成可定制的Lorem Ipsum占位文本。适用于模型、布局和设计草稿。',
    seoJsonFormatterTitle: 'JSON格式化器 | 3ToolsPro',
    seoJsonFormatterDesc: '格式化、验证和压缩JSON，输出可读，错误即时显示。非常适合开发者和数据清理。',
    seoBase64Title: 'Base64编码/解码器 | 3ToolsPro',
    seoBase64Desc: '在浏览器中安全地编码或解码Base64字符串。非常适合数据传输、测试和开发工作流。',
    seoUrlEncoderTitle: 'URL编码/解码器 | 3ToolsPro',
    seoUrlEncoderDesc: '编码或解码URL，正确处理空格和特殊字符。有助于Web表单、API和调试。',
    seoPasswordGeneratorTitle: '密码生成器 | 3ToolsPro',
    seoPasswordGeneratorDesc: '使用可定制的长度和字符选项创建强大、安全的密码。本地生成，保护隐私。',
    seoRandomNumberTitle: '随机数生成器 | 3ToolsPro',
    seoRandomNumberDesc: '在范围内生成随机数，可选唯一结果。适用于游戏、测试和快速选择。',
    seoAgeCalculatorTitle: '年龄计算器 | 3ToolsPro',
    seoAgeCalculatorDesc: '计算你的确切年龄，包含详细统计，包括月份、天数和下一个生日。快速且私密。',
    seoUnitConverterTitle: '单位转换器 | 3ToolsPro',
    seoUnitConverterDesc: '即时转换长度、重量、温度、体积和时间单位，结果准确，界面易用。',
    seoWheelTitle: '命运之轮选择器 | 3ToolsPro',
    seoWheelDesc: '旋转可定制的轮盘来选择食物或任何物品。本地保存列表，在任何设备上即时获得结果。',

    // Footer
    footerTagline: '为所有人提供的专业免费工具',
    footerCopyright: '© 2025 3ToolsPro. 保留所有权利。',
    quickLinks: '快速链接',
    legalInfo: '法律与信息',

    // Common
    copy: '复制',
    copied: '已复制！',
    clear: '清除',
    generate: '生成',
    encode: '编码',
    decode: '解码',
    format: '格式化',
    validate: '验证',
    compare: '比较',
    calculate: '计算',
    owner: '所有者',
    email: '邮箱',
    supportEmail: '支持邮箱',

    // About Page
    aboutUs: '关于我们',
    aboutSubtitle: '了解3ToolsPro和我们的使命',
    ourMission: '我们的使命',
    missionText: '3ToolsPro旨在提供免费的高质量工具。我们相信生产力工具应该对每个人都是可访问的。',
    missionText2: '我们的平台提供免费工具集合。所有工具都在您的浏览器中运行，确保隐私。',
    whatWeOffer: '我们提供',
    offer1: '文本工具：字数统计、转换器',
    offer2: '转换工具：JSON、Base64、URL',
    offer3: '安全工具：密码生成器',
    offer4: 'AI聊天快速回答',
    offer5: '最佳AI工具目录',
    contactInfo: '联系信息',

    // Contact Page
    contactUs: '联系我们',
    contactSubtitle: '联系我们 - 我们很乐意听到您的声音',
    socialMedia: '社交媒体',
    needHelp: '需要帮助？',
    contactText: '如有问题请联系我们。我们通常在24-48小时内回复。',

    // Privacy Policy
    privacyPolicy: '隐私政策',
    lastUpdated: '最后更新',
    introduction: '介绍',
    privacyIntro: '在3ToolsPro，我们认真对待您的隐私。本政策解释我们如何收集和保护您的信息。',
    dataCollection: '收集的信息',
    dataCollectionText: '我们收集最少的信息：',
    dataItem1: '使用数据：访问的页面（通过Google Analytics）',
    dataItem2: '设备信息：浏览器类型、操作系统',
    dataItem3: 'IP地址：用于安全（匿名化）',
    howWeUseData: '信息使用',
    useItem1: '提供和维护我们的工具',
    useItem2: '分析使用并改进体验',
    useItem3: '通过Google AdSense显示广告',
    cookies: 'Cookies',
    cookiesText: '我们使用cookies改善您的体验并记住您的偏好。',
    thirdParty: '第三方服务',
    thirdPartyText: '我们使用以下第三方服务：',
    dataSecurity: '数据安全',
    dataSecurityText: '所有工具在您的浏览器中运行。您的数据不会发送到我们的服务器。',
    yourRights: '您的权利',
    right1: '访问：请求收集的数据',
    right2: '删除：请求删除',
    right3: '退出：禁用跟踪',
    privacyContactText: '隐私问题？联系我们：',

    // Terms of Service
    termsOfService: '服务条款',
    acceptanceOfTerms: '接受条款',
    acceptanceText: '使用3ToolsPro即表示您接受这些条款。如果不同意，请勿使用我们的服务。',
    useOfService: '服务使用',
    useOfServiceText: '我们的工具对个人和商业使用免费：',
    serviceRule1: '您可以将我们的工具用于任何合法目的',
    serviceRule2: '不要尝试复制我们的工具',
    serviceRule3: '不要将我们的服务用于非法活动',
    serviceRule4: '不要使我们的服务过载',
    intellectualProperty: '知识产权',
    intellectualPropertyText: '所有内容受知识产权法保护。',
    userContent: '用户内容',
    userContentText: '您的数据在本地处理，不存储在我们的服务器上。',
    disclaimerText: '我们的工具按"原样"提供，不提供保证。',
    disclaimerWarning: '使用风险自负。我们不对数据丢失负责。',
    limitationOfLiability: '责任限制',
    limitationText: '我们不对间接损害负责。',
    modifications: '修改',
    modificationsText: '我们可以随时修改这些条款。',
    governingLaw: '适用法律',
    governingLawText: '这些条款受埃及法律管辖。',
    termsContactText: '条款问题？联系我们：',

    // How To Use Page
    howToUse: '使用指南',
    howToUseSubtitle: '开始使用3ToolsPro - 简单又免费！',
    step1Title: '步骤1：选择您的工具',
    step1Text: '浏览我们的免费工具：',
    step1Item1: '文本工具：字数统计、转换器',
    step1Item2: '数据工具：JSON、Base64、URL',
    step1Item3: '实用工具：密码、年龄、单位',
    step2Title: '步骤2：使用工具',
    step2Text: '每个工具都很简单：',
    step2Item1: '输入您的数据',
    step2Item2: '点击操作按钮',
    step2Item3: '即时结果！',
    step3Title: '步骤3：复制您的结果',
    step3Text: '完成后：',
    step3Item1: '点击"复制"',
    step3Item2: '如可用则下载',
    step3Item3: '清除并重新开始',
    step4Title: '步骤4：探索',
    step4Text: '查看我们的AI目录、足球、编程和游戏资源。试试免费AI聊天！',
    helpText: '需要帮助或建议？联系我们：',

    wordCounterPage: {
      title: '字数统计工具',
      subtitle: '即时统计字数、字符、句子、段落和阅读时间',
      whyTitle: '为什么使用这个字数统计工具？',
      why1: '检查文章长度以优化SEO',
      why2: '统计字符以满足社交媒体限制',
      why3: '提高写作效率和准确性',
      why4: '自动估算阅读时间',
      why5: '无需上传文件即可即时分析文本',
      howTitle: '如何使用字数统计工具：',
      how1: '在上方输入或粘贴文本',
      how2: '统计数据会在输入时自动更新',
      how3: '阅读时间基于每分钟200个单词计算',
      how4: '所有处理都在浏览器中完成——文本不会被保存',
      faq: '常见问题',
      faq1q: '这个工具是免费的吗？',
      faq1a: '是的，该工具完全免费且无限使用。',
      faq2q: '我的文本会被保存吗？',
      faq2a: '不会。所有处理都在您的浏览器本地完成。',
      faq3q: '谁可以使用这个工具？',
      faq3a: '作家、学生、市场人员、开发者以及任何处理文本的人。' ,
      toolWordCounterDesc: "即时统计单词和字符数量。",
toolJSONFormatterDesc: "格式化、验证并美化 JSON 数据。",
toolPasswordGeneratorDesc: "生成安全的随机密码。",
toolBase64EncoderDesc: "轻松编码和解码 Base64 字符串。",
toolAgeCalculatorDesc: "根据出生日期即时计算年龄。",
toolTextCaseConverterDesc: "将文本转换为不同的大小写格式。"

    },
    seo: {
      wordCounterTitle: '免费字数统计工具 - 在线统计字数和字符',
      wordCounterDesc: '免费的在线字数统计工具，可即时统计字数、字符、句子和阅读时间。'
    }
  },
  pt: {
    // Navigation
    home: 'Início',
    tools: 'Ferramentas',
    aiChat: 'Chat IA Grátis',
    aiToolsDirectory: 'Diretório IA',
    footballNews: 'Notícias de Futebol',
    programming: 'Programação',
    gaming: 'Jogos',
    gamesHub: 'Jogos de QI',
    gamesHubTitle: 'Jogos de treinamento cerebral e QI',
    gamesHubSubtitle: 'Jogue gratuitamente jogos de memória, lógica, reação e código para melhorar o foco e manter seu cérebro ativo.',
    seoGamesTitle: 'Jogos de QI online | 3ToolsPro',
    seoGamesDesc: 'Jogue gratuitamente jogos de QI e treinamento cerebral online, incluindo desafios de memória, quebra-cabeça, reação e código. Compatível com dispositivos móveis e totalmente baseado no navegador.',
    gameWhatIsTitle: 'O que é',
    gameHowToPlayTitle: 'Como jogar',
    gameSkillsTitle: 'Habilidades melhoradas',
    gameBenefitsTitle: 'Benefícios',
    gameFaqTitle: 'FAQ',
    gameRelatedTitle: 'Ferramentas e jogos relacionados',
    gameScore: 'Pontuação',
    gameBest: 'Melhor',
    gameQuestion: 'Pergunta',
    gameNextQuestion: 'Próxima pergunta',
    difficultyEasy: 'Fácil',
    difficultyMedium: 'Médio',
    difficultyHard: 'Difícil',
    codeOutputTitle: 'Adivinhar a saída do código',
    codeOutputSubtitle: 'Um jogo cerebral para desenvolvedores aprimorar o raciocínio em JavaScript.',
    seoCodeOutputTitle: 'Jogo Adivinhar a saída do código | 3ToolsPro',
    seoCodeOutputDesc: 'Jogue gratuitamente um jogo de QI de programação e adivinhe a saída JavaScript. Pratique lógica, mentalidade de depuração e intuição de desenvolvedor no seu navegador.',
    codeOutputWhatIs: 'Adivinhar a saída do código é um desafio de programação leve para desenvolvedores e aprendizes. Ele treina a análise rápida de sintaxe, escopo e comportamento em tempo de execução.',
    codeOutputHow1: 'Escolha um nível de dificuldade.',
    codeOutputHow2: 'Leia o trecho de JavaScript cuidadosamente.',
    codeOutputHow3: 'Selecione a saída que você acha correta.',
    codeOutputHow4: 'Vá para a próxima pergunta e melhore sua pontuação.',
    codeOutputSkill1: 'Mentalidade de depuração',
    codeOutputSkill2: 'Fundamentos de JavaScript',
    codeOutputSkill3: 'Intuição de complexidade de tempo',
    codeOutputBenefit1: 'Maior engajamento do desenvolvedor',
    codeOutputBenefit2: 'Prática útil para entrevistas',
    codeOutputBenefit3: 'Hábito de aprendizado diário rápido',
    codeOutputFaq1Q: 'As perguntas são amigáveis para iniciantes?',
    codeOutputFaq1A: 'Sim. O modo fácil é projetado para prática fundamental.',
    codeOutputFaq2Q: 'A pontuação é salva?',
    codeOutputFaq2A: 'A melhor pontuação é salva localmente no seu navegador.',
    memoryGameTitle: 'Jogo de cartas de memória',
    memoryGameSubtitle: 'Combine todos os pares no menor número de movimentos e supere sua melhor pontuação pessoal.',
    seoMemoryGameTitle: 'Jogo de cartas de memória | 3ToolsPro',
    seoMemoryGameDesc: 'Jogue gratuitamente um jogo de cartas de memória online para treinar foco e memória de curto prazo. Acompanhe sua melhor pontuação e melhore a concentração com este jogo cerebral.',
    memoryWhatIs: 'Este jogo cerebral leve ajuda crianças e adultos a fortalecer a memória visual e a concentração combinando pares de símbolos.',
    memoryHow1: 'Toque em uma carta para revelá-la.',
    memoryHow2: 'Toque em uma segunda carta para encontrar uma correspondência.',
    memoryHow3: 'Continue combinando pares até que o tabuleiro seja resolvido.',
    memoryHow4: 'Tente terminar com menos movimentos a cada rodada.',
    memorySkill1: 'Memória de trabalho',
    memorySkill2: 'Atenção visual',
    memorySkill3: 'Reconhecimento de padrões',
    memoryBenefit1: 'Exercício cerebral diário rápido',
    memoryBenefit2: 'Jogabilidade familiar',
    memoryBenefit3: 'Nenhuma conta ou download necessário',
    memoryFaq1Q: 'Este jogo salva minha melhor pontuação?',
    memoryFaq1A: 'Sim, seu melhor número de movimentos é armazenado no localStorage neste dispositivo.',
    memoryFaq2Q: 'Crianças podem jogar este jogo?',
    memoryFaq2A: 'Sim, ele usa visuais simples e controles táteis.',
    numberPuzzleTitle: 'Quebra-cabeça numérico',
    numberPuzzleSubtitle: 'Deslize os blocos na ordem correta de 1 a 8.',
    seoNumberPuzzleTitle: 'Jogo de quebra-cabeça numérico | 3ToolsPro',
    seoNumberPuzzleDesc: 'Jogue gratuitamente um jogo de quebra-cabeça numérico 3x3 online. Melhore suas habilidades de resolução de problemas e lógica, acompanhe seus melhores movimentos e aproveite um desafio rápido no navegador.',
    numberPuzzleSolved: 'Ótimo trabalho! Quebra-cabeça resolvido em {moves} movimentos.',
    numberPuzzleWhatIs: 'O quebra-cabeça numérico é um jogo de lógica clássico onde você desliza blocos numerados para restaurar a ordem correta.',
    numberPuzzleHow1: 'Toque em um bloco ao lado do espaço vazio.',
    numberPuzzleHow2: 'Continue movendo os blocos um de cada vez.',
    numberPuzzleHow3: 'Organize os números de 1 a 8 em ordem.',
    numberPuzzleHow4: 'Repita e melhore sua melhor pontuação.',
    numberPuzzleSkill1: 'Resolução de problemas',
    numberPuzzleSkill2: 'Planejamento antecipado',
    numberPuzzleSkill3: 'Raciocínio espacial',
    numberPuzzleBenefit1: 'Exercício cerebral rápido',
    numberPuzzleBenefit2: 'Melhora a paciência e o foco',
    numberPuzzleBenefit3: 'Funciona perfeitamente em dispositivos móveis e desktop',
    numberPuzzleFaq1Q: 'Este jogo requer internet?',
    numberPuzzleFaq1A: 'Não. Uma vez carregado, o jogo é totalmente do lado do cliente.',
    numberPuzzleFaq2Q: 'A melhor pontuação é salva?',
    numberPuzzleFaq2A: 'Sim, seu melhor número de movimentos é salvo no localStorage.',
    reactionTestTitle: 'Teste de reação rápida',
    reactionTestSubtitle: 'Meça sua velocidade de reflexo e mantenha sua melhor pontuação.',
    seoReactionTestTitle: 'Teste de reação rápida | 3ToolsPro',
    seoReactionTestDesc: 'Teste sua velocidade de reação online gratuitamente. Acompanhe sua melhor pontuação de reflexo e melhore o foco com um jogo de navegador leve.',
    reactionWhatIs: 'O teste de reação rápida é um jogo de reflexo simples que mede a rapidez com que você reage a um sinal visual.',
    reactionHow1: 'Pressione Iniciar para armar o teste.',
    reactionHow2: 'Aguarde até o painel ficar verde.',
    reactionHow3: 'Toque imediatamente quando "pronto" aparecer.',
    reactionHow4: 'Repita e melhore seu melhor tempo.',
    reactionSkill1: 'Velocidade de reflexo',
    reactionSkill2: 'Foco visual',
    reactionSkill3: 'Controle de resposta',
    reactionBenefit1: 'Desafio diário rápido',
    reactionBenefit2: 'Ótimo para todas as idades',
    reactionBenefit3: 'Sem registro ou instalação',
    reactionFaq1Q: 'Qual é um bom tempo de reação?',
    reactionFaq1A: 'Para muitas pessoas, 200–300 ms é um bom resultado.',
    reactionFaq2Q: 'Posso usar isso no celular?',
    reactionFaq2A: 'Sim, o jogo é otimizado para toques em dispositivos móveis.',
    gameMoves: 'Movimentos',
    gameRestart: 'Reiniciar',
    selectLanguage: 'Selecionar idioma',
    more: 'Mais',
    resources: 'Recursos',

    // Home Page
    heroTitle: 'Ferramentas online gratuitas para acelerar seu trabalho',
    heroSubtitle: 'Ferramentas profissionais para tarefas diárias. Rápidas, seguras e sem registro.',
    startUsing: 'Começar',
    ourTools: 'Nossas Ferramentas',
    ourToolsSubtitle: 'Todas as ferramentas são 100% gratuitas, funcionam instantaneamente e não requerem registro.',
    allFree: '100% Grátis',
    instantResults: 'Resultados instantâneos',
    noSignup: 'Sem registro',
    freeAIChat: 'Chat IA Grátis',

    // Shared UI
    adLabel: 'Anúncio',
    adAreaAriaLabel: 'Área de conteúdo patrocinado',
    adPlaceholderLabel: 'Posicionamento do Google AdSense',
    adPlaceholderBetweenSections: 'Posicionamento de anúncio no conteúdo',
    visitSite: 'Visitar site',
    noSitesFound: 'Nenhum site encontrado',
    selectDifferentRegion: 'Tente selecionar uma região diferente',
    aiServiceUnavailable: 'Serviço temporariamente indisponível',
    aiUnexpectedError: 'Algo deu errado. Por favor, tente novamente.',

    // Home Card Descriptions
    aiChatDesc: 'Converse grátis com IA - Uso limitado',
    aiToolsDesc: 'Descubra as melhores ferramentas IA',
    footballDesc: 'Últimas notícias de futebol do mundo',
    programmingDesc: 'Recursos para desenvolvedores',
    gamingDesc: 'Melhores plataformas de jogos',

    // Tools Page
    toolsPageTitle: 'Ferramentas online gratuitas',
    toolsPageSubtitle: 'Ferramentas profissionais para tarefas diárias. Rápidas, seguras e sem registro.',

    // Tool Categories
    categoryAll: 'Todas',
    categoryTextContent: 'Texto e Conteúdo',
    categoryDeveloper: 'Desenvolvedor',
    categoryUtility: 'Utilidade',

    // Tool Names
    toolWordCounter: 'Contador de palavras',
    toolTextCaseConverter: 'Conversor de maiúsculas',
    toolTextCompare: 'Comparador de texto',
    toolLoremIpsum: 'Gerador Lorem Ipsum',
    toolJSONFormatter: 'Formatador JSON',
    toolBase64Encoder: 'Codificador/Decodificador Base64',
    toolURLEncoder: 'Codificador/Decodificador URL',
    toolPasswordGenerator: 'Gerador de senhas',
    toolRandomNumber: 'Gerador de números aleatórios',
    toolAgeCalculator: 'Calculadora de idade',
    toolUnitConverter: 'Conversor de unidades',
    toolWheelOfFortune: 'Roda da Fortuna',
    toolWheelOfFortuneDesc: 'Gire uma roda personalizável para escolher uma comida ou item aleatório',

    // AI Chat Status
    connectionStatus: 'Status',
    aiStatusOnline: 'Online',
    aiStatusOffline: 'Modo offline',
    aiLocalModeNotice: 'O serviço de IA está indisponível no momento, então você está usando respostas offline.',
    openChatGPT: 'Abrir ChatGPT',
    aiLocalResponse1: 'Estou offline agora, mas ainda posso ajudar. Tente refinar sua pergunta ou peça um esboço rápido.',
    aiLocalResponse2: 'Aqui está uma sugestão rápida: divida a tarefa em etapas e comece pela parte mais importante.',
    aiLocalResponse3: 'Se você precisar de resultados detalhados, tente novamente mais tarde. Por enquanto, posso fornecer um breve resumo ou lista de verificação.',

    // Wheel of Fortune UI
    wheelTitle: 'Roda da Fortuna (Seletor de comida)',
    wheelSubtitle: 'Adicione opções, gire a roda e obtenha uma escolha aleatória instantaneamente.',
    wheelSpin: 'Girar a roda',
    wheelSpinning: 'Girando...',
    wheelResultLabel: 'Resultado selecionado',
    wheelResultPlaceholder: 'Adicione itens e gire para escolher',
    wheelManageTitle: 'Gerenciar seus itens',
    wheelManageSubtitle: 'Adicione comidas ou opções e mantenha-os salvos neste dispositivo.',
    wheelInputPlaceholder: 'Digite uma comida ou item',
    wheelAdd: 'Adicionar',
    wheelEmpty: 'Nenhum item ainda. Adicione pelo menos dois para girar.',
    wheelRemove: 'Remover',
    wheelReset: 'Redefinir lista',

    // Tool Content - Age Calculator
    toolAgeWhatTitle: 'O que é a calculadora de idade?',
    toolAgeWhatDesc: 'A calculadora de idade ajuda você a descobrir sua idade exata e marcos importantes a partir de uma data de nascimento.',
    toolAgeHowTitle: 'Como usar a calculadora de idade',
    toolAgeHow1: 'Selecione sua data de nascimento.',
    toolAgeHow2: 'Clique em calcular para ver os detalhes da sua idade.',
    toolAgeHow3: 'Revise totais como dias, meses e próximo aniversário.',
    toolAgeBenefitsTitle: 'Benefícios',
    toolAgeBenefit1: 'Obtenha detalhes precisos da idade instantaneamente.',
    toolAgeBenefit2: 'Veja totais úteis como dias e meses.',
    toolAgeBenefit3: 'Tudo funciona localmente para privacidade.',
    toolAgeFaqTitle: 'FAQ',
    toolAgeFaq1Q: 'O cálculo é preciso?',
    toolAgeFaq1A: 'Sim, ele usa a data e hora do seu dispositivo local para resultados precisos.',
    toolAgeFaq2Q: 'Minha data é armazenada em algum lugar?',
    toolAgeFaq2A: 'Não. Todos os cálculos acontecem no seu navegador.',

    // Tool Content - Base64
    toolBase64WhatTitle: 'O que é o codificador/decodificador Base64?',
    toolBase64WhatDesc: 'Esta ferramenta converte texto de e para Base64 para transferência e testes seguros.',
    toolBase64HowTitle: 'Como usar a ferramenta Base64',
    toolBase64How1: 'Escolha o modo codificar ou decodificar.',
    toolBase64How2: 'Cole seu texto ou string Base64.',
    toolBase64How3: 'Clique em processar e copie o resultado.',
    toolBase64BenefitsTitle: 'Benefícios',
    toolBase64Benefit1: 'Converta dados rapidamente sem uploads.',
    toolBase64Benefit2: 'Útil para desenvolvimento e depuração.',
    toolBase64Benefit3: 'Funciona completamente no seu navegador.',
    toolBase64FaqTitle: 'FAQ',
    toolBase64Faq1Q: 'Base64 é criptografia?',
    toolBase64Faq1A: 'Não, Base64 é um formato de codificação e pode ser facilmente revertido.',
    toolBase64Faq2Q: 'A ferramenta armazena meus dados?',
    toolBase64Faq2A: 'Não. Seus dados permanecem no seu dispositivo.',

    // Tool Content - JSON Formatter
    toolJsonWhatTitle: 'O que é o formatador JSON?',
    toolJsonWhatDesc: 'Formate, valide e minifique JSON com saída clara e erros instantâneos.',
    toolJsonHowTitle: 'Como usar o formatador JSON',
    toolJsonHow1: 'Cole JSON na caixa de entrada.',
    toolJsonHow2: 'Escolha formatar, minificar ou validar.',
    toolJsonHow3: 'Copie a saída quando estiver pronto.',
    toolJsonBenefitsTitle: 'Benefícios',
    toolJsonBenefit1: 'Melhore a legibilidade para depuração.',
    toolJsonBenefit2: 'Capture erros rapidamente com validação.',
    toolJsonBenefit3: 'Minifique JSON para uso em produção.',
    toolJsonFaqTitle: 'FAQ',
    toolJsonFaq1Q: 'Suporta arrays?',
    toolJsonFaq1A: 'Sim, arrays e objetos são suportados.',
    toolJsonFaq2Q: 'Meus dados são enviados para um servidor?',
    toolJsonFaq2A: 'Não, tudo funciona no seu navegador.',

    // Tool Content - Lorem Ipsum
    toolLoremWhatTitle: 'O que é o gerador Lorem Ipsum?',
    toolLoremWhatDesc: 'Gere texto de preenchimento para preencher layouts, maquetes e rascunhos de design.',
    toolLoremHowTitle: 'Como usar o gerador Lorem Ipsum',
    toolLoremHow1: 'Selecione parágrafos e palavras por parágrafo.',
    toolLoremHow2: 'Escolha se deseja começar com "Lorem".',
    toolLoremHow3: 'Clique em gerar e copie a saída.',
    toolLoremBenefitsTitle: 'Benefícios',
    toolLoremBenefit1: 'Crie preenchimento de layout realista rapidamente.',
    toolLoremBenefit2: 'Personalize o comprimento para qualquer projeto.',
    toolLoremBenefit3: 'Nenhum download ou registro necessário.',
    toolLoremFaqTitle: 'FAQ',
    toolLoremFaq1Q: 'Posso mudar o comprimento?',
    toolLoremFaq1A: 'Sim, você pode controlar os parágrafos e a contagem de palavras.',
    toolLoremFaq2Q: 'O texto é livre de direitos autorais?',
    toolLoremFaq2A: 'Sim, é texto de preenchimento padrão.',

    // Tool Content - Password Generator
    toolPasswordWhatTitle: 'O que é o gerador de senhas?',
    toolPasswordWhatDesc: 'Crie senhas fortes com opções personalizáveis de comprimento e caracteres.',
    toolPasswordHowTitle: 'Como usar o gerador de senhas',
    toolPasswordHow1: 'Ajuste as configurações de comprimento e caracteres.',
    toolPasswordHow2: 'Clique em gerar para criar uma senha.',
    toolPasswordHow3: 'Copie a senha para usar.',
    toolPasswordBenefitsTitle: 'Benefícios',
    toolPasswordBenefit1: 'Crie senhas seguras instantaneamente.',
    toolPasswordBenefit2: 'Personalize a força com base nas necessidades.',
    toolPasswordBenefit3: 'Gerado localmente para privacidade.',
    toolPasswordFaqTitle: 'FAQ',
    toolPasswordFaq1Q: 'As senhas são armazenadas?',
    toolPasswordFaq1A: 'Não, as senhas são geradas localmente e nunca são salvas.',
    toolPasswordFaq2Q: 'Qual deve ser o comprimento das senhas?',
    toolPasswordFaq2A: 'Recomendamos 12+ caracteres para segurança forte.',

    // Tool Content - Random Number
    toolRandomWhatTitle: 'O que é o gerador de números aleatórios?',
    toolRandomWhatDesc: 'Gere números aleatórios dentro de um intervalo personalizado para jogos, testes ou seleção.',
    toolRandomHowTitle: 'Como usar o gerador de números aleatórios',
    toolRandomHow1: 'Defina seu intervalo mínimo e máximo.',
    toolRandomHow2: 'Escolha quantos números gerar.',
    toolRandomHow3: 'Clique em gerar e copie os resultados.',
    toolRandomBenefitsTitle: 'Benefícios',
    toolRandomBenefit1: 'Escolhas aleatórias rápidas para qualquer tarefa.',
    toolRandomBenefit2: 'Suporte para resultados únicos ou duplicados.',
    toolRandomBenefit3: 'Funciona instantaneamente no seu navegador.',
    toolRandomFaqTitle: 'FAQ',
    toolRandomFaq1Q: 'Posso evitar duplicatas?',
    toolRandomFaq1A: 'Sim, desative duplicatas para obter números únicos.',
    toolRandomFaq2Q: 'Quantos números posso gerar?',
    toolRandomFaq2A: 'Até 100 números por execução.',

    // Tool Content - Text Case Converter
    toolCaseWhatTitle: 'O que é o conversor de maiúsculas?',
    toolCaseWhatDesc: 'Converta texto em diferentes maiúsculas para escrita, formatação e codificação.',
    toolCaseHowTitle: 'Como usar o conversor de maiúsculas',
    toolCaseHow1: 'Cole ou digite seu texto.',
    toolCaseHow2: 'Selecione a maiúscula que deseja aplicar.',
    toolCaseHow3: 'Copie o texto atualizado.',
    toolCaseBenefitsTitle: 'Benefícios',
    toolCaseBenefit1: 'Padronize instantaneamente a formatação de texto.',
    toolCaseBenefit2: 'Útil para títulos, cabeçalhos e código.',
    toolCaseBenefit3: 'Nenhum dado sai do seu navegador.',
    toolCaseFaqTitle: 'FAQ',
    toolCaseFaq1Q: 'Posso converter texto grande?',
    toolCaseFaq1A: 'Sim, grandes blocos de texto são suportados.',
    toolCaseFaq2Q: 'Ele mantém a pontuação?',
    toolCaseFaq2A: 'Sim, a pontuação permanece inalterada.',

    // Tool Content - Text Compare
    toolCompareWhatTitle: 'O que é a ferramenta de comparação de texto?',
    toolCompareWhatDesc: 'Compare dois textos linha por linha para encontrar alterações, adições e exclusões.',
    toolCompareHowTitle: 'Como usar a ferramenta de comparação de texto',
    toolCompareHow1: 'Cole o texto original na primeira caixa.',
    toolCompareHow2: 'Cole o texto modificado na segunda caixa.',
    toolCompareHow3: 'Clique em comparar para ver as diferenças.',
    toolCompareBenefitsTitle: 'Benefícios',
    toolCompareBenefit1: 'Identifique mudanças rapidamente durante revisões.',
    toolCompareBenefit2: 'Destaques claros para edições e atualizações.',
    toolCompareBenefit3: 'Ideal para escritores e desenvolvedores.',
    toolCompareFaqTitle: 'FAQ',
    toolCompareFaq1Q: 'Compara linha por linha?',
    toolCompareFaq1A: 'Sim, compara texto linha por linha.',
    toolCompareFaq2Q: 'Meu texto é armazenado?',
    toolCompareFaq2A: 'Não, as comparações são executadas localmente.',

    // Tool Content - URL Encoder
    toolUrlWhatTitle: 'O que é o codificador/decodificador URL?',
    toolUrlWhatDesc: 'Codifique ou decodifique URLs para lidar com segurança com caracteres especiais em links da web.',
    toolUrlHowTitle: 'Como usar o codificador URL',
    toolUrlHow1: 'Selecione o modo codificar ou decodificar.',
    toolUrlHow2: 'Cole sua URL ou texto.',
    toolUrlHow3: 'Clique em processar e copie o resultado.',
    toolUrlBenefitsTitle: 'Benefícios',
    toolUrlBenefit1: 'Evite links quebrados em formulários da web.',
    toolUrlBenefit2: 'Ótimo para APIs e strings de consulta.',
    toolUrlBenefit3: 'Processamento rápido baseado no navegador.',
    toolUrlFaqTitle: 'FAQ',
    toolUrlFaq1Q: 'Quais caracteres são codificados?',
    toolUrlFaq1A: 'Espaços e caracteres especiais são convertidos em códigos seguros.',
    toolUrlFaq2Q: 'Suporta URLs completas?',
    toolUrlFaq2A: 'Sim, funciona com URLs completas e strings de consulta.',

    // Tool Content - Unit Converter
    toolUnitWhatTitle: 'O que é o conversor de unidades?',
    toolUnitWhatDesc: 'Converta entre unidades comuns de comprimento, peso, temperatura, volume e tempo.',
    toolUnitHowTitle: 'Como usar o conversor de unidades',
    toolUnitHow1: 'Escolha uma categoria como comprimento ou temperatura.',
    toolUnitHow2: 'Selecione as unidades para converter.',
    toolUnitHow3: 'Insira um valor para ver os resultados instantaneamente.',
    toolUnitBenefitsTitle: 'Benefícios',
    toolUnitBenefit1: 'Conversões precisas em segundos.',
    toolUnitBenefit2: 'Suporta múltiplas categorias.',
    toolUnitBenefit3: 'Fácil de usar em qualquer dispositivo.',
    toolUnitFaqTitle: 'FAQ',
    toolUnitFaq1Q: 'Quais unidades são suportadas?',
    toolUnitFaq1A: 'Comprimento, peso, temperatura, volume e tempo.',
    toolUnitFaq2Q: 'A conversão é precisa?',
    toolUnitFaq2A: 'Sim, fatores de conversão padrão são usados.',

    // Tool Content - Wheel of Fortune
    wheelWhatTitle: 'O que é a ferramenta Roda da Fortuna?',
    wheelWhatDesc: 'Um seletor interativo divertido que ajuda você a decidir girando uma roda personalizável.',
    wheelHowTitle: 'Como usar a Roda da Fortuna',
    wheelHow1: 'Adicione comidas ou itens à sua lista.',
    wheelHow2: 'Clique em girar para animar a roda.',
    wheelHow3: 'Veja o resultado selecionado instantaneamente.',
    wheelBenefitsTitle: 'Benefícios',
    wheelBenefit1: 'Ótimo para decisões rápidas e escolhas em grupo.',
    wheelBenefit2: 'Os itens são salvos localmente no seu dispositivo.',
    wheelBenefit3: 'Funciona perfeitamente em dispositivos móveis e desktop.',
    wheelFaqTitle: 'FAQ',
    wheelFaq1Q: 'Meus itens são salvos?',
    wheelFaq1A: 'Sim, os itens são armazenados no localStorage no seu dispositivo.',
    wheelFaq2Q: 'Posso redefinir a lista?',
    wheelFaq2A: 'Sim, use o botão redefinir para limpar todos os itens.',

    // Tools Features
    featureFast: 'Ultra rápido',
    featureFastDesc: 'Todas as ferramentas rodam no seu navegador',
    featureSecure: '100% Seguro',
    featureSecureDesc: 'Seus dados nunca saem do seu dispositivo',
    featureFree: 'Totalmente grátis',
    featureFreeDesc: 'Sem registro, sem limites, sem custos ocultos',

    // AI Chat
    freeAIChatTitle: 'Chat IA Grátis',
    freeAIChatSubtitle: 'Converse com o assistente IA',
    fairUsagePolicy: 'Chat IA Grátis – Política de uso justo',
    disclaimer: 'Aviso',
    aiDisclaimer: 'Este é um chat IA gratuito. As respostas são geradas por IA e podem não ser sempre precisas. Para chat profissional ilimitado, experimente ChatGPT, Claude ou Gemini.',
    startConversation: 'Comece uma conversa! Pergunte-me qualquer coisa.',
    exampleQuestions: 'Tente: "Conte-me uma piada" ou "O que é IA?"',
    aiThinking: 'IA pensando...',
    typePlaceholder: 'Digite sua mensagem...',
    sendMessage: 'Enviar',
    pressEnter: 'Pressione Enter',
    freeServiceNotice: 'Serviço gratuito com limites de uso',
    aboutFreeAIChat: 'Sobre o Chat IA',
    poweredByHF: 'Powered by Hugging Face - IA gratuita e open-source',
    refreshToReset: 'Atualize para nova conversa',
    responsesDelay: 'Respostas em 3-5 segundos',
    engagementOnly: 'Este chat é para aprendizado',
    unlimitedAI: 'Para chat ilimitado: ChatGPT, Claude ou Gemini',
    aiNoResponse: 'Desculpe, não consegui gerar resposta.',
    aiFallbackMessage: 'Problemas de conexão. Tente novamente ou atualize.',

    // AI Tools Page
    aiToolsTitle: 'Diretório de ferramentas IA',
    aiToolsSubtitle: 'Descubra as melhores ferramentas IA',
    searchPlaceholder: 'O que você quer fazer?',
    allCategories: 'Todas as categorias',
    visitTool: 'Visitar',
    free: 'Grátis',
    foundToolsFor: 'Encontradas {count} ferramentas para "{query}"',
    noAIToolsFound: 'Nenhuma ferramenta IA encontrada',
    adjustSearchFilter: 'Tente ajustar sua busca ou filtro',

    // Football
    footballTitle: 'Sites de notícias de futebol',
    footballSubtitle: 'Últimas notícias de futebol do mundo',

    // Programming
    programmingTitle: 'Recursos de programação',
    programmingSubtitle: 'Aprenda e cresça como desenvolvedor',

    // Gaming
    gamingTitle: 'Sites de jogos',
    gamingSubtitle: 'Melhores plataformas de jogos',

    // SEO
    seoHomeTitle: '3ToolsPro - Ferramentas online grátis para o dia a dia',
    seoHomeDesc: 'Acesse ferramentas gratuitas de texto, desenvolvimento e utilidades. Rápidas, seguras e pensadas para resultados profissionais.',
    seoToolsTitle: 'Biblioteca de ferramentas online grátis | 3ToolsPro',
    seoToolsDesc: 'Explore uma coleção de ferramentas gratuitas para produtividade, texto, desenvolvimento e utilidades.',
    seoAiChatTitle: 'Chat IA grátis com uso justo | 3ToolsPro',
    seoAiChatDesc: 'Converse com um assistente de IA gratuito para respostas rápidas e ideias. Há limites de uso justo.',
    seoAiToolsTitle: 'Diretório de ferramentas de IA | 3ToolsPro',
    seoAiToolsDesc: 'Explore ferramentas de IA verificadas para escrita, imagem, vídeo e produtividade.',
    seoFootballTitle: 'Fontes de notícias de futebol | 3ToolsPro',
    seoFootballDesc: 'Encontre sites confiáveis de notícias de futebol no mundo todo.',
    seoProgrammingTitle: 'Recursos de programação | 3ToolsPro',
    seoProgrammingDesc: 'Recursos, documentação, ferramentas e links de aprendizado para desenvolvedores.',
    seoGamingTitle: 'Recursos de jogos | 3ToolsPro',
    seoGamingDesc: 'Veja plataformas, downloads, notícias e comunidades de jogos em um só lugar.',
    seoAboutTitle: 'Sobre a 3ToolsPro',
    seoAboutDesc: 'Conheça a 3ToolsPro, nossa missão e como oferecemos ferramentas online gratuitas.',
    seoContactTitle: 'Contato 3ToolsPro',
    seoContactDesc: 'Fale com a equipe da 3ToolsPro para suporte, feedback ou parcerias.',
    seoHowToUseTitle: 'Como usar a 3ToolsPro',
    seoHowToUseDesc: 'Guia passo a passo para usar as ferramentas da 3ToolsPro com eficiência.',
    seoPrivacyTitle: 'Política de Privacidade | 3ToolsPro',
    seoPrivacyDesc: 'Saiba como a 3ToolsPro lida com dados, privacidade e segurança.',
    seoTermsTitle: 'Termos de Serviço | 3ToolsPro',
    seoTermsDesc: 'Confira os termos de serviço da 3ToolsPro e suas ferramentas gratuitas.',
    seoWordCounterTitle: 'Contador de palavras | 3ToolsPro',
    seoWordCounterDesc: 'Conte palavras, caracteres, frases e parágrafos instantaneamente. Perfeito para escritores, estudantes e verificações de SEO com análise privada no navegador.',
    seoTextCaseTitle: 'Conversor de maiúsculas | 3ToolsPro',
    seoTextCaseDesc: 'Converta texto para maiúsculas, minúsculas, título, frase e mais. Formatação rápida e precisa para tarefas de escrita e codificação.',
    seoTextCompareTitle: 'Ferramenta de comparação de texto | 3ToolsPro',
    seoTextCompareDesc: 'Compare dois textos linha por linha para encontrar adições, exclusões e alterações. Ideal para edição, revisões e verificações de conteúdo.',
    seoLoremIpsumTitle: 'Gerador Lorem Ipsum | 3ToolsPro',
    seoLoremIpsumDesc: 'Gere texto de preenchimento Lorem Ipsum personalizável por parágrafos ou palavras. Útil para maquetes, layouts e rascunhos de design.',
    seoJsonFormatterTitle: 'Formatador JSON | 3ToolsPro',
    seoJsonFormatterDesc: 'Formate, valide e minifique JSON com saída legível e erros instantâneos. Perfeito para desenvolvedores e limpeza de dados.',
    seoBase64Title: 'Codificador/Decodificador Base64 | 3ToolsPro',
    seoBase64Desc: 'Codifique ou decodifique strings Base64 com segurança no seu navegador. Ótimo para transferência de dados, testes e fluxos de desenvolvimento.',
    seoUrlEncoderTitle: 'Codificador/Decodificador URL | 3ToolsPro',
    seoUrlEncoderDesc: 'Codifique ou decodifique URLs para lidar corretamente com espaços e caracteres especiais. Útil para formulários web, APIs e depuração.',
    seoPasswordGeneratorTitle: 'Gerador de senhas | 3ToolsPro',
    seoPasswordGeneratorDesc: 'Crie senhas fortes e seguras com opções personalizáveis de comprimento e caracteres. Gerado localmente para privacidade.',
    seoRandomNumberTitle: 'Gerador de números aleatórios | 3ToolsPro',
    seoRandomNumberDesc: 'Gere números aleatórios dentro de um intervalo, com resultados únicos opcionais. Útil para jogos, testes e escolhas rápidas.',
    seoAgeCalculatorTitle: 'Calculadora de idade | 3ToolsPro',
    seoAgeCalculatorDesc: 'Calcule sua idade exata com estatísticas detalhadas, incluindo meses, dias e próximo aniversário. Rápido e privado.',
    seoUnitConverterTitle: 'Conversor de unidades | 3ToolsPro',
    seoUnitConverterDesc: 'Converta unidades de comprimento, peso, temperatura, volume e tempo instantaneamente com resultados precisos e uma interface fácil.',
    seoWheelTitle: 'Seletor da Roda da Fortuna | 3ToolsPro',
    seoWheelDesc: 'Gire uma roda personalizável para escolher comida ou qualquer item. Salve sua lista localmente e obtenha resultados instantâneos em qualquer dispositivo.',

    // Footer
    footerTagline: 'Ferramentas gratuitas profissionais para todos',
    footerCopyright: '© 2025 3ToolsPro. Todos os direitos reservados.',
    quickLinks: 'Links rápidos',
    legalInfo: 'Legal e Info',

    // Common
    copy: 'Copiar',
    copied: 'Copiado!',
    clear: 'Limpar',
    generate: 'Gerar',
    encode: 'Codificar',
    decode: 'Decodificar',
    format: 'Formatar',
    validate: 'Validar',
    compare: 'Comparar',
    calculate: 'Calcular',
    owner: 'Proprietário',
    email: 'E-mail',
    supportEmail: 'E-mail de suporte',

    // About Page
    aboutUs: 'Sobre nós',
    aboutSubtitle: 'Conheça 3ToolsPro e nossa missão',
    ourMission: 'Nossa missão',
    missionText: '3ToolsPro foi criado para fornecer ferramentas gratuitas de alta qualidade. Acreditamos que ferramentas de produtividade devem ser acessíveis a todos.',
    missionText2: 'Nossa plataforma oferece uma coleção de ferramentas gratuitas. Todas funcionam no seu navegador, garantindo privacidade.',
    whatWeOffer: 'O que oferecemos',
    offer1: 'Ferramentas de texto: Contador de palavras, conversor',
    offer2: 'Ferramentas de conversão: JSON, Base64, URL',
    offer3: 'Ferramentas de segurança: Gerador de senhas',
    offer4: 'Chat IA para respostas rápidas',
    offer5: 'Diretório das melhores ferramentas IA',
    contactInfo: 'Informações de contato',

    // Contact Page
    contactUs: 'Contato',
    contactSubtitle: 'Entre em contato - adoraríamos ouvir de você',
    socialMedia: 'Redes sociais',
    needHelp: 'Precisa de ajuda?',
    contactText: 'Se tiver perguntas, entre em contato. Respondemos em 24-48 horas.',

    // Privacy Policy
    privacyPolicy: 'Política de Privacidade',
    lastUpdated: 'Última atualização',
    introduction: 'Introdução',
    privacyIntro: 'Na 3ToolsPro, levamos sua privacidade a sério. Esta política explica como coletamos e protegemos suas informações.',
    dataCollection: 'Informações coletadas',
    dataCollectionText: 'Coletamos informações mínimas:',
    dataItem1: 'Dados de uso: Páginas visitadas (via Google Analytics)',
    dataItem2: 'Informações do dispositivo: Tipo de navegador, SO',
    dataItem3: 'Endereço IP: Para segurança (anonimizado)',
    howWeUseData: 'Uso das informações',
    useItem1: 'Fornecer e manter nossas ferramentas',
    useItem2: 'Analisar uso e melhorar experiência',
    useItem3: 'Exibir anúncios via Google AdSense',
    cookies: 'Cookies',
    cookiesText: 'Usamos cookies para melhorar sua experiência e lembrar suas preferências.',
    thirdParty: 'Serviços de terceiros',
    thirdPartyText: 'Usamos os seguintes serviços de terceiros:',
    dataSecurity: 'Segurança de dados',
    dataSecurityText: 'Todas as ferramentas rodam no seu navegador. Seus dados não são enviados aos nossos servidores.',
    yourRights: 'Seus direitos',
    right1: 'Acesso: Solicitar dados coletados',
    right2: 'Exclusão: Solicitar exclusão',
    right3: 'Opt-out: Desativar rastreamento',
    privacyContactText: 'Perguntas sobre privacidade? Contate-nos:',

    // Terms of Service
    termsOfService: 'Termos de Serviço',
    acceptanceOfTerms: 'Aceitação dos termos',
    acceptanceText: 'Ao usar 3ToolsPro, você aceita estes termos. Se não concordar, não use nossos serviços.',
    useOfService: 'Uso do serviço',
    useOfServiceText: 'Nossas ferramentas são gratuitas para uso pessoal e comercial:',
    serviceRule1: 'Use nossas ferramentas para qualquer propósito legal',
    serviceRule2: 'Não tente copiar nossas ferramentas',
    serviceRule3: 'Não use nossos serviços para atividades ilegais',
    serviceRule4: 'Não sobrecarregue nossos serviços',
    intellectualProperty: 'Propriedade intelectual',
    intellectualPropertyText: 'Todo conteúdo é protegido por leis de propriedade intelectual.',
    userContent: 'Conteúdo do usuário',
    userContentText: 'Seus dados são processados localmente e não armazenados em nossos servidores.',
    disclaimerText: 'Nossas ferramentas são fornecidas "como estão" sem garantia.',
    disclaimerWarning: 'USE POR SUA CONTA E RISCO. Não somos responsáveis por perda de dados.',
    limitationOfLiability: 'Limitação de responsabilidade',
    limitationText: 'Não seremos responsáveis por danos indiretos.',
    modifications: 'Modificações',
    modificationsText: 'Podemos modificar estes termos a qualquer momento.',
    governingLaw: 'Lei aplicável',
    governingLawText: 'Estes termos são regidos pelas leis do Egito.',
    termsContactText: 'Perguntas sobre os termos? Contate-nos:',

    // How To Use Page
    howToUse: 'Como usar',
    howToUseSubtitle: 'Comece com 3ToolsPro - fácil e grátis!',
    step1Title: 'Passo 1: Escolha sua ferramenta',
    step1Text: 'Navegue por nossas ferramentas gratuitas:',
    step1Item1: 'Ferramentas de texto: Contador de palavras, conversor',
    step1Item2: 'Ferramentas de dados: JSON, Base64, URL',
    step1Item3: 'Utilitários: Senhas, idade, unidades',
    step2Title: 'Passo 2: Use a ferramenta',
    step2Text: 'Cada ferramenta é simples:',
    step2Item1: 'Insira seus dados',
    step2Item2: 'Clique no botão de ação',
    step2Item3: 'Resultados instantâneos!',
    step3Title: 'Passo 3: Copie seus resultados',
    step3Text: 'Após terminar:',
    step3Item1: 'Clique em "Copiar"',
    step3Item2: 'Download se disponível',
    step3Item3: 'Limpe e recomece',
    step4Title: 'Passo 4: Explore',
    step4Text: 'Confira nosso diretório IA, recursos de futebol, programação e jogos. Experimente o chat IA grátis!',
    helpText: 'Precisa de ajuda ou sugestões? Contate-nos:',
    toolWordCounterDesc: "Conte palavras e caracteres instantaneamente.",
toolJSONFormatterDesc: "Formate, valide e embeleze dados JSON.",
toolPasswordGeneratorDesc: "Gere senhas aleatórias seguras.",
toolBase64EncoderDesc: "Codifique e decodifique strings Base64 facilmente.",
toolAgeCalculatorDesc: "Calcule a idade a partir da data de nascimento instantaneamente.",
toolTextCaseConverterDesc: "Converta texto para diferentes formatos de letras maiúsculas e minúsculas.",


    wordCounterPage: {
      title: 'Contador de Palavras',
      subtitle: 'Conte palavras, caracteres, frases, parágrafos e o tempo de leitura instantaneamente',
      whyTitle: 'Por que usar este contador de palavras?',
      why1: 'Verificar o tamanho de artigos para otimização de SEO',
      why2: 'Contar caracteres para limites de redes sociais',
      why3: 'Melhorar a produtividade e a precisão da escrita',
      why4: 'Estimar automaticamente o tempo de leitura',
      why5: 'Analisar o texto instantaneamente sem enviar arquivos',
      howTitle: 'Como usar a ferramenta Contador de Palavras:',
      how1: 'Digite ou cole seu texto na caixa acima',
      how2: 'As estatísticas são atualizadas automaticamente enquanto você digita',
      how3: 'O tempo de leitura é calculado com base em 200 palavras por minuto',
      how4: 'Todo o processamento acontece no seu navegador — seu texto não é armazenado',
      faq: 'Perguntas Frequentes',
      faq1q: 'Este contador de palavras é gratuito?',
      faq1a: 'Sim, esta ferramenta é totalmente gratuita com uso ilimitado.',
      faq2q: 'Meu texto é salvo?',
      faq2a: 'Não. Todo o processamento acontece localmente no seu navegador.',
      faq3q: 'Quem pode usar esta ferramenta?',
      faq3a: 'Escritores, estudantes, profissionais de marketing, desenvolvedores e qualquer pessoa que trabalhe com texto.'
    },
    seo: {
      wordCounterTitle: 'Contador de Palavras Gratuito - Conte palavras e caracteres online',
      wordCounterDesc: 'Ferramenta online gratuita para contar palavras, caracteres, frases e tempo de leitura instantaneamente.'
    }
  }
};


const buildTranslations = (source, autofill = {}) => {
  const languages = Object.keys(source);
  const english = { ...(source.en || {}), ...(autofill.en || {}) };

  return Object.fromEntries(
    languages.map((lang) => {
      const localeValues = { ...(source[lang] || {}), ...(autofill[lang] || {}) };
      return [lang, lang === 'en' ? english : { ...english, ...localeValues }];
    })
  );
};

export const translations = buildTranslations(rawTranslations, translationAutofill);
